import Z from "axios";
import { FetchFirmLicenseDocument as pe, UpdateFirmLicenseDocument as de, TodoFeedsDocument as le, WorkflowRequestsCountDocument as ye, RpaDocumentFragmentDoc as fe, WorkflowRequestSectionFragmentDoc as Ae, WorkflowRequestFragmentDoc as ge, WorkflowResponseItem2FragmentDoc as he, WorkflowRequestItem2FragmentDoc as Fe, WorkflowItemCondition2FragmentDoc as qe, WorkflowItemInterface2FragmentDoc as _e, WorkflowRequestItemFragmentDoc as Ve, WorkflowItem2FragmentDoc as Re, DefaultWorkflowItem2FragmentDoc as Ke, WorkflowSectionFragmentDoc as Te, WorkflowSignableDocumentItem2FragmentDoc as ve, WorkflowResponseItemFragmentDoc as Ie, UpdateResponseItemBoolDocument as we, UpdateWorkflowRequestDocument as Oe, UpdateResponseItemDocUploadDocument as ke, UpdateResponseItemTextDocument as Se, WorkflowRequestDocument as De, WorkflowRequestsQueryDocument as Pe, WorkflowTemplateFragmentDoc as Ce, ReadyToSendDocument as Ee, CreateWorkflowsFromWorkflowTemplateDocumentDocument as Ge, WorkflowTemplatesDocument as be, DeleteWorkflowTemplateDocument as xe, UpdateWorkflowDocument as Ue, WorkflowsDocument as $e } from "./index-graphql.js";
import { useQuery as c, useMutation as u } from "@tanstack/react-query";
let J;
const Me = new Uint8Array(16);
function Ne() {
  if (!J && (J = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !J))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return J(Me);
}
const U = [];
for (let t = 0; t < 256; ++t)
  U.push((t + 256).toString(16).slice(1));
function We(t, e = 0) {
  return U[t[e + 0]] + U[t[e + 1]] + U[t[e + 2]] + U[t[e + 3]] + "-" + U[t[e + 4]] + U[t[e + 5]] + "-" + U[t[e + 6]] + U[t[e + 7]] + "-" + U[t[e + 8]] + U[t[e + 9]] + "-" + U[t[e + 10]] + U[t[e + 11]] + U[t[e + 12]] + U[t[e + 13]] + U[t[e + 14]] + U[t[e + 15]];
}
const Le = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ut = {
  randomUUID: Le
};
function Qe(t, e, n) {
  if (ut.randomUUID && !e && !t)
    return ut.randomUUID();
  t = t || {};
  const s = t.random || (t.rng || Ne)();
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, We(s);
}
function Be(t) {
  return Z.create({
    baseURL: t,
    headers: {
      post: {
        "Content-Type": "application/json"
      }
    }
  });
}
function je(t) {
  async function e({
    recordType: F,
    recordId: q,
    fieldName: D
  }) {
    const W = await t.get(
      `/api/v5/encrypted_fields/${F}/${q}/${D}`
    );
    return W == null ? void 0 : W.data;
  }
  async function n({
    recordType: F,
    recordId: q,
    fieldName: D,
    newValue: W
  }) {
    return await t.patch(
      `/api/v5/encrypted_fields/${F}/${q}/${D}`,
      { enc_value: W }
    );
  }
  async function s() {
    const { data: F } = await t.get(
      "/api/v3/get_accounts_of_contact_on_the_basis_of_user_id/"
    );
    return F;
  }
  async function i(F) {
    const { data: q } = await t.get(
      `/api/v3/get_accounts_of_contact/${F}`
    );
    return q;
  }
  async function o() {
    const {
      data: { accounts: F }
    } = await t.get(
      "/api/v3/get_initial_task_data"
    );
    return Array.isArray(F) ? F : [];
  }
  const a = ({
    page: F
  }) => `/api/v3/accounts?per_page=15&${[`page=${F}`].join("&")}`;
  async function d({
    pageParam: F = 1
  }) {
    const q = a({ page: F }), { data: D } = await t.get(q), W = (D == null ? void 0 : D.new_data) || [], me = (D == null ? void 0 : D.count_data) || {
      all: 0,
      prospects: 0,
      clients: 0
    };
    return { accounts: W, count_data: me };
  }
  async function y({
    queryKey: [F, q]
  }) {
    const {
      data: { data: D }
    } = await t.get(
      `/api/v3/accounts/${q}`
    );
    return D;
  }
  const A = async (F) => {
    const q = await t.put(
      `/api/v3/accounts/${F.id}`,
      F
    );
    if (!q.data.success || q.data.status !== 200)
      throw q.data;
    return q.data;
  };
  async function v({
    queryKey: [F, q]
  }) {
    const { data: D } = await t.get(
      `/api/v3/bank_accounts/${q}`
    );
    return (D == null ? void 0 : D.data) || [];
  }
  async function I({
    queryKey: [F, q]
  }) {
    const { data: D } = await t.get(
      `/api/v3/account_logins/${q}`
    );
    return D.data || [];
  }
  async function V({
    queryKey: [F, q]
  }) {
    const { data: D } = await t.get(
      `/api/v3/security_questions/${q}`
    );
    return D.data || [];
  }
  async function P({
    queryKey: [F, q]
  }) {
    const { data: D } = await t.get(
      `/api/v3/account_logins/${q}`
    );
    return D.data || [];
  }
  async function h({
    queryKey: [F, q]
  }) {
    const { data: D } = await t.get(
      `/api/v3/get_task_account_search/?keyword=${q}&message=true      `
    );
    return Array.isArray(D) ? D : [];
  }
  async function _({
    id: F,
    ...q
  }) {
    const { data: D } = await t.put(
      `/api/v3/bank_accounts/${F}`,
      q
    );
    return D;
  }
  async function w({ id: F, ...q }) {
    const { data: D } = await t.put(
      `/api/v3/dependants/${F}`,
      q
    );
    return D;
  }
  async function f(F) {
    const { data: q } = await t.put(
      `/api/v3/security_questions/${F.id}`,
      {
        security_question: F
      }
    );
    return q;
  }
  async function R(F) {
    const { data: q } = await t.post(
      "/api/v3/bank_accounts",
      F
    );
    return q;
  }
  async function K(F) {
    const { data: q } = await t.post(
      "/api/v3/dependants",
      F
    );
    return q.dependant;
  }
  async function k({
    id: F,
    ...q
  }) {
    const { data: D } = await t.put(
      `/api/v3/account_logins/${F}`,
      {
        account_login: q
      }
    );
    return D;
  }
  async function E(F) {
    const { data: q } = await t.post(
      "/api/v3/account_logins",
      {
        account_login: F
      }
    );
    return q;
  }
  async function g(F) {
    const { data: q } = await t.post(
      "/api/v3/security_questions",
      {
        security_question: F
      }
    );
    return q;
  }
  async function m(F) {
    return await t.delete(`/api/v3/bank_accounts/${F}`);
  }
  async function l(F) {
    return await t.delete(`/api/v3/account_logins/${F}`);
  }
  async function S(F) {
    return await t.delete(
      `/api/v3/security_questions/${F}`
    );
  }
  async function O(F) {
    return await t.delete(`/api/v3/dependants/${F}`);
  }
  async function G(F) {
    const { data: q } = await t.post(
      "/api/v3/auto_generate_onboard_message",
      { account_id: F }
    );
    return q;
  }
  return {
    getAccountsOfContactOnTheBasisOfUserId: s,
    getAccountsOfContact: i,
    getAccountsAsTaskData: o,
    getContactAccounts: d,
    getAccountOverview: y,
    getAccountBankAccounts: v,
    getAccountLogins: I,
    getLoginSecurityQuestions: V,
    getAccountLoginDetail: P,
    searchAccounts: h,
    editBankAccount: _,
    editSecurityQuestion: f,
    createBankAccount: R,
    editAccountLogin: k,
    createAccountLogin: E,
    createSecurityQuestion: g,
    deleteBankAccount: m,
    deleteAccountLogin: l,
    deleteSecurityQuestion: S,
    sendAccountUpdateNotification: G,
    getInitialTaskAccounts: async () => {
      var q;
      return ((q = (await t.get(
        "/api/v3/get_initial_task_data"
      )).data) == null ? void 0 : q.accounts) || [];
    },
    searchTaskAccounts: async (F) => {
      const q = await t.get(
        "/api/v3/get_task_account_search",
        { params: F }
      );
      return Array.isArray(q.data) ? q.data : [];
    },
    searchToDoTaskAccounts: async (F) => {
      const q = { keyword: F };
      return (await t.get(
        "/api/v3/get_to_do_account_search",
        { params: q }
      )).data;
    },
    updateAccountDetails: A,
    editDependant: w,
    createDependant: K,
    deleteDependant: O,
    getEncryptedField: e,
    updateEncryptedField: n
  };
}
function ze(t) {
  async function e({
    queryKey: s = []
  }) {
    const [i, o] = s;
    try {
      const {
        data: { data: a }
      } = await t.get(
        `/api/v3/get_relationship_of_contact/${o}`
      );
      return a;
    } catch (a) {
      return console.error(a);
    }
  }
  return {
    getFirmContactAccounts: e,
    getFilteredAccounts: async ({
      pageParam: s = 1,
      queryKey: i
    }) => {
      const [o, a] = i, d = {
        employee_id: "",
        entity_type: [],
        field: "name",
        filter: null,
        is_restricted_account: !1,
        keyword: a,
        page: s,
        per_page: 15,
        sort_by: "asc",
        stage: [],
        status: []
      }, {
        data: { new_data: y, count_data: A }
      } = await t.post(
        "/api/v3/account_search_with_filter",
        d
      );
      return { accounts: y || [], count_data: A };
    }
  };
}
function He(t) {
  const e = ({ page: h, searchString: _ = "", sortOrder: w, sortField: f }) => {
    const R = [
      `page=${h}`,
      `sort_by=${w}`,
      `field=${f}`
    ];
    return _ && R.push(`keyword=${encodeURIComponent(_)}`), `/api/v3/contacts?per_page=15&${R.join("&")}`;
  };
  async function n({
    pageParam: h = 1,
    queryKey: _ = []
  }) {
    const [w, f, R, K] = _, k = e({
      page: h,
      sortOrder: R,
      sortField: K,
      searchString: f
    }), { data: E } = await t.get(k);
    return E;
  }
  async function s({
    queryKey: h = []
  }) {
    const [_, w] = h, { data: f } = await t.get(
      `/api/v3/contacts/${encodeURIComponent(w)}`
    );
    return f;
  }
  async function i({
    queryKey: [h, _]
  }) {
    const { data: w } = await t.get(
      `/api/v3/get_emp_and_contact_of_account/${_}`
    );
    return w.data;
  }
  async function o({
    queryKey: [h, _]
  }) {
    const { data: w } = await t.get(
      `/api/v3/get_rel_contacts_and_cst_of_accounts?account_id=${_}`
    );
    return w;
  }
  async function a() {
    const { data: h } = await t.post(
      "/api/v3/get_emp_and_contact",
      {
        limit: !0,
        message: !0
      }
    );
    return h;
  }
  const d = async (h) => {
    const { data: _ } = await t.get(
      `/api/v3/get_contacts_of_accounts/${h}`
    );
    return _.data;
  };
  async function y({
    queryKey: [h, _]
  }) {
    const { data: w } = await t.get(
      `/api/v3/get_task_contact_search/?keyword=${_}&message=false`
    );
    return w;
  }
  const A = async (h) => (await t.post(
    "/api/v3/get_emp_and_contact",
    {
      task_type_key: h,
      limit: !0
    }
  )).data, v = async (h, _, w) => {
    const f = {
      keyword: _
    };
    return w !== void 0 ? f.message = w : f.task_type_key = h, (await t.get(
      "/api/v3/get_task_contact_search",
      { params: f }
    )).data;
  }, I = async (h) => {
    const _ = { keyword: h };
    return (await t.get(
      "/api/v3/get_to_do_contact_search",
      { params: _ }
    )).data;
  };
  async function V(h) {
    var w, f, R, K;
    const _ = await t.post(
      "/api/v3/create_records",
      h
    );
    if ((w = _ == null ? void 0 : _.data) != null && w.contact_error_message || (f = _ == null ? void 0 : _.data) != null && f.account_error_message)
      throw new Error(
        `${(R = _ == null ? void 0 : _.data) == null ? void 0 : R.contact_error_message} ${(K = _ == null ? void 0 : _.data) == null ? void 0 : K.account_error_message}`
      );
    return _.data;
  }
  async function P({
    id: h,
    putBody: _
  }) {
    return (await t.put(
      `/api/v3/contacts/${h}`,
      _
    )).data;
  }
  return {
    getContacts: n,
    getContactDetails: s,
    getEmployeesAndContactsOfAccount: i,
    getRelContactsAndCstOfAccounts: o,
    getEmployeesAndContacts: a,
    searchContacts: y,
    createQuickContactAndOrAccount: V,
    updateContact: P,
    getAccountContacts: d,
    getInitialTaskContacts: A,
    searchTaskContacts: v,
    searchToDoTaskContacts: I
  };
}
function Je(t) {
  async function e(n) {
    const s = new URLSearchParams();
    n && s.append("keyword", n);
    const i = `/api/v5/clients/contacts${s.toString() ? `?${s.toString()}` : ""}`, { data: o } = await t.get(i);
    return o;
  }
  return {
    getClientsContacts: e
  };
}
function Ye(t) {
  async function e(a) {
    const d = new URLSearchParams();
    a && d.append("keyword", a);
    const y = `/api/v5/firms/contacts${d.toString() ? `?${d.toString()}` : ""}`, { data: A } = await t.get(y);
    return A;
  }
  async function n(a, d) {
    const { data: y } = await t.post(
      `/api/v5/firms/contacts/${a}/assign_account`,
      d
    );
    return y;
  }
  async function s() {
    const { data: a } = await t.get(
      "/api/v5/firms/contacts/accounts"
    );
    return a;
  }
  async function i(a) {
    const d = new URLSearchParams();
    a.forEach((v) => d.append("account_ids[]", String(v)));
    const y = `/api/v5/firms/contacts/for_accounts?${d.toString()}`, { data: A } = await t.get(y);
    return A;
  }
  async function o(a) {
    const d = new URLSearchParams();
    d.append("keyword", a);
    const y = `/api/v5/firms/contacts/search?${d.toString()}`, { data: A } = await t.get(y);
    return A;
  }
  return {
    getFirmsContacts: e,
    assignAccountToContact: n,
    getAccountsList: s,
    getContactsForAccounts: i,
    searchContacts: o
  };
}
const Ze = (t) => ({
  getCpaTheme: async (e) => ("custom_liscio_url" in e && (/^https:\/\//.test(e.custom_liscio_url) || (e.custom_liscio_url = `https://${e.custom_liscio_url}`)), (await t.get(
    "/api/v5/custom_themes",
    {
      params: e
    }
  )).data)
});
var N = /* @__PURE__ */ ((t) => (t.Task = "Task", t.Invoice = "Invoice", t.Message = "Message", t.NewFile = "NewFile", t.Workflow = "Document", t))(N || {}), Xe = /* @__PURE__ */ ((t) => (t.Task = "task", t.Invoice = "invoice", t.MessageThread = "message-thread", t.NewMessage = "new-message", t.Edit = "edit", t.NewFile = "new-file", t.Workflow = "document", t))(Xe || {}), tn = /* @__PURE__ */ ((t) => (t.Client = "client", t.Firm = "firm", t))(tn || {}), en = /* @__PURE__ */ ((t) => (t.Client = "clientuploads", t.Firm = "firmuploads", t.Private = "privatefile", t))(en || {});
const ct = ({
  contactId: t,
  contactIds: e,
  accountId: n,
  page: s = 1,
  sortBy: i,
  sortOrder: o,
  searchString: a,
  showArchived: d,
  source: y,
  fileUploadedBy: A,
  month: v,
  year: I,
  tags: V,
  perPage: P
}) => {
  const h = Number(s), w = [`page=${Math.max(
    1,
    Math.trunc(Number.isFinite(h) ? h : 1)
  )}`];
  if (i) {
    const f = i === "doc_name" ? "aws_url_file_name" : i;
    w.push(`field=${f}`);
  }
  if (o && w.push(`sort_by=${o}`), a && (w.push(`search=${a}`), w.push(`keyword=${a}`)), d && w.push("archive=true"), y && w.push(`source=${y}`), A && w.push(`file_uploaded_by=${A}`), Array.isArray(I) && I.forEach((f) => {
    f && w.push(`year[]=${f}`);
  }), Array.isArray(v) && v.forEach((f) => {
    f && w.push(`month[]=${f}`);
  }), Array.isArray(V)) {
    const f = V.join(",");
    f && w.push(`tags=${f}`);
  }
  return e != null && e.length ? w.push(`contact_id=${e.join(",")}`) : t && w.push(`contact_id=${t}`), n && w.push(`account_id=${n}`), P && w.push(`per_page=${P}`), w.join("&");
};
function mt({
  file: t,
  name: e,
  uploadType: n,
  taskId: s,
  is_draft: i = !0,
  is_private_to_firm: o,
  is_private_to_uploader: a,
  contact_id: d,
  account_id: y
}) {
  const A = new FormData();
  return A.append("aws_url", t, e), A.append("is_draft", String(i)), o !== void 0 && A.append("is_private_to_firm", String(o)), a !== void 0 && A.append("is_private_to_uploader", String(a)), d !== void 0 && A.append("contact_id", String(d)), y !== void 0 && A.append("account_id", String(y)), s && n === N.Task || n === N.Invoice ? A.append("task_id", s) : n === N.Message ? A.append("doc_type", n) : n === N.NewFile ? A.append("doc_type", "Manual") : n === N.Workflow && (A.set("is_draft", "false"), A.append("doc_type", "Request")), A;
}
function pt(t) {
  return `${t.name}-${t.lastModified}-${t.size}`;
}
function nn(t) {
  async function e(f) {
    const K = `/api/v3/liscio_vault_files?per_page=15&${ct(f)}`;
    try {
      const { data: k } = await t.get(K, {
        // TODO: DEV-3811 - Refactor this so we don't rely on using the App header anymore
        headers: { App: "mobile" }
      });
      return k;
    } catch (k) {
      return console.error(k);
    }
  }
  async function n(f, R) {
    const k = `/api/v3/documents_list_contact?${ct({
      ...R,
      contactId: f
    })}`;
    try {
      const { data: E } = await t.get(k, {
        // TODO: DEV-3811 - Refactor this so we don't rely on using the App header anymore
        headers: { App: "mobile" }
      });
      return E;
    } catch (E) {
      return console.error(E);
    }
  }
  const s = async (f, R = {}) => {
    const K = {
      ...R,
      account_id: f,
      tags: (R.tags || []).join(","),
      year: (R.year || []).join(",")
    };
    return K.archive !== !0 && delete K.archive, (await t.get(
      "/api/v3/documents_list",
      {
        // TODO: DEV-3811 - Refactor this so we don't rely on using the App header anymore
        headers: { App: "mobile" },
        // Needed to return response_hash
        params: K
      }
    )).data;
  };
  async function i({
    queryKey: f = []
  }) {
    const [R, K] = f;
    try {
      const {
        data: { data: k }
      } = await t.get(
        `/api/v3/get_document_details/${encodeURIComponent(K)}`
      );
      return k;
    } catch (k) {
      return console.error(k);
    }
  }
  async function o(f) {
    const R = { template_doc_ids: f, template_type: "task_type" }, { data: K } = await t.post(
      "/api/v3/create_doc_from_template_ids",
      R
    );
    return K;
  }
  async function a({
    documents: f,
    uploadType: R = N.Task,
    taskId: K,
    onUploadProgress: k,
    setCancelController: E
  }) {
    const g = [];
    let m = {};
    const l = {};
    for (const O of Array.from(f)) {
      const G = new AbortController();
      l[pt(O)] = G;
      const $ = O, M = mt({
        file: $,
        name: $.name,
        taskId: K,
        uploadType: R
      }), j = {
        headers: { "content-type": "multipart/form-data" },
        signal: G.signal
      };
      j.onUploadProgress = (F) => {
        if (k) {
          const q = typeof F.progress == "number" ? F.progress * 100 : 0;
          m = {
            ...m,
            [pt(O)]: q
          }, k(m);
        }
      }, g.push(t.post("/api/v3/documents", M, j));
    }
    return E && E(l), (await Promise.allSettled(g)).filter((O) => !O.reason).map((O) => O == null ? void 0 : O.value);
  }
  const d = async ({
    file: f,
    type: R = N.NewFile,
    signal: K,
    onUploadProgress: k,
    is_draft: E,
    is_private_to_firm: g,
    is_private_to_uploader: m,
    contact_id: l,
    account_id: S
  }) => {
    const O = mt({
      file: f,
      name: f.name,
      uploadType: R,
      doc_type: f.type,
      is_draft: E,
      is_private_to_firm: g,
      is_private_to_uploader: m,
      contact_id: l,
      account_id: S
    });
    return await t.post(
      "/api/v3/documents",
      O,
      {
        signal: K,
        onUploadProgress: k,
        headers: { "content-type": "multipart/form-data" }
      }
    );
  };
  async function y(f) {
    const { data: R } = await t.post("/api/v3/update_new_document", f);
    return R;
  }
  async function A(f, R) {
    const { data: K } = await t.post(
      "/api/v3/multiple_files_upload_for_sharing",
      {
        ...f,
        send_message: !0
      },
      R
    );
    return K;
  }
  async function v({
    doc_ids: f,
    recipients: R,
    send_message: K = !1,
    message: k = "",
    is_private_to_firm: E,
    tags: g,
    year: m,
    month: l
  }, S) {
    const { data: O } = await t.post(
      "/api/v3/multiple_files_upload_for_sharing",
      {
        doc_ids: f,
        recipients: R,
        send_message: K,
        message: k,
        ...E != null ? { is_private_to_firm: E } : {},
        ...g ? { tags: g } : {},
        ...m ? { year: m } : {},
        ...l ? { month: l } : {}
      },
      S
    );
    return O;
  }
  async function I(f) {
    const { data: R } = await t.put("/api/v3/update_document", f);
    return R;
  }
  async function V({
    documentId: f,
    mode: R = "ARCHIVE"
  }) {
    const { data: K } = await t.post("/api/v3/arhive_files", {
      archive: R === "ARCHIVE" ? "true" : void 0,
      id: [f]
    });
    return K;
  }
  async function P({
    documentId: f,
    messageId: R,
    docType: K = "message"
  }) {
    return await t.delete(
      `/api/v3/documents/${f}?doc_type=${K}&message_id=${encodeURIComponent(
        R
      )}`
    );
  }
  async function h(f, R, K) {
    const k = await a(f), E = (k == null ? void 0 : k.map(
      ({ data: S }) => {
        var O;
        return (O = S.data) == null ? void 0 : O.id;
      }
    )) || [], g = (k == null ? void 0 : k.map(
      ({ data: S }) => {
        var O;
        return (O = S.data) == null ? void 0 : O.uuid;
      }
    )) || [], m = (k == null ? void 0 : k.map(
      ({ data: S }) => S.data
    )) || [];
    return {
      ...await A({
        doc_ids: E,
        is_msg_alter: K,
        ...R
      }),
      doc_ids: E,
      doc_uuids: g,
      doc_info: m,
      uploadType: f.uploadType,
      id: f.taskId
    };
  }
  async function _(f, R) {
    const K = await a(f), k = (K == null ? void 0 : K.map(
      ({ data: m }) => {
        var l;
        return (l = m.data) == null ? void 0 : l.id;
      }
    )) || [], E = K == null ? void 0 : K.map((m) => m.data.data);
    return f.uploadType === "Message" && delete R.is_draft, {
      ...await y({
        doc_ids: k,
        ...R
      }),
      doc_ids: k,
      documents: E,
      uploadType: f.uploadType,
      id: f.taskId,
      files: f.documents
    };
  }
  async function w(f) {
    const { data: R } = await t.get(
      `/api/v3/get_download_url?ids=${f.join(",")}`
    );
    return R;
  }
  return {
    getLiscioVaultDocuments: e,
    getContactDocuments: n,
    getDocumentDetails: i,
    getDocumentInfo: o,
    sendDocsToS3: a,
    updateNewDocument: y,
    shareDocumentsByDocId: A,
    associateUploadedDocuments: v,
    updateDocument: I,
    archiveDocuments: V,
    deleteDocument: P,
    uploadAndSendDocDirectly: h,
    uploadAndAttachDocument: _,
    getAccountDocuments: s,
    getDocumentDownloadUrls: w,
    uploadFile: d
  };
}
function nt(t) {
  if (!t || t.length === 0) return [];
  const e = /* @__PURE__ */ new Map();
  t.forEach((o) => {
    const a = Number(o.cpa_user_id || o.id);
    if (!a || isNaN(a))
      return;
    const d = o.account_id ? Number(o.account_id) : null, y = d ? `${a}-${d}` : `${a}`;
    if (!e.get(y))
      e.set(y, o);
    else
      return;
  });
  const n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
  return Array.from(e.values()).forEach((o) => {
    const a = Number(o.cpa_user_id || o.id);
    n.add(a), o.account_id && Number(o.account_id) > 0 ? s.add(a) : i.add(a);
  }), Array.from(e.values()).filter((o) => {
    const a = Number(o.cpa_user_id || o.id), d = o.account_id && Number(o.account_id) > 0;
    return s.has(a) && i.has(a) ? d : !0;
  }).map((o) => {
    const a = Number(o.cpa_user_id || o.id);
    return {
      ...o,
      id: a,
      cpa_user_id: a
    };
  });
}
function sn(t) {
  const e = ({
    type: m,
    page: l,
    searchString: S,
    accountId: O,
    perPage: G = 15,
    user_view_id: $
  }) => {
    const M = [`page=${l}`];
    return O && M.push(`account_id=${O}`), m ? M.push(`tab=${m}`) : M.push("tab=inbox"), S && M.push(`keyword=${S}`), $ && M.push(`user_view_id=${encodeURIComponent($)}`), `/api/v3/messages?per_page=${G}&${M.join("&")}`;
  };
  async function n({
    pageParam: m = 1,
    queryKey: l = []
  }) {
    const [S, O] = l, G = `/api/v3/get_messages_of_contact/${O}?per_page=15&page=${m}`;
    try {
      const {
        data: { data: $ }
      } = await t.get(G);
      return $;
    } catch ($) {
      console.error($);
    }
  }
  async function s({
    pageParam: m = 1,
    queryKey: l = []
  }) {
    const [S, O, G] = l;
    return i({ type: O, pageParam: m, searchString: G });
  }
  async function i({
    type: m,
    pageParam: l,
    searchString: S,
    perPage: O,
    accountId: G,
    user_view_id: $
  }) {
    const M = e({
      type: m,
      page: l,
      searchString: S,
      perPage: O,
      accountId: G,
      user_view_id: $
    }), {
      data: { data: j }
    } = await t.get(M);
    return j;
  }
  async function o({
    queryKey: m = []
  }) {
    const [l, S] = m, { data: O } = await t.get(
      `/api/v3/get_thread_messages/${encodeURIComponent(S)}`
    );
    if (!O.success)
      throw new Error("Unable to read messages");
    return O;
  }
  async function a(m) {
    try {
      const l = {
        ...m,
        participants: m.participants ? nt(m.participants) : []
      }, { data: S } = await t.post(
        "/api/v3/messages",
        l
      );
      return S;
    } catch (l) {
      console.error(l);
    }
  }
  async function d(m) {
    var l, S;
    try {
      const O = {
        ...m,
        participants: m.participants ? nt(m.participants) : []
      }, { data: G } = await t.post(
        "/api/v3/send_message",
        O
      );
      return G;
    } catch (O) {
      console.error(O);
      const G = ((l = O == null ? void 0 : O.response) == null ? void 0 : l.data) || O, $ = (G == null ? void 0 : G.messages) || (G == null ? void 0 : G.message) || ((S = G == null ? void 0 : G.error) == null ? void 0 : S[0]) || (O == null ? void 0 : O.message) || "Failed to send message. Please try again.";
      throw new Error($);
    }
  }
  async function y(m) {
    try {
      return await t.delete(
        `/api/v3/archive_thread/${encodeURIComponent(m)}`
      ), !0;
    } catch (l) {
      console.error(l);
    }
  }
  async function A(m) {
    try {
      const { data: l } = await t.patch(
        `/api/v3/messages/${encodeURIComponent(m.id)}`,
        m
      );
      return l;
    } catch (l) {
      console.error(l);
    }
  }
  async function v(m) {
    try {
      const l = {
        ...m,
        participants: m.participants ? nt(m.participants) : []
      }, { data: S } = await t.post(
        "/api/v3/update_message_participants",
        l
      );
      return S;
    } catch (l) {
      console.error(l);
    }
  }
  async function I(m) {
    try {
      const { data: l } = await t.post(
        "/api/v3/update_message_read_status",
        m
      );
      return l;
    } catch (l) {
      console.error(l);
    }
  }
  async function V(m) {
    try {
      const { data: l } = await t.put(
        `/api/v3/pin_unpin_message/${encodeURIComponent(m)}`
      );
      if (l.success === !1 || l.status && l.status >= 400)
        throw new Error(l.message || "Failed to toggle pin");
      return l;
    } catch (l) {
      throw console.error(l), l;
    }
  }
  async function P(m) {
    try {
      const { data: l } = await t.put(
        `/api/v3/pin_unpin_thread_message/${encodeURIComponent(m)}`
      );
      if (l.success === !1 || l.status && l.status >= 400)
        throw new Error(l.message || "Failed to toggle thread pin");
      return l;
    } catch (l) {
      throw console.error(l), l;
    }
  }
  async function h(m) {
    try {
      const { data: l } = await t.delete(`/api/v3/delete_message/${encodeURIComponent(m)}`);
      if (l.success === !1 || l.status && l.status >= 400)
        throw new Error(l.message || "Failed to delete message");
      return l;
    } catch (l) {
      throw console.error(l), l;
    }
  }
  const _ = async (m) => (await t.delete(
    `/api/v3/discard_draft/${encodeURIComponent(m)}`
  )).data;
  async function w(m) {
    return await t.post("/api/v3/mass_archive", { ids: m }), !0;
  }
  async function f(m) {
    const { data: l } = await t.post(
      "/api/v3/user_emails",
      m
    );
    return l;
  }
  async function R(m) {
    const l = m ? `?view_id=${encodeURIComponent(m)}` : "", S = await t.get(
      `/api/v3/get_all_messages_view${l}`
    );
    return {
      data: S.data.data || [],
      shared_views: S.data.shared_views || []
    };
  }
  async function K(m) {
    const { data: l } = await t.get(
      `/api/v3/user_views/${encodeURIComponent(m)}`
    );
    return l.data;
  }
  async function k(m) {
    const { data: l } = await t.post(
      "/api/v3/user_views",
      m
    );
    return l;
  }
  async function E(m, l) {
    const { data: S } = await t.put(
      `/api/v3/user_views/${encodeURIComponent(m)}`,
      l
    );
    return S;
  }
  async function g(m) {
    const { data: l } = await t.delete(
      `/api/v3/user_views/${encodeURIComponent(m)}`
    );
    return l;
  }
  return {
    getMessagesOfContact: n,
    getMessagesQueryKeyWrapper: s,
    getMessages: i,
    getMessageThread: o,
    sendMessage: d,
    archiveThread: y,
    bulkArchiveThreads: w,
    discardMessageDraft: _,
    toggleMessageIsPinned: V,
    updateMessageUnreadStatus: I,
    toggleThreadIsPinned: P,
    updateDraft: A,
    updateParticipantsInDraft: v,
    createDraft: a,
    deleteMessage: h,
    sendUserEmail: f,
    getAllUserViews: R,
    getUserViewDetails: K,
    createUserView: k,
    updateUserView: E,
    deleteUserView: g
  };
}
function on(t) {
  return { createNote: async (n) => {
    const { data: s } = await t.post("/api/v3/notes", n);
    return s;
  } };
}
function rn(t) {
  const e = ({ page: o, sortOrder: a, sortField: d, all: y }) => {
    const A = [`page=${o}`];
    return a && A.push(`sort_by=${a}`), d && A.push(`field=${d}`), y && A.push("all=true"), `/api/v5/notifications?${A.join("&")}`;
  };
  async function n({
    pageParam: o = 1,
    queryKey: a = []
  }) {
    const [d, y, A, v, I] = a, V = e({
      page: o,
      sortOrder: A,
      sortField: v,
      all: I === "true"
    }), {
      data: { data: P }
    } = await t.get(V);
    return P;
  }
  async function s() {
    return (await t.post(
      "/api/v5/notifications/mark_all_read",
      null
    )).data.success;
  }
  async function i(o) {
    return (await t.put(
      `/api/v5/notifications/${o}/mark_as_read`,
      {}
    )).data.success;
  }
  return {
    getNotifications: n,
    markAllRead: s,
    viewNotification: i
  };
}
function an(t) {
  return { getWouldBeTaskOwners: async () => (await t.get(
    "/api/v3/get_would_be_owner"
  )).data.data };
}
function un(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function cn(t) {
  for (var e = !1, n = 0; n < t.length; n++) {
    var s = t.charAt(n);
    e && /[a-zA-Z]/.test(s) && s.toUpperCase() === s ? (t = t.substr(0, n) + "-" + t.substr(n), e = !1, n++) : e = s.toLowerCase() === s;
  }
  return t;
}
var mn = function() {
  var t = [].map.call(arguments, function(e) {
    return e.trim();
  }).filter(function(e) {
    return e.length;
  }).join("-");
  return t.length ? t.length === 1 ? t : /[_.\- ]+/.test(t) ? (t = cn(t), t.replace(/^[_.\- ]+/, "").toLowerCase().replace(/[_.\- ]+(\w|$)/g, function(e, n) {
    return n.toUpperCase();
  })) : t === t.toUpperCase() ? t.toLowerCase() : t[0] !== t[0].toLowerCase() ? t[0].toLowerCase() + t.slice(1) : t : "";
}, pn = function(t, e) {
  for (var n = {}, s = Object.keys(t), i = 0; i < s.length; i++) {
    var o = s[i], a = e(o, t[o], t);
    n[a[0]] = a[1];
  }
  return n;
}, dn = mn, ln = pn, yn = function t(e) {
  return !e || e instanceof Date ? e : Array.isArray(e) ? e.map(function(n) {
    return t(n);
  }) : typeof e == "object" ? ln(e, function(n, s) {
    var i = dn(n);
    if (n !== i && i in e)
      throw new Error("Camelcased key `" + i + "` would overwrite existing key of the given JSON object");
    return [i, t(s)];
  }) : e;
};
const fn = /* @__PURE__ */ un(yn);
function An(t) {
  async function e() {
    const { data: a } = await t.get(
      "/text-messaging/threads"
    ), d = a.filter(
      (A) => !A.participants || A.participants.length === 0
    ), y = a.filter(
      (A) => A.participants && A.participants.length > 0
    );
    return d.length && console.log(
      "Invalid SMS Threads without any participants:",
      d
    ), y;
  }
  async function n() {
    try {
      const { data: a } = await t.get("/text-messaging/status");
      return fn(a);
    } catch (a) {
      console.error(a);
    }
  }
  const s = async () => {
    const a = await t.get("/api/v3/get_contact_phones");
    return a.status !== 200 ? [] : a.data.data;
  };
  async function i({
    queryKey: a
  }) {
    const [, d] = a, { data: y } = await t.get(
      `/text-messaging/threads/${d}`
    );
    return y;
  }
  async function o(a) {
    return await t.post(
      "/text-messaging/messages",
      a
    );
  }
  return {
    getThreads: e,
    getContactSMSStatus: n,
    getSMSContacts: s,
    getThreadDetail: i,
    createSMSMessage: o
  };
}
function gn(t) {
  const e = ({
    page: I,
    taskTypes: V = "",
    account: P = "",
    sortOrder: h = "desc",
    sortField: _ = "updated_at",
    dashboardParameter: w = "",
    owner: f = "",
    isRecurring: R = ""
  }) => {
    const K = [
      `page=${I}`,
      `sort_by=${h}`,
      `field=${_}`
    ];
    return V && K.push(`task_type_key=${encodeURIComponent(V)}`), P && K.push(`account=${P}`), w === "true" && K.push("dashboard=true"), R === "true" && K.push("is_recurring=true"), f && K.push(`owner=${f}`), `/api/v3/tasks?per_page=15&${K.join("&")}`;
  };
  async function n({
    pageParam: I = 1,
    queryKey: V = []
  }) {
    const [
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      P,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      h,
      _,
      w,
      f,
      R,
      K,
      k,
      E
    ] = V, g = e({
      page: I,
      taskTypes: _,
      account: w,
      sortOrder: f,
      sortField: R,
      dashboardParameter: K,
      owner: k,
      isRecurring: E
    });
    try {
      const { data: m } = await t.get(g);
      return m;
    } catch (m) {
      console.error(m);
    }
  }
  async function s({
    queryKey: I = []
  }) {
    const [V, P] = I, { data: h } = await t.get(
      `/api/v3/tasks/${encodeURIComponent(P)}`
    );
    return h;
  }
  async function i(I) {
    try {
      return await t.post(
        "/api/v3/update_task_status",
        {
          task_id: I
        }
      ), !0;
    } catch (V) {
      return console.error(V);
    }
  }
  const o = async (I) => {
    const V = await t.put(
      `/api/v3/reopen_task/${encodeURIComponent(I)}`
    );
    if (V.data.status !== 200)
      throw V.data;
    return V.data;
  };
  async function a(I, V) {
    try {
      return await t.post(
        "/api/v3/sign_document_and_generate_pdf",
        {
          content: I,
          task_id: V
        }
      ), !0;
    } catch (P) {
      return console.error(P);
    }
  }
  async function d(I, V, P) {
    try {
      const h = await t.post(
        "/api/v3/add_comment",
        {
          comment: I,
          task_id: V,
          reject_task: P
        }
      );
      return h == null ? void 0 : h.data;
    } catch (h) {
      return console.error(h);
    }
  }
  return {
    getTasks: n,
    getTaskDetails: s,
    updateTaskStatus: i,
    signDocumentAndGeneratePdf: a,
    addComment: d,
    reOpenTask: o,
    getContactTasks: async (I) => (await t.get(
      `/api/v3/get_tasks_of_contact/${I}`
    )).data,
    getToDoTaskData: async () => (await t.get(
      "/api/v3/get_to_do_task_data"
    )).data,
    createTask: async (I) => {
      const V = await t.post("/api/v3/tasks", I);
      if (!V.data.success || V.data.status !== 200)
        throw V.data;
      return V.data;
    }
  };
}
function hn(t) {
  async function e() {
    try {
      const { data: s } = await t.get(
        "/api/v3/get_templates_for_creation?template_type=message_template"
      );
      return s && s.data && Array.isArray(s.data) ? s.data : [];
    } catch (s) {
      throw console.error("Error fetching message templates:", s), s;
    }
  }
  async function n(s) {
    try {
      const { data: i } = await t.post(
        "/api/v3/create_doc_from_template_ids",
        {
          template_doc_ids: s
        }
      );
      return i;
    } catch (i) {
      throw console.error("Error creating documents from template IDs:", i), i;
    }
  }
  return {
    getMessageTemplates: e,
    createDocumentsFromTemplateIds: n
  };
}
function Fn(t) {
  async function e(g) {
    const { data: m } = await t.post("/api/v3/sign_in_mfa", {
      user: g
    });
    if (!m.success)
      throw m;
    return m;
  }
  const n = async (g) => {
    const { data: m } = await t.post(
      "/api/v3/login_with_code",
      g
    );
    return m;
  }, s = async (g) => {
    const { data: m } = await t.post(
      "/api/v3/login_with_code",
      g
    );
    return m;
  }, i = async (g) => {
    const { data: m } = await t.post(
      "/api/v5/auth/self_signup_sso",
      g
    );
    return m;
  }, o = async (g) => {
    const { data: m } = await t.post(
      "/api/v5/auth/self_signup_invitations/validate",
      g
    );
    return m;
  };
  async function a() {
    const { data: g } = await t.post("/api/v3/logout");
    return g;
  }
  return {
    fetchLogin: e,
    loginWithOAuthCode: n,
    loginWithOauthTokenAndCpaId: s,
    selfSignupSso: i,
    validateSelfSignupInvitation: o,
    fetchLogout: a,
    switchCpa: async (g) => {
      const { data: m } = await t.post(
        "/api/v3/switch_cpa",
        g
      );
      if (!m.success)
        throw m;
      return m;
    },
    switchCpaV5: async (g) => {
      const { data: m } = await t.post(
        "/api/v5/auth/cpa_switcher",
        g
      );
      return m;
    },
    requestBackupMfaCode: async (g) => {
      await t.post("/api/v3/backup_code", { email: g });
    },
    requestForgotPassword: async (g) => {
      const { data: m } = await t.post(
        "/api/v3/forgot_password",
        g
      );
      return m;
    },
    validateForgotPasswordToken: async (g) => {
      const { data: m } = await t.post(
        "/api/v3/check_link_validation",
        { token: g }
      );
      if (!m.success)
        throw m;
      return m;
    },
    changePasswordWithToken: async (g) => {
      const { data: m } = await t.post(
        "/api/v3/change_password",
        g
      );
      if (m.status !== 200)
        throw m;
      return m;
    },
    requestForgotPasswordMagicLink: async (g) => {
      const { data: m } = await t.post(
        "/api/v3/send_magic_link",
        g
      );
      return m;
    },
    loginWithMagicLink: async (g) => {
      const { data: m } = await t.post(
        "/api/v3/login_with_magic_link",
        g
      );
      if (!m.success)
        throw m;
      return m;
    },
    cpaAuthorizationV5WithTemporaryAuthToken: async (g) => {
      const { data: m } = await t.post(
        "/api/v5/auth/cpa_authorization",
        {
          cpa_uuid: g.cpa_uuid,
          login_type: g.login_type
        },
        {
          headers: { Authorization: g.temporary_auth_token }
        }
      );
      return m;
    },
    signUpSettings: async (g) => {
      const { data: m } = await t.post(
        "/api/v3/get_data",
        g
      );
      return m.data;
    },
    passwordResetsIdV5WithTemporaryAuthToken: async (g) => {
      const { data: m } = await t.put(
        `/api/v5/auth/password_resets/${g.url_token}`,
        {
          password: g.password,
          password_confirmation: g.password_confirmation
        },
        {
          headers: { Authorization: g.temporary_auth_token }
        }
      );
      return m;
    },
    postMfaV5WithTemporaryAuthToken: async (g) => {
      const { data: m } = await t.post(
        "/api/v5/auth/mfa",
        {
          two_factor_code: g.two_factor_code
        },
        {
          headers: {
            Authorization: g.temporary_auth_token
          }
        }
      );
      return m;
    },
    patchApiV5AuthMagicLinksIdWithTemporaryAuthToken: async (g, m) => {
      const { data: l } = await t.patch(
        `/api/v5/auth/magic_links/${g}`,
        {
          headers: {
            Authorization: m
          }
        }
      );
      return l;
    },
    postApiV5AuthMfaSetupsWithTemporaryAuthToken: async (g) => {
      const { data: m } = await t.post(
        "/api/v5/auth/mfa_setups",
        void 0,
        { headers: { Authorization: g.temporary_auth_token } }
      );
      return m;
    },
    patchApiV5AuthMfaSetupsWithTemporaryAuthToken: async (g) => {
      const { data: m } = await t.patch(
        "/api/v5/auth/mfa_setups",
        { two_factor_code: g.two_factor_code },
        { headers: { Authorization: g.temporary_auth_token } }
      );
      return m;
    }
  };
}
function qn(t) {
  return {
    addDevice: async (n) => (await t.post("/api/v3/add_device", {
      device_id: n
    })).data
  };
}
const _n = (t) => ({
  /**
   * Verify an invitation token and get invitee name and email
   * NOTE: This method does not need authentication, just a valid token
   */
  verifyInviteToken: async (e) => {
    const n = await t.post(
      "/api/v3/get_email",
      {
        token: e
      }
    );
    if (!n.data.success)
      throw n.data;
    return n.data;
  },
  /**
   * Updates contact name and phone preferences
   * NOTE: This method requires authentication
   */
  updateContactAndPhone: async (e, n) => (await t.put(
    `/api/v3/update_contact_and_phone/${e}`,
    n
  )).data
}), Vn = (t) => ({
  /**
   * Initate two-factor auth management setup
   */
  initiateTwoFactorAuthRegistration: async () => (await t.get(
    "/api/v3/two_factor"
  )).data,
  /**
   *  Register device for two-factor auth
   */
  registerTwoFactorAuth: async (e) => {
    const n = {
      user: {
        otp_attempt: e
      }
    }, s = await t.post(
      "/api/v3/two_factor",
      n
    );
    if (s.data.message.toLowerCase() === "invalid passcode")
      throw s.data;
    return s.data;
  },
  /**
   * Disable existing two-factor auth
   */
  disableTwoFactorAuth: async ({
    currentPassword: e,
    twoFactorCode: n
  }) => {
    const s = {
      current_password: e,
      two_factor_code: n
    };
    return (await t.delete(
      "/api/v3/two_factor",
      { data: s }
    )).data;
  },
  /**
   * Get two-factor auth backup codes
   */
  generateTwoFactorBackupCodes: async () => (await t.get(
    "/api/v3/two_factor_backup"
  )).data,
  /**
   * Logout a signed-in device by id
   */
  logoutFromDevice: async (e) => (await t.put(
    `/api/v3/logout_from_device/${e}`
  )).data
});
function Rn(t) {
  async function e() {
    try {
      const { data: d } = await t.get("/api/v3/home");
      return d;
    } catch (d) {
      console.error(d);
    }
  }
  async function n() {
    try {
      const { data: d } = await t.get(
        "/api/v3/get_menu_items"
      );
      return d;
    } catch (d) {
      console.error(d);
    }
  }
  async function s({
    password: d
  }) {
    const { data: y } = await t.post(
      "/api/v3/check_current_password",
      {
        current_password: d
      }
    );
    return y.success;
  }
  async function i({
    currentPassword: d,
    newPassword: y
  }) {
    if (!await s({
      password: d
    }))
      throw new Error("Wrong current password");
    const { data: v } = await t.post(
      "/api/v3/profile_change_password",
      {
        current_password: d,
        user: {
          password: y,
          password_confirmation: y
        }
      }
    );
    if (v.status === 201)
      throw v;
    return v;
  }
  async function o({
    firstName: d,
    middleName: y,
    lastName: A,
    phone: v,
    title: I,
    isTextingAllowed: V,
    companyName: P,
    customLiscioUrl: h
  }) {
    const { data: _ } = await t.post(
      "/api/v3/update_profile",
      {
        first_name: d,
        middle_name: y,
        last_name: A,
        phone: v,
        title: I,
        is_texting_allowed: V,
        ...P ? { company_name: P } : {},
        ...h ? { custom_liscio_url: h } : {}
      }
    );
    return _;
  }
  async function a({
    base64Picture: d
  }) {
    var v;
    const y = new FormData();
    y.append("avatar", d), y.append("plateform", "true");
    const { data: A } = await t.post(
      "/api/v3/update_avatar",
      y
    );
    if (!A.success) {
      const I = ((v = A == null ? void 0 : A.message) == null ? void 0 : v[0]) || "An unexpected error occurred";
      throw new Error(I);
    }
    return A;
  }
  return {
    getHomeData: e,
    getMenuItems: n,
    checkCurrentPassword: s,
    changePassword: i,
    updateProfile: o,
    updateUserAvatar: a
  };
}
const Kn = (t) => {
  async function e(i) {
    try {
      const { data: o } = await t.get(
        `/api/v5/workflow_requests/${i}/completion`
      );
      return o;
    } catch (o) {
      console.error(o);
    }
  }
  async function n(i) {
    try {
      const { data: o } = await t.post(
        i
      );
      return o;
    } catch (o) {
      console.error(o);
    }
  }
  async function s(i) {
    try {
      const { data: o } = await t.get(i);
      return o;
    } catch (o) {
      console.error(o);
    }
  }
  return {
    getESignDocumentURL: s,
    getCompletionValues: e,
    createESignAgreement: n
  };
}, At = /* @__PURE__ */ new WeakMap(), OA = (t) => {
  var e;
  if (Z.isAxiosError(t)) return (e = t.response) == null ? void 0 : e.status;
  if (typeof t == "object" && t !== null)
    return At.get(t);
}, Tn = (t) => {
  window.axiosClient = t;
};
async function r(t) {
  let e = window.axiosClient;
  e || (e = Z);
  try {
    return (await e({
      method: t.method,
      url: t.url,
      data: t.data,
      headers: t.headers,
      params: t.params,
      // Forward the AbortSignal TanStack Query passes to generated query
      // functions so superseded / unmounted requests actually cancel —
      // otherwise a stale response can resolve and win a race.
      signal: t.signal
    })).data;
  } catch (n) {
    if (Z.isAxiosError(n)) {
      if (!n.response) throw n;
      const { data: s, status: i } = n.response;
      throw typeof s == "object" && s !== null && At.set(s, i), s;
    } else
      throw n;
  }
}
var vn = /* @__PURE__ */ ((t) => (t.Client = "client", t.Prospect = "prospect", t))(vn || {}), In = /* @__PURE__ */ ((t) => (t.New = "New", t.Invited = "Invited", t.Active = "Active", t))(In || {}), wn = /* @__PURE__ */ ((t) => (t.Sent = "Sent", t.Draft = "Draft", t))(wn || {});
const On = [
  "no_active_recipients",
  "private_documents_acknowledgement_required",
  "recipient_unavailable",
  "unprocessable_entity",
  "InvalidTemplates"
], dt = (t) => typeof t == "string" && On.includes(t), gt = (t) => {
  var n;
  if (t == null) return {};
  const e = t;
  return ((n = e.response) == null ? void 0 : n.data) || e;
}, kn = (t, e) => {
  var i, o;
  if (t instanceof Error && dt(t.name)) return t.name;
  const n = gt(t), s = ((o = (i = n.errors) == null ? void 0 : i[0]) == null ? void 0 : o.type) || n.type;
  return dt(s) ? s : e;
}, kA = (t, e) => {
  var d, y;
  const n = gt(t), s = Array.isArray(n.error) ? n.error[0] : n.error, i = ((y = (d = n.errors) == null ? void 0 : d[0]) == null ? void 0 : y.message) || n.messages || n.message || s || (t instanceof Error ? t.message : void 0) || e, o = new Error(i), a = kn(t);
  return a && (o.name = a), o;
};
var Sn = /* @__PURE__ */ ((t) => (t.User = "user", t.Admin = "admin", t.Contact = "contact", t.Emp = "emp", t))(Sn || {}), Dn = /* @__PURE__ */ ((t) => (t.Open = "Open", t.Review = "Review", t.Closed = "Closed", t.Draft = "Draft", t))(Dn || {}), Pn = /* @__PURE__ */ ((t) => (t.RequestInformation = "request_info", t.ToDo = "to_do", t.Meeting = "virtual_meeting", t.GetSignature = "get_signature", t.GetSignatureConsent = "get_signature_consent", t.ManageToGoItems = "manage_to_go_items", t.ManageToGoItemsPickup = "manage_to_go_items_pickup", t))(Pn || {});
const SA = (t) => !!t.auth_token, DA = (t) => !!t.cpa_data;
function st(t, e) {
  if (!!!t)
    throw new Error(e);
}
function Cn(t) {
  return typeof t == "object" && t !== null;
}
function En(t, e) {
  if (!!!t)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const Gn = /\r\n|[\n\r]/g;
function ot(t, e) {
  let n = 0, s = 1;
  for (const i of t.body.matchAll(Gn)) {
    if (typeof i.index == "number" || En(!1), i.index >= e)
      break;
    n = i.index + i[0].length, s += 1;
  }
  return {
    line: s,
    column: e + 1 - n
  };
}
function bn(t) {
  return ht(
    t.source,
    ot(t.source, t.start)
  );
}
function ht(t, e) {
  const n = t.locationOffset.column - 1, s = "".padStart(n) + t.body, i = e.line - 1, o = t.locationOffset.line - 1, a = e.line + o, d = e.line === 1 ? n : 0, y = e.column + d, A = `${t.name}:${a}:${y}
`, v = s.split(/\r\n|[\n\r]/g), I = v[i];
  if (I.length > 120) {
    const V = Math.floor(y / 80), P = y % 80, h = [];
    for (let _ = 0; _ < I.length; _ += 80)
      h.push(I.slice(_, _ + 80));
    return A + lt([
      [`${a} |`, h[0]],
      ...h.slice(1, V + 1).map((_) => ["|", _]),
      ["|", "^".padStart(P)],
      ["|", h[V + 1]]
    ]);
  }
  return A + lt([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, v[i - 1]],
    [`${a} |`, I],
    ["|", "^".padStart(y)],
    [`${a + 1} |`, v[i + 1]]
  ]);
}
function lt(t) {
  const e = t.filter(([s, i]) => i !== void 0), n = Math.max(...e.map(([s]) => s.length));
  return e.map(([s, i]) => s.padStart(n) + (i ? " " + i : "")).join(`
`);
}
function xn(t) {
  const e = t[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: t[1],
    positions: t[2],
    path: t[3],
    originalError: t[4],
    extensions: t[5]
  } : e;
}
class at extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...n) {
    var s, i, o;
    const { nodes: a, source: d, positions: y, path: A, originalError: v, extensions: I } = xn(n);
    super(e), this.name = "GraphQLError", this.path = A ?? void 0, this.originalError = v ?? void 0, this.nodes = yt(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const V = yt(
      (s = this.nodes) === null || s === void 0 ? void 0 : s.map((h) => h.loc).filter((h) => h != null)
    );
    this.source = d ?? (V == null || (i = V[0]) === null || i === void 0 ? void 0 : i.source), this.positions = y ?? (V == null ? void 0 : V.map((h) => h.start)), this.locations = y && d ? y.map((h) => ot(d, h)) : V == null ? void 0 : V.map((h) => ot(h.source, h.start));
    const P = Cn(
      v == null ? void 0 : v.extensions
    ) ? v == null ? void 0 : v.extensions : void 0;
    this.extensions = (o = I ?? P) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), v != null && v.stack ? Object.defineProperty(this, "stack", {
      value: v.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, at) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const n of this.nodes)
        n.loc && (e += `

` + bn(n.loc));
    else if (this.source && this.locations)
      for (const n of this.locations)
        e += `

` + ht(this.source, n);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function yt(t) {
  return t === void 0 || t.length === 0 ? void 0 : t;
}
function x(t, e, n) {
  return new at(`Syntax Error: ${n}`, {
    source: t,
    positions: [e]
  });
}
class Un {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(e, n, s) {
    this.start = e.start, this.end = n.end, this.startToken = e, this.endToken = n, this.source = s;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Ft {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(e, n, s, i, o, a) {
    this.kind = e, this.start = n, this.end = s, this.line = i, this.column = o, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const $n = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
};
new Set(Object.keys($n));
var Q;
(function(t) {
  t.QUERY = "query", t.MUTATION = "mutation", t.SUBSCRIPTION = "subscription";
})(Q || (Q = {}));
var rt;
(function(t) {
  t.QUERY = "QUERY", t.MUTATION = "MUTATION", t.SUBSCRIPTION = "SUBSCRIPTION", t.FIELD = "FIELD", t.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", t.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", t.INLINE_FRAGMENT = "INLINE_FRAGMENT", t.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", t.SCHEMA = "SCHEMA", t.SCALAR = "SCALAR", t.OBJECT = "OBJECT", t.FIELD_DEFINITION = "FIELD_DEFINITION", t.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", t.INTERFACE = "INTERFACE", t.UNION = "UNION", t.ENUM = "ENUM", t.ENUM_VALUE = "ENUM_VALUE", t.INPUT_OBJECT = "INPUT_OBJECT", t.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(rt || (rt = {}));
var T;
(function(t) {
  t.NAME = "Name", t.DOCUMENT = "Document", t.OPERATION_DEFINITION = "OperationDefinition", t.VARIABLE_DEFINITION = "VariableDefinition", t.SELECTION_SET = "SelectionSet", t.FIELD = "Field", t.ARGUMENT = "Argument", t.FRAGMENT_SPREAD = "FragmentSpread", t.INLINE_FRAGMENT = "InlineFragment", t.FRAGMENT_DEFINITION = "FragmentDefinition", t.VARIABLE = "Variable", t.INT = "IntValue", t.FLOAT = "FloatValue", t.STRING = "StringValue", t.BOOLEAN = "BooleanValue", t.NULL = "NullValue", t.ENUM = "EnumValue", t.LIST = "ListValue", t.OBJECT = "ObjectValue", t.OBJECT_FIELD = "ObjectField", t.DIRECTIVE = "Directive", t.NAMED_TYPE = "NamedType", t.LIST_TYPE = "ListType", t.NON_NULL_TYPE = "NonNullType", t.SCHEMA_DEFINITION = "SchemaDefinition", t.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", t.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", t.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", t.FIELD_DEFINITION = "FieldDefinition", t.INPUT_VALUE_DEFINITION = "InputValueDefinition", t.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", t.UNION_TYPE_DEFINITION = "UnionTypeDefinition", t.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", t.ENUM_VALUE_DEFINITION = "EnumValueDefinition", t.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", t.DIRECTIVE_DEFINITION = "DirectiveDefinition", t.SCHEMA_EXTENSION = "SchemaExtension", t.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", t.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", t.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", t.UNION_TYPE_EXTENSION = "UnionTypeExtension", t.ENUM_TYPE_EXTENSION = "EnumTypeExtension", t.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(T || (T = {}));
function Mn(t) {
  return t === 9 || t === 32;
}
function H(t) {
  return t >= 48 && t <= 57;
}
function qt(t) {
  return t >= 97 && t <= 122 || // A-Z
  t >= 65 && t <= 90;
}
function _t(t) {
  return qt(t) || t === 95;
}
function Nn(t) {
  return qt(t) || H(t) || t === 95;
}
function Wn(t) {
  var e;
  let n = Number.MAX_SAFE_INTEGER, s = null, i = -1;
  for (let a = 0; a < t.length; ++a) {
    var o;
    const d = t[a], y = Ln(d);
    y !== d.length && (s = (o = s) !== null && o !== void 0 ? o : a, i = a, a !== 0 && y < n && (n = y));
  }
  return t.map((a, d) => d === 0 ? a : a.slice(n)).slice(
    (e = s) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function Ln(t) {
  let e = 0;
  for (; e < t.length && Mn(t.charCodeAt(e)); )
    ++e;
  return e;
}
var p;
(function(t) {
  t.SOF = "<SOF>", t.EOF = "<EOF>", t.BANG = "!", t.DOLLAR = "$", t.AMP = "&", t.PAREN_L = "(", t.PAREN_R = ")", t.SPREAD = "...", t.COLON = ":", t.EQUALS = "=", t.AT = "@", t.BRACKET_L = "[", t.BRACKET_R = "]", t.BRACE_L = "{", t.PIPE = "|", t.BRACE_R = "}", t.NAME = "Name", t.INT = "Int", t.FLOAT = "Float", t.STRING = "String", t.BLOCK_STRING = "BlockString", t.COMMENT = "Comment";
})(p || (p = {}));
class Qn {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(e) {
    const n = new Ft(p.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== p.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const n = jn(this, e.end);
          e.next = n, n.prev = e, e = n;
        }
      while (e.kind === p.COMMENT);
    return e;
  }
}
function Bn(t) {
  return t === p.BANG || t === p.DOLLAR || t === p.AMP || t === p.PAREN_L || t === p.PAREN_R || t === p.SPREAD || t === p.COLON || t === p.EQUALS || t === p.AT || t === p.BRACKET_L || t === p.BRACKET_R || t === p.BRACE_L || t === p.PIPE || t === p.BRACE_R;
}
function B(t) {
  return t >= 0 && t <= 55295 || t >= 57344 && t <= 1114111;
}
function X(t, e) {
  return Vt(t.charCodeAt(e)) && Rt(t.charCodeAt(e + 1));
}
function Vt(t) {
  return t >= 55296 && t <= 56319;
}
function Rt(t) {
  return t >= 56320 && t <= 57343;
}
function L(t, e) {
  const n = t.source.body.codePointAt(e);
  if (n === void 0)
    return p.EOF;
  if (n >= 32 && n <= 126) {
    const s = String.fromCodePoint(n);
    return s === '"' ? `'"'` : `"${s}"`;
  }
  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}
function b(t, e, n, s, i) {
  const o = t.line, a = 1 + n - t.lineStart;
  return new Ft(e, n, s, o, a, i);
}
function jn(t, e) {
  const n = t.source.body, s = n.length;
  let i = e;
  for (; i < s; ) {
    const o = n.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++t.line, t.lineStart = i;
        continue;
      case 13:
        n.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++t.line, t.lineStart = i;
        continue;
      case 35:
        return zn(t, i);
      case 33:
        return b(t, p.BANG, i, i + 1);
      case 36:
        return b(t, p.DOLLAR, i, i + 1);
      case 38:
        return b(t, p.AMP, i, i + 1);
      case 40:
        return b(t, p.PAREN_L, i, i + 1);
      case 41:
        return b(t, p.PAREN_R, i, i + 1);
      case 46:
        if (n.charCodeAt(i + 1) === 46 && n.charCodeAt(i + 2) === 46)
          return b(t, p.SPREAD, i, i + 3);
        break;
      case 58:
        return b(t, p.COLON, i, i + 1);
      case 61:
        return b(t, p.EQUALS, i, i + 1);
      case 64:
        return b(t, p.AT, i, i + 1);
      case 91:
        return b(t, p.BRACKET_L, i, i + 1);
      case 93:
        return b(t, p.BRACKET_R, i, i + 1);
      case 123:
        return b(t, p.BRACE_L, i, i + 1);
      case 124:
        return b(t, p.PIPE, i, i + 1);
      case 125:
        return b(t, p.BRACE_R, i, i + 1);
      case 34:
        return n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34 ? ts(t, i) : Jn(t, i);
    }
    if (H(o) || o === 45)
      return Hn(t, i, o);
    if (_t(o))
      return es(t, i);
    throw x(
      t.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : B(o) || X(n, i) ? `Unexpected character: ${L(t, i)}.` : `Invalid character: ${L(t, i)}.`
    );
  }
  return b(t, p.EOF, s, s);
}
function zn(t, e) {
  const n = t.source.body, s = n.length;
  let i = e + 1;
  for (; i < s; ) {
    const o = n.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (B(o))
      ++i;
    else if (X(n, i))
      i += 2;
    else
      break;
  }
  return b(
    t,
    p.COMMENT,
    e,
    i,
    n.slice(e + 1, i)
  );
}
function Hn(t, e, n) {
  const s = t.source.body;
  let i = e, o = n, a = !1;
  if (o === 45 && (o = s.charCodeAt(++i)), o === 48) {
    if (o = s.charCodeAt(++i), H(o))
      throw x(
        t.source,
        i,
        `Invalid number, unexpected digit after 0: ${L(
          t,
          i
        )}.`
      );
  } else
    i = it(t, i, o), o = s.charCodeAt(i);
  if (o === 46 && (a = !0, o = s.charCodeAt(++i), i = it(t, i, o), o = s.charCodeAt(i)), (o === 69 || o === 101) && (a = !0, o = s.charCodeAt(++i), (o === 43 || o === 45) && (o = s.charCodeAt(++i)), i = it(t, i, o), o = s.charCodeAt(i)), o === 46 || _t(o))
    throw x(
      t.source,
      i,
      `Invalid number, expected digit but got: ${L(
        t,
        i
      )}.`
    );
  return b(
    t,
    a ? p.FLOAT : p.INT,
    e,
    i,
    s.slice(e, i)
  );
}
function it(t, e, n) {
  if (!H(n))
    throw x(
      t.source,
      e,
      `Invalid number, expected digit but got: ${L(
        t,
        e
      )}.`
    );
  const s = t.source.body;
  let i = e + 1;
  for (; H(s.charCodeAt(i)); )
    ++i;
  return i;
}
function Jn(t, e) {
  const n = t.source.body, s = n.length;
  let i = e + 1, o = i, a = "";
  for (; i < s; ) {
    const d = n.charCodeAt(i);
    if (d === 34)
      return a += n.slice(o, i), b(t, p.STRING, e, i + 1, a);
    if (d === 92) {
      a += n.slice(o, i);
      const y = n.charCodeAt(i + 1) === 117 ? n.charCodeAt(i + 2) === 123 ? Yn(t, i) : Zn(t, i) : Xn(t, i);
      a += y.value, i += y.size, o = i;
      continue;
    }
    if (d === 10 || d === 13)
      break;
    if (B(d))
      ++i;
    else if (X(n, i))
      i += 2;
    else
      throw x(
        t.source,
        i,
        `Invalid character within String: ${L(
          t,
          i
        )}.`
      );
  }
  throw x(t.source, i, "Unterminated string.");
}
function Yn(t, e) {
  const n = t.source.body;
  let s = 0, i = 3;
  for (; i < 12; ) {
    const o = n.charCodeAt(e + i++);
    if (o === 125) {
      if (i < 5 || !B(s))
        break;
      return {
        value: String.fromCodePoint(s),
        size: i
      };
    }
    if (s = s << 4 | z(o), s < 0)
      break;
  }
  throw x(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${n.slice(
      e,
      e + i
    )}".`
  );
}
function Zn(t, e) {
  const n = t.source.body, s = ft(n, e + 2);
  if (B(s))
    return {
      value: String.fromCodePoint(s),
      size: 6
    };
  if (Vt(s) && n.charCodeAt(e + 6) === 92 && n.charCodeAt(e + 7) === 117) {
    const i = ft(n, e + 8);
    if (Rt(i))
      return {
        value: String.fromCodePoint(s, i),
        size: 12
      };
  }
  throw x(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${n.slice(e, e + 6)}".`
  );
}
function ft(t, e) {
  return z(t.charCodeAt(e)) << 12 | z(t.charCodeAt(e + 1)) << 8 | z(t.charCodeAt(e + 2)) << 4 | z(t.charCodeAt(e + 3));
}
function z(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 65 && t <= 70 ? t - 55 : t >= 97 && t <= 102 ? t - 87 : -1;
}
function Xn(t, e) {
  const n = t.source.body;
  switch (n.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw x(
    t.source,
    e,
    `Invalid character escape sequence: "${n.slice(
      e,
      e + 2
    )}".`
  );
}
function ts(t, e) {
  const n = t.source.body, s = n.length;
  let i = t.lineStart, o = e + 3, a = o, d = "";
  const y = [];
  for (; o < s; ) {
    const A = n.charCodeAt(o);
    if (A === 34 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34) {
      d += n.slice(a, o), y.push(d);
      const v = b(
        t,
        p.BLOCK_STRING,
        e,
        o + 3,
        // Return a string of the lines joined with U+000A.
        Wn(y).join(`
`)
      );
      return t.line += y.length - 1, t.lineStart = i, v;
    }
    if (A === 92 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34 && n.charCodeAt(o + 3) === 34) {
      d += n.slice(a, o), a = o + 1, o += 4;
      continue;
    }
    if (A === 10 || A === 13) {
      d += n.slice(a, o), y.push(d), A === 13 && n.charCodeAt(o + 1) === 10 ? o += 2 : ++o, d = "", a = o, i = o;
      continue;
    }
    if (B(A))
      ++o;
    else if (X(n, o))
      o += 2;
    else
      throw x(
        t.source,
        o,
        `Invalid character within String: ${L(
          t,
          o
        )}.`
      );
  }
  throw x(t.source, o, "Unterminated string.");
}
function es(t, e) {
  const n = t.source.body, s = n.length;
  let i = e + 1;
  for (; i < s; ) {
    const o = n.charCodeAt(i);
    if (Nn(o))
      ++i;
    else
      break;
  }
  return b(
    t,
    p.NAME,
    e,
    i,
    n.slice(e, i)
  );
}
const ns = 10, Kt = 2;
function Tt(t) {
  return tt(t, []);
}
function tt(t, e) {
  switch (typeof t) {
    case "string":
      return JSON.stringify(t);
    case "function":
      return t.name ? `[function ${t.name}]` : "[function]";
    case "object":
      return ss(t, e);
    default:
      return String(t);
  }
}
function ss(t, e) {
  if (t === null)
    return "null";
  if (e.includes(t))
    return "[Circular]";
  const n = [...e, t];
  if (is(t)) {
    const s = t.toJSON();
    if (s !== t)
      return typeof s == "string" ? s : tt(s, n);
  } else if (Array.isArray(t))
    return rs(t, n);
  return os(t, n);
}
function is(t) {
  return typeof t.toJSON == "function";
}
function os(t, e) {
  const n = Object.entries(t);
  return n.length === 0 ? "{}" : e.length > Kt ? "[" + as(t) + "]" : "{ " + n.map(
    ([i, o]) => i + ": " + tt(o, e)
  ).join(", ") + " }";
}
function rs(t, e) {
  if (t.length === 0)
    return "[]";
  if (e.length > Kt)
    return "[Array]";
  const n = Math.min(ns, t.length), s = t.length - n, i = [];
  for (let o = 0; o < n; ++o)
    i.push(tt(t[o], e));
  return s === 1 ? i.push("... 1 more item") : s > 1 && i.push(`... ${s} more items`), "[" + i.join(", ") + "]";
}
function as(t) {
  const e = Object.prototype.toString.call(t).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof t.constructor == "function") {
    const n = t.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return e;
}
const us = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", cs = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  us ? function(e, n) {
    return e instanceof n;
  } : function(e, n) {
    if (e instanceof n)
      return !0;
    if (typeof e == "object" && e !== null) {
      var s;
      const i = n.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (s = e.constructor) === null || s === void 0 ? void 0 : s.name
      );
      if (i === o) {
        const a = Tt(e);
        throw new Error(`Cannot use ${i} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class vt {
  constructor(e, n = "GraphQL request", s = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || st(!1, `Body must be a string. Received: ${Tt(e)}.`), this.body = e, this.name = n, this.locationOffset = s, this.locationOffset.line > 0 || st(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || st(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function ms(t) {
  return cs(t, vt);
}
function et(t, e) {
  return new ps(t, e).parseDocument();
}
class ps {
  constructor(e, n = {}) {
    const s = ms(e) ? e : new vt(e);
    this._lexer = new Qn(s), this._options = n, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const e = this.expectToken(p.NAME);
    return this.node(e, {
      kind: T.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: T.DOCUMENT,
      definitions: this.many(
        p.SOF,
        this.parseDefinition,
        p.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(p.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), n = e ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === p.NAME) {
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw x(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (n.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(n);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(p.BRACE_L))
      return this.node(e, {
        kind: T.OPERATION_DEFINITION,
        operation: Q.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const n = this.parseOperationType();
    let s;
    return this.peek(p.NAME) && (s = this.parseName()), this.node(e, {
      kind: T.OPERATION_DEFINITION,
      operation: n,
      name: s,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const e = this.expectToken(p.NAME);
    switch (e.value) {
      case "query":
        return Q.QUERY;
      case "mutation":
        return Q.MUTATION;
      case "subscription":
        return Q.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      p.PAREN_L,
      this.parseVariableDefinition,
      p.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: T.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(p.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(p.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(p.DOLLAR), this.node(e, {
      kind: T.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: T.SELECTION_SET,
      selections: this.many(
        p.BRACE_L,
        this.parseSelection,
        p.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(p.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const e = this._lexer.token, n = this.parseName();
    let s, i;
    return this.expectOptionalToken(p.COLON) ? (s = n, i = this.parseName()) : i = n, this.node(e, {
      kind: T.FIELD,
      alias: s,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(p.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(e) {
    const n = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(p.PAREN_L, n, p.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(e = !1) {
    const n = this._lexer.token, s = this.parseName();
    return this.expectToken(p.COLON), this.node(n, {
      kind: T.ARGUMENT,
      name: s,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(p.SPREAD);
    const n = this.expectOptionalKeyword("on");
    return !n && this.peek(p.NAME) ? this.node(e, {
      kind: T.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: T.INLINE_FRAGMENT,
      typeCondition: n ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const e = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: T.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: T.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(e) {
    const n = this._lexer.token;
    switch (n.kind) {
      case p.BRACKET_L:
        return this.parseList(e);
      case p.BRACE_L:
        return this.parseObject(e);
      case p.INT:
        return this.advanceLexer(), this.node(n, {
          kind: T.INT,
          value: n.value
        });
      case p.FLOAT:
        return this.advanceLexer(), this.node(n, {
          kind: T.FLOAT,
          value: n.value
        });
      case p.STRING:
      case p.BLOCK_STRING:
        return this.parseStringLiteral();
      case p.NAME:
        switch (this.advanceLexer(), n.value) {
          case "true":
            return this.node(n, {
              kind: T.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(n, {
              kind: T.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(n, {
              kind: T.NULL
            });
          default:
            return this.node(n, {
              kind: T.ENUM,
              value: n.value
            });
        }
      case p.DOLLAR:
        if (e)
          if (this.expectToken(p.DOLLAR), this._lexer.token.kind === p.NAME) {
            const s = this._lexer.token.value;
            throw x(
              this._lexer.source,
              n.start,
              `Unexpected variable "$${s}" in constant value.`
            );
          } else
            throw this.unexpected(n);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: T.STRING,
      value: e.value,
      block: e.kind === p.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(e) {
    const n = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: T.LIST,
      values: this.any(p.BRACKET_L, n, p.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(e) {
    const n = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: T.OBJECT,
      fields: this.any(p.BRACE_L, n, p.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(e) {
    const n = this._lexer.token, s = this.parseName();
    return this.expectToken(p.COLON), this.node(n, {
      kind: T.OBJECT_FIELD,
      name: s,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(e) {
    const n = [];
    for (; this.peek(p.AT); )
      n.push(this.parseDirective(e));
    return n;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(e) {
    const n = this._lexer.token;
    return this.expectToken(p.AT), this.node(n, {
      kind: T.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let n;
    if (this.expectOptionalToken(p.BRACKET_L)) {
      const s = this.parseTypeReference();
      this.expectToken(p.BRACKET_R), n = this.node(e, {
        kind: T.LIST_TYPE,
        type: s
      });
    } else
      n = this.parseNamedType();
    return this.expectOptionalToken(p.BANG) ? this.node(e, {
      kind: T.NON_NULL_TYPE,
      type: n
    }) : n;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: T.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(p.STRING) || this.peek(p.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("schema");
    const s = this.parseConstDirectives(), i = this.many(
      p.BRACE_L,
      this.parseOperationTypeDefinition,
      p.BRACE_R
    );
    return this.node(e, {
      kind: T.SCHEMA_DEFINITION,
      description: n,
      directives: s,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, n = this.parseOperationType();
    this.expectToken(p.COLON);
    const s = this.parseNamedType();
    return this.node(e, {
      kind: T.OPERATION_TYPE_DEFINITION,
      operation: n,
      type: s
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("scalar");
    const s = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: T.SCALAR_TYPE_DEFINITION,
      description: n,
      name: s,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("type");
    const s = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(e, {
      kind: T.OBJECT_TYPE_DEFINITION,
      description: n,
      name: s,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(p.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      p.BRACE_L,
      this.parseFieldDefinition,
      p.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const e = this._lexer.token, n = this.parseDescription(), s = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(p.COLON);
    const o = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(e, {
      kind: T.FIELD_DEFINITION,
      description: n,
      name: s,
      arguments: i,
      type: o,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      p.PAREN_L,
      this.parseInputValueDef,
      p.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const e = this._lexer.token, n = this.parseDescription(), s = this.parseName();
    this.expectToken(p.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(p.EQUALS) && (o = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(e, {
      kind: T.INPUT_VALUE_DEFINITION,
      description: n,
      name: s,
      type: i,
      defaultValue: o,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("interface");
    const s = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(e, {
      kind: T.INTERFACE_TYPE_DEFINITION,
      description: n,
      name: s,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("union");
    const s = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: T.UNION_TYPE_DEFINITION,
      description: n,
      name: s,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(p.EQUALS) ? this.delimitedMany(p.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("enum");
    const s = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: T.ENUM_TYPE_DEFINITION,
      description: n,
      name: s,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      p.BRACE_L,
      this.parseEnumValueDefinition,
      p.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, n = this.parseDescription(), s = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: T.ENUM_VALUE_DEFINITION,
      description: n,
      name: s,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw x(
        this._lexer.source,
        this._lexer.token.start,
        `${Y(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("input");
    const s = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: T.INPUT_OBJECT_TYPE_DEFINITION,
      description: n,
      name: s,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      p.BRACE_L,
      this.parseInputValueDef,
      p.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === p.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const n = this.parseConstDirectives(), s = this.optionalMany(
      p.BRACE_L,
      this.parseOperationTypeDefinition,
      p.BRACE_R
    );
    if (n.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: T.SCHEMA_EXTENSION,
      directives: n,
      operationTypes: s
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const n = this.parseName(), s = this.parseConstDirectives();
    if (s.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: T.SCALAR_TYPE_EXTENSION,
      name: n,
      directives: s
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const n = this.parseName(), s = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (s.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: T.OBJECT_TYPE_EXTENSION,
      name: n,
      interfaces: s,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const n = this.parseName(), s = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (s.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: T.INTERFACE_TYPE_EXTENSION,
      name: n,
      interfaces: s,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const n = this.parseName(), s = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (s.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: T.UNION_TYPE_EXTENSION,
      name: n,
      directives: s,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const n = this.parseName(), s = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (s.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: T.ENUM_TYPE_EXTENSION,
      name: n,
      directives: s,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const n = this.parseName(), s = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (s.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: T.INPUT_OBJECT_TYPE_EXTENSION,
      name: n,
      directives: s,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(p.AT);
    const s = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(e, {
      kind: T.DIRECTIVE_DEFINITION,
      description: n,
      name: s,
      arguments: i,
      repeatable: o,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(p.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, n = this.parseName();
    if (Object.prototype.hasOwnProperty.call(rt, n.value))
      return n;
    throw this.unexpected(e);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(e, n) {
    return this._options.noLocation !== !0 && (n.loc = new Un(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), n;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(e) {
    const n = this._lexer.token;
    if (n.kind === e)
      return this.advanceLexer(), n;
    throw x(
      this._lexer.source,
      n.start,
      `Expected ${It(e)}, found ${Y(n)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(e) {
    const n = this._lexer.token;
    if (n.kind === p.NAME && n.value === e)
      this.advanceLexer();
    else
      throw x(
        this._lexer.source,
        n.start,
        `Expected "${e}", found ${Y(n)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(e) {
    const n = this._lexer.token;
    return n.kind === p.NAME && n.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(e) {
    const n = e ?? this._lexer.token;
    return x(
      this._lexer.source,
      n.start,
      `Unexpected ${Y(n)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(e, n, s) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(s); )
      i.push(n.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(e, n, s) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(n.call(this));
      while (!this.expectOptionalToken(s));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(e, n, s) {
    this.expectToken(e);
    const i = [];
    do
      i.push(n.call(this));
    while (!this.expectOptionalToken(s));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(e, n) {
    this.expectOptionalToken(e);
    const s = [];
    do
      s.push(n.call(this));
    while (this.expectOptionalToken(e));
    return s;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, n = this._lexer.advance();
    if (e !== void 0 && n.kind !== p.EOF && (++this._tokenCounter, this._tokenCounter > e))
      throw x(
        this._lexer.source,
        n.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
}
function Y(t) {
  const e = t.value;
  return It(t.kind) + (e != null ? ` "${e}"` : "");
}
function It(t) {
  return Bn(t) ? `"${t}"` : t;
}
const ds = {
  "\n  query FetchFirmLicense {\n    fetchFirmLicense {\n      id\n      billingCycle\n      billingStartDay\n      licenseTier\n      seatCount\n      status\n    }\n  }\n": pe,
  "\n  mutation UpdateFirmLicense(\n    $licenseTier: LicenseTier!\n    $billingCycle: BillingCycle!\n  ) {\n    updateFirmLicense(licenseTier: $licenseTier, billingCycle: $billingCycle) {\n      errors {\n        message\n      }\n      firmLicense {\n        id\n        seatCount\n        billingCycle\n        licenseTier\n      }\n    }\n  }\n": de,
  "\n  query todoFeeds {\n    todoFeeds {\n      id\n      feedItemType\n      createdAt\n      updatedAt\n      isRead\n      item {\n        ...TaskFields\n        ...InvoiceFields\n        ...WorkflowRequestFields\n      }\n    }\n  }\n\n  fragment TaskFields on Task {\n    __typename\n    itemId: id\n    legacyId\n    subject\n    taskType: taskSubtype\n    taskStatus: status\n    dueByDate\n  }\n  fragment InvoiceFields on Invoice {\n    __typename\n    itemId: id\n    legacyId\n    subject\n    isRecurring\n    invoiceStatus: status\n    dueByDate\n  }\n  fragment WorkflowRequestFields on WorkflowRequest {\n    __typename\n    id\n    status\n    title\n    percentComplete\n    dueByDate\n  }\n": le,
  "\n  query workflowRequestsCount(\n    $status: WorkflowRequestStatus\n    $statuses: [WorkflowRequestStatus!]\n  ) {\n    workflowRequests(status: $status, statuses: $statuses) {\n      totalCount\n    }\n  }\n": ye,
  "\n  fragment RpaDocument on RpaDocument {\n    id\n    fileUrl\n    legacyId\n    title\n  }\n": fe,
  "\n  fragment WorkflowRequestSection on WorkflowRequestSection {\n    id\n    title\n    requestItems {\n      ...WorkflowRequestItem\n    }\n  }\n": Ae,
  "\n  fragment WorkflowRequest on WorkflowRequest {\n    id\n    title\n    percentComplete\n    assignedAccount {\n      id\n      legacyId\n    }\n    assignedContact {\n      id\n      firstName\n      middleName\n      lastName\n    }\n    assignedContacts {\n      id\n      firstName\n      middleName\n      lastName\n    }\n    dueDate\n    status\n    workflow {\n      id\n      type\n      title\n      description\n      sections {\n        ...WorkflowSection\n      }\n    }\n    requestSections {\n      ...WorkflowRequestSection\n    }\n    rpaDocuments {\n      ...RpaDocument\n    }\n  }\n": ge,
  "\n  fragment WorkflowResponseItem2 on WorkflowResponseItem {\n    id\n    type\n    booleanValue\n    textValue\n    notApplicable\n    liscioObjects {\n      id\n    }\n  }\n": he,
  "\n  fragment WorkflowRequestItem2 on WorkflowRequestItem {\n    id\n    prompt\n    dependency {\n      ... on Invoice {\n        invoiceId: id\n        legacyId\n        dueByDate\n        isRecurring\n        status\n        subject\n        taskType\n      }\n      ... on Payable {\n        payableId: id\n        url\n        document {\n          id\n          uuid\n          legacyId\n          awsUrlFileName\n        }\n      }\n      ... on Document {\n        documentId: id\n        uuid\n        legacyId\n      }\n      ... on DynamicDependency {\n        readUrl\n        type\n      }\n    }\n    responseItem {\n      ...WorkflowResponseItem2\n    }\n  }\n": Fe,
  "\n  fragment WorkflowItemCondition2 on WorkflowItemConditionType2 {\n    id\n    conditionType\n    matchValue\n    rangeLowerBound\n    rangeUpperBound\n    items {\n      id\n      hint\n      prompt\n      responseType\n      type\n      requestItem {\n        ...WorkflowRequestItem2\n      }\n    }\n  }\n": qe,
  "\n  fragment WorkflowItemInterface2 on WorkflowItemInterface2 {\n    id\n    hint\n    prompt\n    type\n    updatedAt\n    position\n    options\n    section {\n      id\n    }\n    requestItem {\n      ...WorkflowRequestItem2\n    }\n    conditions {\n      ...WorkflowItemCondition2\n    }\n  }\n": _e,
  "\n  fragment WorkflowRequestItem on WorkflowRequestItem {\n    id\n    prompt\n    responseType\n    status\n    dependency {\n      ... on Invoice {\n        invoiceId: id\n        legacyId\n        dueByDate\n        isRecurring\n        status\n        subject\n        taskType\n      }\n      ... on Payable {\n        payableId: id\n        url\n        document {\n          id\n          uuid\n          legacyId\n          awsUrlFileName\n        }\n      }\n      ... on Document {\n        documentId: id\n        uuid\n        legacyId\n      }\n      ... on DynamicDependency {\n        readUrl\n        type\n      }\n    }\n    responseItem {\n      ...WorkflowResponseItem\n    }\n  }\n": Ve,
  "\n  fragment WorkflowItem2 on WorkflowItemInterface2 {\n    ...DefaultWorkflowItem2\n    ...WorkflowSignableDocumentItem2\n  }\n": Re,
  "\n  fragment DefaultWorkflowItem2 on WorkflowItemType2 {\n    ... on WorkflowItemType2 {\n      ...WorkflowItemInterface2\n    }\n  }\n": Ke,
  "\n  fragment WorkflowSection on WorkflowSection {\n    createdAt\n    id\n    title\n    items2 {\n      ...WorkflowItem2\n    }\n    updatedAt\n  }\n": Te,
  "\n  fragment WorkflowSignableDocumentItem2 on WorkflowSignableDocumentItemType2 {\n    ... on WorkflowSignableDocumentItemType2 {\n      ...WorkflowItemInterface2\n      esignAgreement {\n        id\n        documentToSign {\n          id\n        }\n        signatories {\n          contact {\n            id\n          }\n          kbaRequired\n          signOnSameDevice\n          esignSignatureBlocks {\n            pageNumber\n            top\n            left\n            width\n            height\n          }\n        }\n        currentUserSignatory {\n          id\n          contact {\n            id\n            firstName\n            lastName\n          }\n          firstName\n          lastName\n          label\n          status\n          email\n          kbaRequired\n          signOnSameDevice\n          signingUrl\n          signingStatusUrl\n          esignSignatureBlocks {\n            pageNumber\n            top\n            left\n            width\n            height\n          }\n        }\n        sameDeviceSignatories {\n          id\n          contact {\n            id\n            firstName\n            lastName\n          }\n          firstName\n          lastName\n          label\n          status\n          email\n          kbaRequired\n          signOnSameDevice\n          signingUrl\n          signingStatusUrl\n          esignSignatureBlocks {\n            pageNumber\n            top\n            left\n            width\n            height\n          }\n        }\n        startSigningUrl\n        signingAvailableUrl\n      }\n    }\n  }\n": ve,
  "\n  fragment WorkflowResponseItem on WorkflowResponseItem {\n    __typename\n    id\n    liscioObjects {\n      id\n    }\n    workflowItem2 {\n      ...WorkflowItem2\n    }\n    type\n    booleanValue\n    textValue\n    createdAt\n    updatedAt\n    notApplicable\n  }\n": Ie,
  "\n  mutation updateResponseItemBool(\n    $notApplicable: Boolean\n    $booleanValue: Boolean\n    $workflowResponseItemId: Uuid!\n  ) {\n    updateResponseItemBool(\n      notApplicable: $notApplicable\n      booleanValue: $booleanValue\n      workflowResponseItemId: $workflowResponseItemId\n    ) {\n      errors {\n        message\n      }\n      workflowResponseItem {\n        id\n      }\n    }\n  }\n": we,
  "\n  mutation updateWorkflowRequest(\n    $status: WorkflowRequestStatus\n    $workflowRequestId: Uuid!\n  ) {\n    updateWorkflowRequest(\n      status: $status\n      workflowRequestId: $workflowRequestId\n    ) {\n      errors {\n        message\n      }\n      workflowRequest {\n        title\n        id\n        dueDate\n        assignedContact {\n          id\n        }\n      }\n    }\n  }\n": Oe,
  "\n  mutation updateResponseItemDocUpload(\n    $notApplicable: Boolean\n    $liscioObjectData: [LiscioObjectInput!]\n    $workflowResponseItemId: Uuid!\n  ) {\n    updateResponseItemDocUpload(\n      notApplicable: $notApplicable\n      liscioObjectData: $liscioObjectData\n      workflowResponseItemId: $workflowResponseItemId\n    ) {\n      errors {\n        message\n      }\n      workflowResponseItem {\n        ...WorkflowResponseItem\n      }\n    }\n  }\n": ke,
  "\n  mutation updateResponseItemText(\n    $notApplicable: Boolean\n    $textValue: String\n    $workflowResponseItemId: Uuid!\n  ) {\n    updateResponseItemText(\n      notApplicable: $notApplicable\n      textValue: $textValue\n      workflowResponseItemId: $workflowResponseItemId\n    ) {\n      errors {\n        message\n      }\n      workflowResponseItem {\n        ...WorkflowResponseItem\n      }\n    }\n  }\n": Se,
  "\n  query workflowRequest($id: Uuid!) {\n    workflowRequest(id: $id) {\n      ...WorkflowRequest\n    }\n  }\n": De,
  "\n  query workflowRequestsQuery(\n    $status: WorkflowRequestStatus\n    $statuses: [WorkflowRequestStatus!]\n    $filter: String\n    $page: Int\n    $perPage: Int\n    $sortField: WfRequestSortOption\n    $sortDirection: String\n  ) {\n    workflowRequests(\n      status: $status\n      statuses: $statuses\n      filter: $filter\n      page: $page\n      perPage: $perPage\n      sortField: $sortField\n      sortDirection: $sortDirection\n    ) {\n      totalCount\n      collection {\n        id\n        title\n        assignedAccount {\n          id\n          name\n        }\n        assignedContact {\n          id\n          firstName\n          middleName\n          lastName\n          legacyId\n          smsNumber\n          smsOptIn\n        }\n        assignedEmployee {\n          id\n          firstName\n          middleName\n          lastName\n          legacyId\n        }\n        owner {\n          contact {\n            firstName\n            lastName\n          }\n        }\n        updatedAt\n        dueDate\n        dueByDate\n        status\n        percentComplete\n        updatedAt\n        workflow {\n          title\n        }\n      }\n    }\n  }\n": Pe,
  "\n  fragment WorkflowTemplate on WorkflowTemplate {\n    id\n    createdAt\n    updatedAt\n    displayName\n    status\n    firm {\n      id\n    }\n  }\n": Ce,
  "\n  mutation readyToSend($workflowId: Uuid!) {\n    readyToSend(workflowId: $workflowId) {\n      errors {\n        message\n      }\n      workflowRequest {\n        id\n      }\n    }\n  }\n": Ee,
  "\n    mutation createWorkflowsFromWorkflowTemplateDocument($id: Uuid!) {\n      createWorkflowsFromWorkflowTemplate(workflowTemplateId: $id) {\n        errors {\n          message\n        }\n        workflows {\n          id\n        }\n      }\n    }\n  ": Ge,
  "\n  query workflowTemplates($statuses: [WorkflowTemplateStatus!]) {\n    workflowTemplates(statuses: $statuses) {\n      ...WorkflowTemplate\n    }\n  }\n": be,
  "\n  mutation deleteWorkflowTemplate($workflowTemplateId: Uuid!) {\n    deleteWorkflowTemplate(workflowTemplateId: $workflowTemplateId) {\n      errors {\n        message\n      }\n      workflowTemplate {\n        ...WorkflowTemplate\n      }\n    }\n  }\n": xe,
  "\n  mutation updateWorkflow($status: String!, $workflowId: Uuid!) {\n    updateWorkflow(status: $status, workflowId: $workflowId) {\n      errors {\n        message\n      }\n      workflow {\n        id\n        status\n      }\n    }\n  }\n": Ue,
  "\n  query workflows(\n    $status: WorkflowStatus\n    $statuses: [WorkflowStatus!]\n    $page: Int\n    $perPage: Int\n    $sortField: WorkflowSortOption\n    $sortDirection: String\n  ) {\n    workflows(\n      status: $status\n      statuses: $statuses\n      page: $page\n      perPage: $perPage\n      sortField: $sortField\n      sortDirection: $sortDirection\n    ) {\n      totalCount\n      collection {\n        id\n        title\n        description\n        createdAt\n        status\n        type\n        updatedAt\n      }\n    }\n  }\n": $e
};
function C(t) {
  return ds[t] ?? {};
}
const PA = C(
  /* GraphQL */
  `
  query workflowRequestsCount(
    $status: WorkflowRequestStatus
    $statuses: [WorkflowRequestStatus!]
  ) {
    workflowRequests(status: $status, statuses: $statuses) {
      totalCount
    }
  }
`
), CA = C(
  /* GraphQL */
  `
  fragment RpaDocument on RpaDocument {
    id
    fileUrl
    legacyId
    title
  }
`
), EA = C(
  /* GraphQL */
  `
  fragment WorkflowRequestSection on WorkflowRequestSection {
    id
    title
    workflowSection {
      id
    }
    requestItems {
      ...WorkflowRequestItem
    }
  }
`
), GA = C(
  /* GraphQL */
  `
  fragment WorkflowRequest on WorkflowRequest {
    id
    title
    percentComplete
    assignedAccount {
      id
      legacyId
    }
    assignedContact {
      id
      firstName
      middleName
      lastName
    }
    assignedContacts {
      id
      firstName
      middleName
      lastName
    }
    dueDate
    status
    workflow {
      id
      type
      title
      description
      sections {
        ...WorkflowSection
      }
    }
    requestSections {
      ...WorkflowRequestSection
    }
    rpaDocuments {
      ...RpaDocument
    }
  }
`
), bA = C(
  /* GraphQL */
  `
  fragment WorkflowResponseItem2 on WorkflowResponseItem {
    id
    type
    booleanValue
    textValue
    notApplicable
    liscioObjects {
      id
    }
  }
`
), xA = C(
  /* GraphQL */
  `
  fragment WorkflowRequestItem2 on WorkflowRequestItem {
    id
    prompt
    dependency {
      ... on Invoice {
        invoiceId: id
        legacyId
        dueByDate
        isRecurring
        status
        subject
        taskType
      }
      ... on Payable {
        payableId: id
        url
        document {
          id
          uuid
          legacyId
          awsUrlFileName
        }
      }
      ... on Document {
        documentId: id
        uuid
        legacyId
      }
      ... on DynamicDependency {
        readUrl
        type
      }
    }
    responseItem {
      ...WorkflowResponseItem2
    }
  }
`
), UA = C(
  /* GraphQL */
  `
  fragment WorkflowItemCondition2 on WorkflowItemConditionType2 {
    id
    conditionType
    matchValue
    rangeLowerBound
    rangeUpperBound
    items {
      id
      hint
      prompt
      responseType
      type
      requestItem {
        ...WorkflowRequestItem2
      }
    }
  }
`
), $A = C(
  /* GraphQL */
  `
  fragment WorkflowItemInterface2 on WorkflowItemInterface2 {
    id
    hint
    prompt
    type
    updatedAt
    position
    options
    section {
      id
    }
    requestItem {
      ...WorkflowRequestItem2
    }
    conditions {
      ...WorkflowItemCondition2
    }
  }
`
), MA = C(
  /* GraphQL */
  `
  fragment WorkflowRequestItem on WorkflowRequestItem {
    id
    prompt
    responseType
    status
    dependency {
      ... on Invoice {
        invoiceId: id
        legacyId
        dueByDate
        isRecurring
        status
        subject
        taskType
      }
      ... on Payable {
        payableId: id
        url
        document {
          id
          uuid
          legacyId
          awsUrlFileName
        }
      }
      ... on Document {
        documentId: id
        uuid
        legacyId
      }
      ... on DynamicDependency {
        readUrl
        type
      }
    }
    responseItem {
      ...WorkflowResponseItem
    }
  }
`
), NA = C(
  /* GraphQL */
  `
  fragment WorkflowItem2 on WorkflowItemInterface2 {
    ...DefaultWorkflowItem2
    ...WorkflowSignableDocumentItem2
  }
`
), WA = C(
  /* GraphQL */
  `
  fragment DefaultWorkflowItem2 on WorkflowItemType2 {
    ... on WorkflowItemType2 {
      ...WorkflowItemInterface2
    }
  }
`
), LA = C(
  /* GraphQL */
  `
  fragment WorkflowSection on WorkflowSection {
    createdAt
    id
    title
    items2 {
      ...WorkflowItem2
    }
    updatedAt
  }
`
), QA = C(
  /* GraphQL */
  `
  fragment WorkflowSignableDocumentItem2 on WorkflowSignableDocumentItemType2 {
    ... on WorkflowSignableDocumentItemType2 {
      ...WorkflowItemInterface2
      esignAgreement {
        id
        documentToSign {
          id
        }
        signatories {
          contact {
            id
          }
          kbaRequired
          signOnSameDevice
          esignSignatureBlocks {
            pageNumber
            top
            left
            width
            height
          }
        }
        currentUserSignatory {
          id
          contact {
            id
            firstName
            lastName
          }
          firstName
          lastName
          label
          status
          email
          kbaRequired
          signOnSameDevice
          signingUrl
          signingStatusUrl
          esignSignatureBlocks {
            pageNumber
            top
            left
            width
            height
          }
        }
        sameDeviceSignatories {
          id
          contact {
            id
            firstName
            lastName
          }
          firstName
          lastName
          label
          status
          email
          kbaRequired
          signOnSameDevice
          signingUrl
          signingStatusUrl
          esignSignatureBlocks {
            pageNumber
            top
            left
            width
            height
          }
        }
        startSigningUrl
        signingAvailableUrl
      }
    }
  }
`
), BA = C(
  /* GraphQL */
  `
  fragment WorkflowResponseItem on WorkflowResponseItem {
    __typename
    id
    liscioObjects {
      id
    }
    workflowItem2 {
      ...WorkflowItem2
    }
    type
    booleanValue
    textValue
    createdAt
    updatedAt
    notApplicable
  }
`
), jA = C(
  /* GraphQL */
  `
  mutation updateResponseItemBool(
    $notApplicable: Boolean
    $booleanValue: Boolean
    $workflowResponseItemId: Uuid!
  ) {
    updateResponseItemBool(
      notApplicable: $notApplicable
      booleanValue: $booleanValue
      workflowResponseItemId: $workflowResponseItemId
    ) {
      errors {
        message
      }
      workflowResponseItem {
        id
      }
    }
  }
`
), zA = C(
  /* GraphQL */
  `
  mutation updateWorkflowRequest(
    $status: WorkflowRequestStatus
    $workflowRequestId: Uuid!
  ) {
    updateWorkflowRequest(
      status: $status
      workflowRequestId: $workflowRequestId
    ) {
      errors {
        message
      }
      workflowRequest {
        title
        id
        dueDate
        assignedContact {
          id
        }
      }
    }
  }
`
), HA = C(
  /* GraphQL */
  `
  mutation updateResponseItemDocUpload(
    $notApplicable: Boolean
    $liscioObjectData: [LiscioObjectInput!]
    $workflowResponseItemId: Uuid!
  ) {
    updateResponseItemDocUpload(
      notApplicable: $notApplicable
      liscioObjectData: $liscioObjectData
      workflowResponseItemId: $workflowResponseItemId
    ) {
      errors {
        message
      }
      workflowResponseItem {
        ...WorkflowResponseItem
      }
    }
  }
`
), JA = C(
  /* GraphQL */
  `
  mutation updateResponseItemText(
    $notApplicable: Boolean
    $textValue: String
    $workflowResponseItemId: Uuid!
  ) {
    updateResponseItemText(
      notApplicable: $notApplicable
      textValue: $textValue
      workflowResponseItemId: $workflowResponseItemId
    ) {
      errors {
        message
      }
      workflowResponseItem {
        ...WorkflowResponseItem
      }
    }
  }
`
), YA = C(
  /* GraphQL */
  `
  query workflowRequest($id: Uuid!) {
    workflowRequest(id: $id) {
      ...WorkflowRequest
    }
  }
`
), ZA = C(
  /* GraphQL */
  `
  query workflowRequestsQuery(
    $status: WorkflowRequestStatus
    $statuses: [WorkflowRequestStatus!]
    $filter: String
    $page: Int
    $perPage: Int
    $sortField: WfRequestSortOption
    $sortDirection: String
  ) {
    workflowRequests(
      status: $status
      statuses: $statuses
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortDirection: $sortDirection
    ) {
      totalCount
      collection {
        id
        title
        assignedAccount {
          id
          name
        }
        assignedContact {
          id
          firstName
          middleName
          lastName
          legacyId
          smsNumber
          smsOptIn
        }
        assignedEmployee {
          id
          firstName
          middleName
          lastName
          legacyId
        }
        owner {
          contact {
            firstName
            lastName
          }
        }
        updatedAt
        dueDate
        dueByDate
        status
        percentComplete
        updatedAt
        workflow {
          title
        }
      }
    }
  }
`
), XA = C(
  /* GraphQL */
  `
  fragment WorkflowTemplate on WorkflowTemplate {
    id
    createdAt
    updatedAt
    displayName
    status
    firm {
      id
    }
  }
`
), tg = C(
  /* GraphQL */
  `
  mutation readyToSend($workflowId: Uuid!) {
    readyToSend(workflowId: $workflowId) {
      errors {
        message
      }
      workflowRequest {
        id
      }
    }
  }
`
), eg = C(
  /* GraphQL */
  `
    mutation createWorkflowsFromWorkflowTemplateDocument($id: Uuid!) {
      createWorkflowsFromWorkflowTemplate(workflowTemplateId: $id) {
        errors {
          message
        }
        workflows {
          id
        }
      }
    }
  `
), ng = C(
  /* GraphQL */
  `
  query workflowTemplates($statuses: [WorkflowTemplateStatus!]) {
    workflowTemplates(statuses: $statuses) {
      ...WorkflowTemplate
    }
  }
`
), sg = C(
  /* GraphQl */
  `
  mutation deleteWorkflowTemplate($workflowTemplateId: Uuid!) {
    deleteWorkflowTemplate(workflowTemplateId: $workflowTemplateId) {
      errors {
        message
      }
      workflowTemplate {
        ...WorkflowTemplate
      }
    }
  }
`
), ig = C(
  /* GraphQL */
  `
  mutation updateWorkflow($status: String!, $workflowId: Uuid!) {
    updateWorkflow(status: $status, workflowId: $workflowId) {
      errors {
        message
      }
      workflow {
        id
        status
      }
    }
  }
`
), og = C(
  /* GraphQL */
  `
  query workflows(
    $status: WorkflowStatus
    $statuses: [WorkflowStatus!]
    $page: Int
    $perPage: Int
    $sortField: WorkflowSortOption
    $sortDirection: String
  ) {
    workflows(
      status: $status
      statuses: $statuses
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortDirection: $sortDirection
    ) {
      totalCount
      collection {
        id
        title
        description
        createdAt
        status
        type
        updatedAt
      }
    }
  }
`
), rg = et(
  /* GraphQL */
  `
  mutation reorderWorkflowItems(
    $workflowSectionId: Uuid!
    $workflowItemIds: [Uuid!]!
  ) {
    reorderWorkflowItems(
      workflowItemIds: $workflowItemIds
      workflowSectionId: $workflowSectionId
    ) {
      errors {
        message
      }
      workflowSection {
        id
      }
    }
  }
`
), ag = et(
  /* GraphQL */
  `
  mutation createWorkflowItem2(
    $prompt: String!
    $workflowItemType: String!
    $workflowId: Uuid
    $workflowSectionId: Uuid
    $hint: String
    $firmAuthoredContent: JSON
    $documentId: Int
  ) {
    createWorkflowItem2(
      prompt: $prompt
      workflowItemType: $workflowItemType
      workflowId: $workflowId
      workflowSectionId: $workflowSectionId
      hint: $hint
      firmAuthoredContent: $firmAuthoredContent
      documentId: $documentId
    ) {
      errors {
        message
      }
      workflowItem {
        id
        prompt
        type
        position
        hint
        responseType
        options
      }
    }
  }
`
), ug = et(
  /* GraphQL */
  `
  mutation updateWorkflowItem2(
    $workflowItemId: Uuid!
    $prompt: String!
    $hint: String
    $firmAuthoredContent: JSON
    $documentId: Int
  ) {
    updateWorkflowItem2(
      workflowItemId: $workflowItemId,
      prompt: $prompt,
      hint: $hint,
      firmAuthoredContent: $firmAuthoredContent,
      documentId: $documentId
    ) {
      errors {
        message
      }
      workflowItem {
        id
        prompt
        type
        position
        hint
        responseType
        options
      }
    }
  }
`
), cg = et(
  /* GraphQL */
  `
  mutation deleteWorkflowItem($workflowItemId: Uuid!) {
    deleteWorkflowItem(workflowItemId: $workflowItemId) {
      errors {
        message
      }
      workflowItem {
        id
      }
    }
  }
`
), mg = C(
  /* GraphQL */
  `
  query todoFeeds {
    todoFeeds {
      id
      feedItemType
      createdAt
      updatedAt
      isRead
      item {
        ...TaskFields
        ...InvoiceFields
        ...WorkflowRequestFields
      }
    }
  }

  fragment TaskFields on Task {
    __typename
    itemId: id
    legacyId
    subject
    taskType: taskSubtype
    taskStatus: status
    dueByDate
  }
  fragment InvoiceFields on Invoice {
    __typename
    itemId: id
    legacyId
    subject
    isRecurring
    invoiceStatus: status
    dueByDate
  }
  fragment WorkflowRequestFields on WorkflowRequest {
    __typename
    id
    status
    title
    percentComplete
    dueByDate
  }
`
), pg = C(
  /* GraphQL */
  `
  query FetchFirmLicense {
    fetchFirmLicense {
      id
      billingCycle
      billingStartDay
      licenseTier
      seatCount
      status
    }
  }
`
), dg = C(
  /* GraphQL */
  `
  mutation UpdateFirmLicense(
    $licenseTier: LicenseTier!
    $billingCycle: BillingCycle!
  ) {
    updateFirmLicense(licenseTier: $licenseTier, billingCycle: $billingCycle) {
      errors {
        message
      }
      firmLicense {
        id
        seatCount
        billingCycle
        licenseTier
      }
    }
  }
`
), ls = (t, e, n) => r(
  {
    url: `/api/v5/accounts/${t}/payment_estimates`,
    method: "GET",
    params: e,
    signal: n
  }
), ys = (t, e) => [`/api/v5/accounts/${t}/payment_estimates`, ...e ? [e] : []], fs = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? ys(t, e), queryFn: ({ signal: a }) => ls(t, e, a), enabled: !!t, ...s };
};
function lg(t, e, n) {
  const s = fs(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const As = (t, e) => r(
  {
    url: "/api/v5/firms/payment_estimates",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), gs = (t) => {
  const e = ["postApiV5FirmsPaymentEstimates"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return As(o);
  }, ...n };
}, yg = (t) => {
  const e = gs(t);
  return u(e);
}, hs = (t, e) => r(
  {
    url: `/api/v5/firms/payment_estimates/${t}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Fs = (t) => {
  const e = ["putApiV5FirmsPaymentEstimatesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return hs(o, a);
  }, ...n };
}, fg = (t) => {
  const e = Fs(t);
  return u(e);
}, qs = (t) => r(
  {
    url: `/api/v5/firms/payment_estimates/${t}`,
    method: "DELETE"
  }
), _s = (t) => {
  const e = ["deleteApiV5FirmsPaymentEstimatesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return qs(o);
  }, ...n };
}, Ag = (t) => {
  const e = _s(t);
  return u(e);
}, Vs = (t, e) => r(
  {
    url: `/api/v5/workflow_requests/${t}/payment_estimates`,
    method: "GET",
    signal: e
  }
), Rs = (t) => [`/api/v5/workflow_requests/${t}/payment_estimates`], Ks = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Rs(t), queryFn: ({ signal: o }) => Vs(t, o), enabled: !!t, ...n };
};
function gg(t, e) {
  const n = Ks(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ts = (t, e, n) => r(
  {
    url: `/api/v5/accounts/${t}/schedule_k1s`,
    method: "GET",
    params: e,
    signal: n
  }
), vs = (t, e) => [`/api/v5/accounts/${t}/schedule_k1s`, ...e ? [e] : []], Is = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? vs(t, e), queryFn: ({ signal: a }) => Ts(t, e, a), enabled: !!t, ...s };
};
function hg(t, e, n) {
  const s = Is(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const ws = (t, e) => r(
  {
    url: `/api/v5/accounts/${t}/tax_returns`,
    method: "GET",
    signal: e
  }
), Os = (t) => [`/api/v5/accounts/${t}/tax_returns`], ks = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Os(t), queryFn: ({ signal: o }) => ws(t, o), enabled: !!t, ...n };
};
function Fg(t, e) {
  const n = ks(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ss = (t, e, n) => r(
  {
    url: `/api/v5/accounts/${t}/tax_returns/${e}`,
    method: "GET",
    signal: n
  }
), Ds = (t, e) => [`/api/v5/accounts/${t}/tax_returns/${e}`], Ps = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Ds(t, e), queryFn: ({ signal: a }) => Ss(t, e, a), enabled: !!(t && e), ...s };
};
function qg(t, e, n) {
  const s = Ps(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Cs = (t, e) => r(
  {
    url: "/api/v5/ai_messages/generate",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Es = (t) => {
  const e = ["postApiV5AiMessagesGenerate"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Cs(o);
  }, ...n };
}, _g = (t) => {
  const e = Es(t);
  return u(e);
}, Gs = (t, e) => r(
  {
    url: "/api/v5/ai_messages/generate_reply",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), bs = (t) => {
  const e = ["postApiV5AiMessagesGenerateReply"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Gs(o);
  }, ...n };
}, Vg = (t) => {
  const e = bs(t);
  return u(e);
}, xs = (t, e) => r(
  {
    url: "/api/v5/ai_messages/demo_generate_reply",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Us = (t) => {
  const e = ["postApiV5AiMessagesDemoGenerateReply"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return xs(o);
  }, ...n };
}, Rg = (t) => {
  const e = Us(t);
  return u(e);
}, $s = (t, e) => r(
  {
    url: "/api/v5/auth/cpa_authorization",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ms = (t) => {
  const e = ["postApiV5AuthCpaAuthorization"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return $s(o);
  }, ...n };
}, Kg = (t) => {
  const e = Ms(t);
  return u(e);
}, Ns = (t, e) => r(
  {
    url: "/api/v5/auth/sign_in",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ws = (t) => {
  const e = ["postApiV5AuthSignIn"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Ns(o);
  }, ...n };
}, Tg = (t) => {
  const e = Ws(t);
  return u(e);
}, Ls = () => r(
  {
    url: "/api/v5/auth/sign_out",
    method: "DELETE"
  }
), Qs = (t) => {
  const e = ["deleteApiV5AuthSignOut"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => Ls(), ...n };
}, vg = (t) => {
  const e = Qs(t);
  return u(e);
}, Bs = (t, e) => r(
  {
    url: "/api/v5/auth/magic_links",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), js = (t) => {
  const e = ["postApiV5AuthMagicLinks"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Bs(o);
  }, ...n };
}, Ig = (t) => {
  const e = js(t);
  return u(e);
}, zs = (t, e) => r(
  {
    url: `/api/v5/auth/magic_links/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Hs = (t) => {
  const e = ["patchApiV5AuthMagicLinksId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return zs(o, a);
  }, ...n };
}, wg = (t) => {
  const e = Hs(t);
  return u(e);
}, Js = (t, e) => r(
  {
    url: "/api/v5/auth/magic_links/handoff",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ys = (t) => {
  const e = ["postApiV5AuthMagicLinksHandoff"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Js(o);
  }, ...n };
}, Og = (t) => {
  const e = Ys(t);
  return u(e);
}, Zs = (t, e) => r(
  {
    url: "/api/v5/auth/mfa",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Xs = (t) => {
  const e = ["postApiV5AuthMfa"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Zs(o);
  }, ...n };
}, kg = (t) => {
  const e = Xs(t);
  return u(e);
}, ti = (t) => r(
  {
    url: "/api/v5/auth/mfa_setups",
    method: "POST",
    signal: t
  }
), ei = (t) => {
  const e = ["postApiV5AuthMfaSetups"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => ti(), ...n };
}, Sg = (t) => {
  const e = ei(t);
  return u(e);
}, ni = (t) => r(
  {
    url: "/api/v5/auth/mfa_setups",
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: t
  }
), si = (t) => {
  const e = ["patchApiV5AuthMfaSetups"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return ni(o);
  }, ...n };
}, Dg = (t) => {
  const e = si(t);
  return u(e);
}, ii = (t) => r(
  {
    url: "/api/v5/auth/passkeys/registration_options",
    method: "POST",
    signal: t
  }
), oi = (t) => {
  const e = ["postApiV5AuthPasskeysRegistrationOptions"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => ii(), ...n };
}, Pg = (t) => {
  const e = oi(t);
  return u(e);
}, ri = (t) => r(
  {
    url: "/api/v5/auth/passkeys",
    method: "GET",
    signal: t
  }
), ai = () => ["/api/v5/auth/passkeys"], ui = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? ai(), queryFn: ({ signal: i }) => ri(i), ...e };
};
function Cg(t) {
  const e = ui(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const ci = (t, e) => r(
  {
    url: "/api/v5/auth/passkeys",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), mi = (t) => {
  const e = ["postApiV5AuthPasskeys"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return ci(o);
  }, ...n };
}, Eg = (t) => {
  const e = mi(t);
  return u(e);
}, pi = (t) => r(
  {
    url: "/api/v5/auth/passkeys/authentication_options",
    method: "POST",
    signal: t
  }
), di = (t) => {
  const e = ["postApiV5AuthPasskeysAuthenticationOptions"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => pi(), ...n };
}, Gg = (t) => {
  const e = di(t);
  return u(e);
}, li = (t, e) => r(
  {
    url: "/api/v5/auth/passkeys/sign_in",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), yi = (t) => {
  const e = ["postApiV5AuthPasskeysSignIn"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return li(o);
  }, ...n };
}, bg = (t) => {
  const e = yi(t);
  return u(e);
}, fi = (t, e) => r(
  {
    url: `/api/v5/auth/passkeys/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Ai = (t) => {
  const e = ["patchApiV5AuthPasskeysId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return fi(o, a);
  }, ...n };
}, xg = (t) => {
  const e = Ai(t);
  return u(e);
}, gi = (t) => r(
  {
    url: `/api/v5/auth/passkeys/${t}`,
    method: "DELETE"
  }
), hi = (t) => {
  const e = ["deleteApiV5AuthPasskeysId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return gi(o);
  }, ...n };
}, Ug = (t) => {
  const e = hi(t);
  return u(e);
}, Fi = (t, e) => r(
  {
    url: "/api/v5/auth/password_reset_tokens",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), qi = (t) => {
  const e = ["postApiV5AuthPasswordResetTokens"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Fi(o);
  }, ...n };
}, $g = (t) => {
  const e = qi(t);
  return u(e);
}, _i = (t, e) => r(
  {
    url: "/api/v5/auth/password_resets",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Vi = (t) => {
  const e = ["postApiV5AuthPasswordResets"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return _i(o);
  }, ...n };
}, Mg = (t) => {
  const e = Vi(t);
  return u(e);
}, Ri = (t, e) => r(
  {
    url: `/api/v5/auth/password_resets/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Ki = (t) => {
  const e = ["patchApiV5AuthPasswordResetsResetToken"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { resetToken: o, data: a } = i ?? {};
    return Ri(o, a);
  }, ...n };
}, Ng = (t) => {
  const e = Ki(t);
  return u(e);
}, Ti = (t) => r(
  {
    url: "/api/v5/auth/passwords",
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: t
  }
), vi = (t) => {
  const e = ["putApiV5AuthPasswords"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Ti(o);
  }, ...n };
}, Wg = (t) => {
  const e = vi(t);
  return u(e);
}, Ii = (t, e) => r(
  {
    url: "/api/v5/auth/self_signup_invitations/validate",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), wi = (t) => {
  const e = ["postApiV5AuthSelfSignupInvitationsValidate"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Ii(o);
  }, ...n };
}, Lg = (t) => {
  const e = wi(t);
  return u(e);
}, Oi = (t, e) => r(
  {
    url: "/api/v5/auth/self_signup_sso",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), ki = (t) => {
  const e = ["postApiV5AuthSelfSignupSso"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Oi(o);
  }, ...n };
}, Qg = (t) => {
  const e = ki(t);
  return u(e);
}, Si = (t) => r(
  {
    url: "/api/v5/auth/sessions",
    method: "GET",
    signal: t
  }
), Di = () => ["/api/v5/auth/sessions"], Pi = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? Di(), queryFn: ({ signal: i }) => Si(i), ...e };
};
function Bg(t) {
  const e = Pi(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Ci = (t, e) => r(
  {
    url: "/api/v5/auth/sign_in_sso",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ei = (t) => {
  const e = ["postApiV5AuthSignInSso"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Ci(o);
  }, ...n };
}, jg = (t) => {
  const e = Ei(t);
  return u(e);
}, Gi = (t, e) => r(
  {
    url: "/api/v5/auth/sign_up_sso",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), bi = (t) => {
  const e = ["postApiV5AuthSignUpSso"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Gi(o);
  }, ...n };
}, zg = (t) => {
  const e = bi(t);
  return u(e);
}, xi = (t) => r(
  {
    url: "/api/v5/me",
    method: "GET",
    signal: t
  }
), Ui = () => ["/api/v5/me"], $i = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? Ui(), queryFn: ({ signal: i }) => xi(i), ...e };
};
function Hg(t) {
  const e = $i(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Mi = (t, e) => r(
  {
    url: "/api/v5/auth/cpa_switcher",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ni = (t) => {
  const e = ["postApiV5AuthCpaSwitcher"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Mi(o);
  }, ...n };
}, Jg = (t) => {
  const e = Ni(t);
  return u(e);
}, Wi = (t, e) => r(
  {
    url: "/api/v5/firms/cpa_switcher",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Li = (t) => {
  const e = ["postApiV5FirmsCpaSwitcher"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Wi(o);
  }, ...n };
}, Yg = (t) => {
  const e = Li(t);
  return u(e);
}, Qi = (t, e) => r(
  {
    url: "/api/v5/clients/contacts",
    method: "GET",
    params: t,
    signal: e
  }
), Bi = (t) => ["/api/v5/clients/contacts", ...t ? [t] : []], ji = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Bi(t), queryFn: ({ signal: o }) => Qi(t, o), ...n };
};
function Zg(t, e) {
  const n = ji(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const zi = (t, e) => r(
  {
    url: "/api/v5/clients/contacts/grouped_by_account",
    method: "GET",
    params: t,
    signal: e
  }
), Hi = (t) => ["/api/v5/clients/contacts/grouped_by_account", ...t ? [t] : []], Ji = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Hi(t), queryFn: ({ signal: o }) => zi(t, o), ...n };
};
function Xg(t, e) {
  const n = Ji(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Yi = (t, e) => r(
  {
    url: "/api/v5/clients/contacts/recipient_accounts",
    method: "GET",
    params: t,
    signal: e
  }
), Zi = (t) => ["/api/v5/clients/contacts/recipient_accounts", ...t ? [t] : []], Xi = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Zi(t), queryFn: ({ signal: o }) => Yi(t, o), ...n };
};
function th(t, e) {
  const n = Xi(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const to = (t, e) => r(
  {
    url: `/api/v5/clients/esign_agreement_signatories/${t}/signing_status`,
    method: "GET",
    signal: e
  }
), eo = (t) => [`/api/v5/clients/esign_agreement_signatories/${t}/signing_status`], no = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? eo(t), queryFn: ({ signal: o }) => to(t, o), enabled: !!t, ...n };
};
function eh(t, e) {
  const n = no(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const so = (t, e) => r(
  {
    url: `/api/v5/clients/esign_agreements/${t}/signing_status`,
    method: "GET",
    signal: e
  }
), io = (t) => [`/api/v5/clients/esign_agreements/${t}/signing_status`], oo = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? io(t), queryFn: ({ signal: o }) => so(t, o), enabled: !!t, ...n };
};
function nh(t, e) {
  const n = oo(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const ro = (t, e) => r(
  {
    url: `/api/v5/clients/esign_agreements/${t}/signing_urls`,
    method: "POST",
    signal: e
  }
), ao = (t) => {
  const e = ["postApiV5ClientsEsignAgreementsIdSigningUrls"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return ro(o);
  }, ...n };
}, sh = (t) => {
  const e = ao(t);
  return u(e);
}, uo = (t, e) => r(
  {
    url: `/api/v5/clients/esign_agreements/${t}/signing_urls`,
    method: "GET",
    signal: e
  }
), co = (t) => [`/api/v5/clients/esign_agreements/${t}/signing_urls`], mo = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? co(t), queryFn: ({ signal: o }) => uo(t, o), enabled: !!t, ...n };
};
function ih(t, e) {
  const n = mo(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const po = (t, e) => r(
  {
    url: `/api/v5/firms/esign_agreement_signatories/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), lo = (t) => {
  const e = ["patchApiV5FirmsEsignAgreementSignatoriesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return po(o, a);
  }, ...n };
}, oh = (t) => {
  const e = lo(t);
  return u(e);
}, yo = (t, e) => r(
  {
    url: `/api/v5/firms/signers/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), fo = (t) => {
  const e = ["patchApiV5FirmsSignersId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return yo(o, a);
  }, ...n };
}, rh = (t) => {
  const e = fo(t);
  return u(e);
}, Ao = (t, e) => r(
  {
    url: `/api/v5/clients/requests/${t}`,
    method: "GET",
    signal: e
  }
), go = (t) => [`/api/v5/clients/requests/${t}`], ho = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? go(t), queryFn: ({ signal: o }) => Ao(t, o), enabled: !!t, ...n };
};
function ah(t, e) {
  const n = ho(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Fo = (t, e) => r(
  {
    url: `/api/v5/clients/workflow_requests/${t}/tax_return/todos`,
    method: "GET",
    signal: e
  }
), qo = (t) => [`/api/v5/clients/workflow_requests/${t}/tax_return/todos`], _o = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? qo(t), queryFn: ({ signal: o }) => Fo(t, o), enabled: !!t, ...n };
};
function uh(t, e) {
  const n = _o(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Vo = (t, e) => r(
  {
    url: `/api/v5/clients/workflow_requests/${t}/tax_return`,
    method: "GET",
    signal: e
  }
), Ro = (t) => [`/api/v5/clients/workflow_requests/${t}/tax_return`], Ko = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ro(t), queryFn: ({ signal: o }) => Vo(t, o), enabled: !!t, ...n };
};
function ch(t, e) {
  const n = Ko(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const To = (t, e, n) => r(
  {
    url: `/api/v5/clients/rfi/requests/${t}/attachments`,
    method: "GET",
    params: e,
    signal: n
  }
), vo = (t, e) => [`/api/v5/clients/rfi/requests/${t}/attachments`, ...e ? [e] : []], Io = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? vo(t, e), queryFn: ({ signal: a }) => To(t, e, a), enabled: !!t, ...s };
};
function mh(t, e, n) {
  const s = Io(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const wo = (t, e, n) => r(
  {
    url: `/api/v5/clients/rfi/requests/${t}/attachments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), Oo = (t) => {
  const e = ["postApiV5ClientsRfiRequestsRequestUuidAttachments"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, data: a } = i ?? {};
    return wo(o, a);
  }, ...n };
}, ph = (t) => {
  const e = Oo(t);
  return u(e);
}, ko = (t, e) => r(
  {
    url: `/api/v5/clients/rfi/attachments/${t}`,
    method: "GET",
    signal: e
  }
), So = (t) => [`/api/v5/clients/rfi/attachments/${t}`], Do = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? So(t), queryFn: ({ signal: o }) => ko(t, o), enabled: !!t, ...n };
};
function dh(t, e) {
  const n = Do(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Po = (t) => r(
  {
    url: `/api/v5/clients/rfi/attachments/${t}`,
    method: "DELETE"
  }
), Co = (t) => {
  const e = ["deleteApiV5ClientsRfiAttachmentsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Po(o);
  }, ...n };
}, lh = (t) => {
  const e = Co(t);
  return u(e);
}, Eo = (t, e) => r(
  {
    url: "/api/v5/clients/rfi/direct_uploads",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Go = (t) => {
  const e = ["postApiV5ClientsRfiDirectUploads"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Eo(o);
  }, ...n };
}, yh = (t) => {
  const e = Go(t);
  return u(e);
}, bo = (t, e) => r(
  {
    url: `/api/v5/clients/rfi/requests/${t}/items`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), xo = (t) => {
  const e = ["patchApiV5ClientsRfiRequestsRequestUuidItems"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, data: a } = i ?? {};
    return bo(o, a);
  }, ...n };
}, fh = (t) => {
  const e = xo(t);
  return u(e);
}, Uo = (t) => r(
  {
    url: "/api/v5/clients/rfi/requests",
    method: "GET",
    signal: t
  }
), $o = () => ["/api/v5/clients/rfi/requests"], Mo = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? $o(), queryFn: ({ signal: i }) => Uo(i), ...e };
};
function Ah(t) {
  const e = Mo(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const No = (t, e) => r(
  {
    url: `/api/v5/clients/rfi/requests/${t}`,
    method: "GET",
    signal: e
  }
), Wo = (t) => [`/api/v5/clients/rfi/requests/${t}`], Lo = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Wo(t), queryFn: ({ signal: o }) => No(t, o), enabled: !!t, ...n };
};
function gh(t, e) {
  const n = Lo(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Qo = (t, e, n) => r(
  {
    url: `/api/v5/clients/rfi/requests/${t}/submit`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), Bo = (t) => {
  const e = ["postApiV5ClientsRfiRequestsUuidSubmit"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o, data: a } = i ?? {};
    return Qo(o, a);
  }, ...n };
}, hh = (t) => {
  const e = Bo(t);
  return u(e);
}, jo = (t, e, n) => r(
  {
    url: `/api/v5/clients/rfi/requests/${t}/to_pdf`,
    method: "GET",
    params: e,
    responseType: "blob",
    signal: n
  }
), zo = (t, e) => [`/api/v5/clients/rfi/requests/${t}/to_pdf`, ...e ? [e] : []], Ho = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? zo(t, e), queryFn: ({ signal: a }) => jo(t, e, a), enabled: !!t, ...s };
};
function Fh(t, e, n) {
  const s = Ho(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Jo = (t, e) => r(
  {
    url: "/api/v5/documents/signed_urls",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Yo = (t) => {
  const e = ["postApiV5DocumentsSignedUrls"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Jo(o);
  }, ...n };
}, qh = (t) => {
  const e = Yo(t);
  return u(e);
}, Zo = (t, e) => r(
  {
    url: "/api/v5/firms/documents/liscio_vault",
    method: "GET",
    params: t,
    signal: e
  }
), Xo = (t) => ["/api/v5/firms/documents/liscio_vault", ...t ? [t] : []], tr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Xo(t), queryFn: ({ signal: o }) => Zo(t, o), ...n };
};
function _h(t, e) {
  const n = tr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const er = (t) => r(
  {
    url: "/api/v5/experiences",
    method: "GET",
    signal: t
  }
), nr = () => ["/api/v5/experiences"], sr = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? nr(), queryFn: ({ signal: i }) => er(i), ...e };
};
function Vh(t) {
  const e = sr(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const ir = (t, e) => r(
  {
    url: `/api/v5/experiences/${t}`,
    method: "GET",
    signal: e
  }
), or = (t) => [`/api/v5/experiences/${t}`], rr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? or(t), queryFn: ({ signal: o }) => ir(t, o), enabled: !!t, ...n };
};
function Rh(t, e) {
  const n = rr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const ar = (t, e) => r(
  {
    url: `/api/v5/experiences/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), ur = (t) => {
  const e = ["patchApiV5ExperiencesExperienceId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { experienceId: o, data: a } = i ?? {};
    return ar(o, a);
  }, ...n };
}, Kh = (t) => {
  const e = ur(t);
  return u(e);
}, cr = (t, e) => r(
  {
    url: "/api/v5/files/preferred_format",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), mr = (t) => {
  const e = ["postApiV5FilesPreferredFormat"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return cr(o);
  }, ...n };
}, Th = (t) => {
  const e = mr(t);
  return u(e);
}, pr = (t) => r(
  {
    url: "/api/v5/files/preferred_format",
    method: "GET",
    signal: t
  }
), dr = () => ["/api/v5/files/preferred_format"], lr = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? dr(), queryFn: ({ signal: i }) => pr(i), ...e };
};
function vh(t) {
  const e = lr(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const yr = (t) => r(
  {
    url: "/api/v5/files/naming_config",
    method: "GET",
    signal: t
  }
), fr = () => ["/api/v5/files/naming_config"], Ar = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? fr(), queryFn: ({ signal: i }) => yr(i), ...e };
};
function Ih(t) {
  const e = Ar(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const gr = (t, e) => r(
  {
    url: `/api/v5/files/${t}/naming_suggestions`,
    method: "GET",
    signal: e
  }
), hr = (t) => [`/api/v5/files/${t}/naming_suggestions`], Fr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? hr(t), queryFn: ({ signal: o }) => gr(t, o), enabled: !!t, ...n };
};
function wh(t, e) {
  const n = Fr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const qr = (t, e) => r(
  {
    url: `/api/v5/files/${t}/undo_auto_name`,
    method: "POST",
    signal: e
  }
), _r = (t) => {
  const e = ["postApiV5FilesIdUndoAutoName"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return qr(o);
  }, ...n };
}, Oh = (t) => {
  const e = _r(t);
  return u(e);
}, Vr = (t, e, n) => r(
  {
    url: `/api/v5/files/${t}/accept_naming_suggestion`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), Rr = (t) => {
  const e = ["postApiV5FilesIdAcceptNamingSuggestion"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return Vr(o, a);
  }, ...n };
}, kh = (t) => {
  const e = Rr(t);
  return u(e);
}, Kr = (t, e) => r(
  {
    url: `/api/v5/files/${t}/tag_suggestions`,
    method: "GET",
    signal: e
  }
), Tr = (t) => [`/api/v5/files/${t}/tag_suggestions`], vr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Tr(t), queryFn: ({ signal: o }) => Kr(t, o), enabled: !!t, ...n };
};
function Sh(t, e) {
  const n = vr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ir = (t, e) => r(
  {
    url: `/api/v5/files/${t}/rename`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), wr = (t) => {
  const e = ["putApiV5FilesIdRename"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return Ir(o, a);
  }, ...n };
}, Dh = (t) => {
  const e = wr(t);
  return u(e);
}, Or = (t) => r(
  {
    url: `/api/v5/files/${t}/mark_as_reviewed`,
    method: "PUT"
  }
), kr = (t) => {
  const e = ["putApiV5FilesIdMarkAsReviewed"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Or(o);
  }, ...n };
}, Ph = (t) => {
  const e = kr(t);
  return u(e);
}, Sr = (t, e) => r(
  {
    url: "/api/v5/files/pending_review",
    method: "GET",
    params: t,
    signal: e
  }
), Dr = (t) => ["/api/v5/files/pending_review", ...t ? [t] : []], Pr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Dr(t), queryFn: ({ signal: o }) => Sr(t, o), ...n };
};
function Ch(t, e) {
  const n = Pr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Cr = (t, e) => r(
  {
    url: `/api/v5/files/${t}/update_tags`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Er = (t) => {
  const e = ["putApiV5FilesIdUpdateTags"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return Cr(o, a);
  }, ...n };
}, Eh = (t) => {
  const e = Er(t);
  return u(e);
}, Gr = (t, e) => r(
  {
    url: "/api/v5/firm_pain_point_selections",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), br = (t) => {
  const e = ["postApiV5FirmPainPointSelections"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Gr(o);
  }, ...n };
}, Gh = (t) => {
  const e = br(t);
  return u(e);
}, xr = (t) => r(
  {
    url: "/api/v5/firm_pain_point_selections",
    method: "GET",
    signal: t
  }
), Ur = () => ["/api/v5/firm_pain_point_selections"], $r = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? Ur(), queryFn: ({ signal: i }) => xr(i), ...e };
};
function bh(t) {
  const e = $r(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Mr = (t, e) => r(
  {
    url: "/api/v5/firms/accounts",
    method: "GET",
    params: t,
    signal: e
  }
), Nr = (t) => ["/api/v5/firms/accounts", ...t ? [t] : []], Wr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Nr(t), queryFn: ({ signal: o }) => Mr(t, o), ...n };
};
function xh(t, e) {
  const n = Wr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Lr = (t, e) => r(
  {
    url: "/api/v5/firms/accounts",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Qr = (t) => {
  const e = ["postApiV5FirmsAccounts"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Lr(o);
  }, ...n };
}, Uh = (t) => {
  const e = Qr(t);
  return u(e);
}, Br = (t, e) => r(
  {
    url: `/api/v5/firms/accounts/${t}`,
    method: "GET",
    signal: e
  }
), jr = (t) => [`/api/v5/firms/accounts/${t}`], zr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? jr(t), queryFn: ({ signal: o }) => Br(t, o), enabled: !!t, ...n };
};
function $h(t, e) {
  const n = zr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Hr = (t, e) => r(
  {
    url: `/api/v5/firms/accounts/${t}/unused_jurisdictions`,
    method: "GET",
    signal: e
  }
), Jr = (t) => [`/api/v5/firms/accounts/${t}/unused_jurisdictions`], Yr = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Jr(t), queryFn: ({ signal: o }) => Hr(t, o), enabled: !!t, ...n };
};
function Mh(t, e) {
  const n = Yr(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Zr = (t, e) => r(
  {
    url: `/api/v5/firms/admin/cpa_settings/${t}`,
    method: "GET",
    signal: e
  }
), Xr = (t) => [`/api/v5/firms/admin/cpa_settings/${t}`], ta = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Xr(t), queryFn: ({ signal: o }) => Zr(t, o), enabled: !!t, ...n };
};
function Nh(t, e) {
  const n = ta(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const ea = (t, e) => r(
  {
    url: `/api/v5/firms/admin/cpa_settings/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), na = (t) => {
  const e = ["patchApiV5FirmsAdminCpaSettingsKey"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { key: o, data: a } = i ?? {};
    return ea(o, a);
  }, ...n };
}, Wh = (t) => {
  const e = na(t);
  return u(e);
}, sa = (t) => r(
  {
    url: "/api/v5/firms/admin/zapier_config",
    method: "GET",
    signal: t
  }
), ia = () => ["/api/v5/firms/admin/zapier_config"], oa = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? ia(), queryFn: ({ signal: i }) => sa(i), ...e };
};
function Lh(t) {
  const e = oa(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const ra = (t, e) => r(
  {
    url: "/api/v5/firms/zapier/exports",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), aa = (t) => {
  const e = ["postApiV5FirmsZapierExports"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return ra(o);
  }, ...n };
}, Qh = (t) => {
  const e = aa(t);
  return u(e);
}, ua = (t, e) => r(
  {
    url: "/api/v5/firms/app_connections/dms/file_exports",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), ca = (t) => {
  const e = ["postApiV5FirmsAppConnectionsDmsFileExports"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return ua(o);
  }, ...n };
}, Bh = (t) => {
  const e = ca(t);
  return u(e);
}, ma = (t, e) => r(
  {
    url: "/api/v5/firms/app_connections/dms/file_exports/status",
    method: "GET",
    params: t,
    signal: e
  }
), pa = (t) => ["/api/v5/firms/app_connections/dms/file_exports/status", ...t ? [t] : []], da = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? pa(t), queryFn: ({ signal: o }) => ma(t, o), ...n };
};
function jh(t, e) {
  const n = da(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const la = (t, e) => r(
  {
    url: `/api/v5/firms/app_connections/oauth/access_tokens/${t}`,
    method: "GET",
    signal: e
  }
), ya = (t) => [`/api/v5/firms/app_connections/oauth/access_tokens/${t}`], fa = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? ya(t), queryFn: ({ signal: o }) => la(t, o), enabled: !!t, ...n };
};
function zh(t, e) {
  const n = fa(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Aa = (t) => r(
  {
    url: "/api/v5/firms/app_connections/sharepoint/export_settings",
    method: "GET",
    signal: t
  }
), ga = () => ["/api/v5/firms/app_connections/sharepoint/export_settings"], ha = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? ga(), queryFn: ({ signal: i }) => Aa(i), ...e };
};
function Hh(t) {
  const e = ha(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Fa = (t) => r(
  {
    url: "/api/v5/firms/app_connections/smart_vault/access_token",
    method: "GET",
    signal: t
  }
), qa = () => ["/api/v5/firms/app_connections/smart_vault/access_token"], _a = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? qa(), queryFn: ({ signal: i }) => Fa(i), ...e };
};
function Jh(t) {
  const e = _a(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Va = (t) => r(
  {
    url: "/api/v5/firms/app_connections/smart_vault/clients/synchronization",
    method: "POST",
    signal: t
  }
), Ra = (t) => {
  const e = ["postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => Va(), ...n };
}, Yh = (t) => {
  const e = Ra(t);
  return u(e);
}, Ka = (t, e) => r(
  {
    url: "/api/v5/firms/workflow_requests/bulk_dispatch",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ta = (t) => {
  const e = ["postApiV5FirmsWorkflowRequestsBulkDispatch"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Ka(o);
  }, ...n };
}, Zh = (t) => {
  const e = Ta(t);
  return u(e);
}, va = (t, e) => r(
  {
    url: "/api/v5/firms/requests/bulk_update",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ia = (t) => {
  const e = ["postApiV5FirmsRequestsBulkUpdate"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return va(o);
  }, ...n };
}, Xh = (t) => {
  const e = Ia(t);
  return u(e);
}, wa = (t, e) => r(
  {
    url: "/api/v5/firms/requests",
    method: "GET",
    params: t,
    signal: e
  }
), Oa = (t) => ["/api/v5/firms/requests", ...t ? [t] : []], ka = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Oa(t), queryFn: ({ signal: o }) => wa(t, o), ...n };
};
function tF(t, e) {
  const n = ka(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Sa = (t, e) => r(
  {
    url: `/api/v5/firms/requests/${t}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Da = (t) => {
  const e = ["putApiV5FirmsRequestsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return Sa(o, a);
  }, ...n };
}, eF = (t) => {
  const e = Da(t);
  return u(e);
}, Pa = (t, e) => r(
  {
    url: `/api/v5/firms/requests/${t}`,
    method: "GET",
    signal: e
  }
), Ca = (t) => [`/api/v5/firms/requests/${t}`], Ea = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ca(t), queryFn: ({ signal: o }) => Pa(t, o), enabled: !!t, ...n };
};
function nF(t, e) {
  const n = Ea(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ga = (t) => r(
  {
    url: `/api/v5/firms/requests/${t}`,
    method: "DELETE"
  }
), ba = (t) => {
  const e = ["deleteApiV5FirmsRequestsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Ga(o);
  }, ...n };
}, sF = (t) => {
  const e = ba(t);
  return u(e);
}, xa = (t, e) => r(
  {
    url: `/api/v5/firms/requests/${t}/recall`,
    method: "POST",
    signal: e
  }
), Ua = (t) => {
  const e = ["postApiV5FirmsRequestsIdRecall"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return xa(o);
  }, ...n };
}, iF = (t) => {
  const e = Ua(t);
  return u(e);
}, $a = (t, e) => r(
  {
    url: `/api/v5/firms/requests/${t}/close`,
    method: "POST",
    signal: e
  }
), Ma = (t) => {
  const e = ["postApiV5FirmsRequestsIdClose"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return $a(o);
  }, ...n };
}, oF = (t) => {
  const e = Ma(t);
  return u(e);
}, Na = (t, e) => r(
  {
    url: `/api/v5/firms/requests/${t}/archive`,
    method: "POST",
    signal: e
  }
), Wa = (t) => {
  const e = ["postApiV5FirmsRequestsIdArchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Na(o);
  }, ...n };
}, rF = (t) => {
  const e = Wa(t);
  return u(e);
}, La = (t, e, n) => r(
  {
    url: `/api/v5/firms/requests/${t}/reopen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), Qa = (t) => {
  const e = ["postApiV5FirmsRequestsIdReopen"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return La(o, a);
  }, ...n };
}, aF = (t) => {
  const e = Qa(t);
  return u(e);
}, Ba = (t, e) => r(
  {
    url: `/api/v5/firms/requests/${t}/zip`,
    method: "POST",
    signal: e
  }
), ja = (t) => {
  const e = ["postApiV5FirmsRequestsIdZip"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Ba(o);
  }, ...n };
}, uF = (t) => {
  const e = ja(t);
  return u(e);
}, za = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/archive",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ha = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsArchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return za(o);
  }, ...n };
}, cF = (t) => {
  const e = Ha(t);
  return u(e);
}, Ja = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/unarchive",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ya = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsUnarchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Ja(o);
  }, ...n };
}, mF = (t) => {
  const e = Ya(t);
  return u(e);
}, Za = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/delete",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Xa = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsDelete"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Za(o);
  }, ...n };
}, pF = (t) => {
  const e = Xa(t);
  return u(e);
}, tu = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/share",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), eu = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsShare"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return tu(o);
  }, ...n };
}, dF = (t) => {
  const e = eu(t);
  return u(e);
}, nu = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/route_to_smart_tax",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), su = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsRouteToSmartTax"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return nu(o);
  }, ...n };
}, lF = (t) => {
  const e = su(t);
  return u(e);
}, iu = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/mark_as_reviewed",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), ou = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsMarkAsReviewed"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return iu(o);
  }, ...n };
}, yF = (t) => {
  const e = ou(t);
  return u(e);
}, ru = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/update_metadata",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), au = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsUpdateMetadata"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return ru(o);
  }, ...n };
}, fF = (t) => {
  const e = au(t);
  return u(e);
}, uu = (t, e) => r(
  {
    url: "/api/v5/firms/bulk_documents/move",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), cu = (t) => {
  const e = ["postApiV5FirmsBulkDocumentsMove"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return uu(o);
  }, ...n };
}, AF = (t) => {
  const e = cu(t);
  return u(e);
}, mu = (t, e) => r(
  {
    url: "/api/v5/firms/contacts",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), pu = (t) => {
  const e = ["postApiV5FirmsContacts"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return mu(o);
  }, ...n };
}, gF = (t) => {
  const e = pu(t);
  return u(e);
}, du = (t, e) => r(
  {
    url: `/api/v5/firms/contacts/${t}`,
    method: "GET",
    signal: e
  }
), lu = (t) => [`/api/v5/firms/contacts/${t}`], yu = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? lu(t), queryFn: ({ signal: o }) => du(t, o), enabled: !!t, ...n };
};
function hF(t, e) {
  const n = yu(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const fu = (t, e) => r(
  {
    url: `/api/v5/firms/contacts/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Au = (t) => {
  const e = ["patchApiV5FirmsContactsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return fu(o, a);
  }, ...n };
}, FF = (t) => {
  const e = Au(t);
  return u(e);
}, gu = (t) => r(
  {
    url: "/api/v5/firms/contacts/accounts",
    method: "GET",
    signal: t
  }
), hu = () => ["/api/v5/firms/contacts/accounts"], Fu = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? hu(), queryFn: ({ signal: i }) => gu(i), ...e };
};
function qF(t) {
  const e = Fu(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const qu = (t, e) => r(
  {
    url: "/api/v5/firms/contacts/for_accounts",
    method: "GET",
    params: t,
    signal: e
  }
), _u = (t) => ["/api/v5/firms/contacts/for_accounts", ...t ? [t] : []], Vu = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? _u(t), queryFn: ({ signal: o }) => qu(t, o), ...n };
};
function _F(t, e) {
  const n = Vu(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ru = (t, e) => r(
  {
    url: "/api/v5/firms/contacts/suggestions",
    method: "GET",
    params: t,
    signal: e
  }
), Ku = (t) => ["/api/v5/firms/contacts/suggestions", ...t ? [t] : []], Tu = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ku(t), queryFn: ({ signal: o }) => Ru(t, o), ...n };
};
function VF(t, e) {
  const n = Tu(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const vu = (t, e) => r(
  {
    url: "/api/v5/firms/contacts/grouped_by_account",
    method: "GET",
    params: t,
    signal: e
  }
), Iu = (t) => ["/api/v5/firms/contacts/grouped_by_account", ...t ? [t] : []], wu = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Iu(t), queryFn: ({ signal: o }) => vu(t, o), ...n };
};
function RF(t, e) {
  const n = wu(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ou = (t, e) => r(
  {
    url: "/api/v5/firms/contacts/recipient_accounts",
    method: "GET",
    params: t,
    signal: e
  }
), ku = (t) => ["/api/v5/firms/contacts/recipient_accounts", ...t ? [t] : []], Su = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? ku(t), queryFn: ({ signal: o }) => Ou(t, o), ...n };
};
function KF(t, e) {
  const n = Su(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Du = (t, e) => r(
  {
    url: "/api/v5/firms/contacts/search",
    method: "GET",
    params: t,
    signal: e
  }
), Pu = (t) => ["/api/v5/firms/contacts/search", ...t ? [t] : []], Cu = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Pu(t), queryFn: ({ signal: o }) => Du(t, o), ...n };
};
function TF(t, e) {
  const n = Cu(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Eu = (t, e) => r(
  {
    url: `/api/v5/firms/contacts/${t}/accounts`,
    method: "GET",
    signal: e
  }
), Gu = (t) => [`/api/v5/firms/contacts/${t}/accounts`], bu = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Gu(t), queryFn: ({ signal: o }) => Eu(t, o), enabled: !!t, ...n };
};
function vF(t, e) {
  const n = bu(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const xu = (t, e) => r(
  {
    url: "/api/v5/firms/cpa_workflow_templates/bulk",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Uu = (t) => {
  const e = ["postApiV5FirmsCpaWorkflowTemplatesBulk"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return xu(o);
  }, ...n };
}, IF = (t) => {
  const e = Uu(t);
  return u(e);
}, $u = (t) => r(
  {
    url: "/api/v5/firms/cpa_workflow_templates/bulk",
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: t
  }
), Mu = (t) => {
  const e = ["putApiV5FirmsCpaWorkflowTemplatesBulk"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return $u(o);
  }, ...n };
}, wF = (t) => {
  const e = Mu(t);
  return u(e);
}, Nu = (t) => r(
  {
    url: "/api/v5/firms/cpa_workflow_templates",
    method: "GET",
    signal: t
  }
), Wu = () => ["/api/v5/firms/cpa_workflow_templates"], Lu = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? Wu(), queryFn: ({ signal: i }) => Nu(i), ...e };
};
function OF(t) {
  const e = Lu(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Qu = (t, e) => r(
  {
    url: "/api/v5/firms/cpa_workflow_templates",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Bu = (t) => {
  const e = ["postApiV5FirmsCpaWorkflowTemplates"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Qu(o);
  }, ...n };
}, kF = (t) => {
  const e = Bu(t);
  return u(e);
}, ju = (t, e) => r(
  {
    url: `/api/v5/firms/cpa_workflow_templates/${t}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), zu = (t) => {
  const e = ["putApiV5FirmsCpaWorkflowTemplatesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return ju(o, a);
  }, ...n };
}, SF = (t) => {
  const e = zu(t);
  return u(e);
}, Hu = (t) => r(
  {
    url: `/api/v5/firms/cpa_workflow_templates/${t}`,
    method: "DELETE"
  }
), Ju = (t) => {
  const e = ["deleteApiV5FirmsCpaWorkflowTemplatesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Hu(o);
  }, ...n };
}, DF = (t) => {
  const e = Ju(t);
  return u(e);
}, Yu = (t, e) => r(
  {
    url: "/api/v5/firms/dashboard_widget_preferences",
    method: "GET",
    params: t,
    signal: e
  }
), Zu = (t) => ["/api/v5/firms/dashboard_widget_preferences", ...t ? [t] : []], Xu = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Zu(t), queryFn: ({ signal: o }) => Yu(t, o), ...n };
};
function PF(t, e) {
  const n = Xu(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const tc = (t, e) => r(
  {
    url: `/api/v5/firms/dashboard_widget_preferences/${t}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), ec = (t) => {
  const e = ["putApiV5FirmsDashboardWidgetPreferencesWidgetKey"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { widgetKey: o, data: a } = i ?? {};
    return tc(o, a);
  }, ...n };
}, CF = (t) => {
  const e = ec(t);
  return u(e);
}, nc = (t) => r(
  {
    url: "/api/v5/firms/file_naming_templates",
    method: "GET",
    signal: t
  }
), sc = () => ["/api/v5/firms/file_naming_templates"], ic = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? sc(), queryFn: ({ signal: i }) => nc(i), ...e };
};
function EF(t) {
  const e = ic(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const oc = (t, e) => r(
  {
    url: `/api/v5/firms/file_naming_templates/${t}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), rc = (t) => {
  const e = ["putApiV5FirmsFileNamingTemplatesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return oc(o, a);
  }, ...n };
}, GF = (t) => {
  const e = rc(t);
  return u(e);
}, ac = (t, e) => r(
  {
    url: `/api/v5/firms/documents/${t}/annotation`,
    method: "GET",
    signal: e
  }
), uc = (t) => [`/api/v5/firms/documents/${t}/annotation`], cc = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? uc(t), queryFn: ({ signal: o }) => ac(t, o), enabled: !!t, ...n };
};
function bF(t, e) {
  const n = cc(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const mc = (t, e) => r(
  {
    url: `/api/v5/firms/documents/${t}/annotation`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), pc = (t) => {
  const e = ["putApiV5FirmsDocumentsDocumentUuidAnnotation"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { documentUuid: o, data: a } = i ?? {};
    return mc(o, a);
  }, ...n };
}, xF = (t) => {
  const e = pc(t);
  return u(e);
}, dc = (t, e) => r(
  {
    url: `/api/v5/firms/documents/${t}/rotation`,
    method: "GET",
    signal: e
  }
), lc = (t) => [`/api/v5/firms/documents/${t}/rotation`], yc = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? lc(t), queryFn: ({ signal: o }) => dc(t, o), enabled: !!t, ...n };
};
function UF(t, e) {
  const n = yc(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const fc = (t, e) => r(
  {
    url: `/api/v5/firms/documents/${t}/rotation`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Ac = (t) => {
  const e = ["putApiV5FirmsDocumentsDocumentUuidRotation"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { documentUuid: o, data: a } = i ?? {};
    return fc(o, a);
  }, ...n };
}, $F = (t) => {
  const e = Ac(t);
  return u(e);
}, gc = (t) => r(
  {
    url: "/api/v5/firms/documents/document_types",
    method: "GET",
    signal: t
  }
), hc = () => ["/api/v5/firms/documents/document_types"], Fc = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? hc(), queryFn: ({ signal: i }) => gc(i), ...e };
};
function MF(t) {
  const e = Fc(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const qc = (t, e) => r(
  {
    url: `/api/v5/firms/documents/${t}`,
    method: "GET",
    signal: e
  }
), _c = (t) => [`/api/v5/firms/documents/${t}`], Vc = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? _c(t), queryFn: ({ signal: o }) => qc(t, o), enabled: !!t, ...n };
};
function NF(t, e) {
  const n = Vc(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Rc = (t, e) => r(
  {
    url: `/api/v5/firms/documents/${t}/metadata`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Kc = (t) => {
  const e = ["patchApiV5FirmsDocumentsDocumentUuidMetadata"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { documentUuid: o, data: a } = i ?? {};
    return Rc(o, a);
  }, ...n };
}, WF = (t) => {
  const e = Kc(t);
  return u(e);
}, Tc = (t, e, n) => r(
  {
    url: `/api/v5/firms/documents/${t}/account_options`,
    method: "GET",
    params: e,
    signal: n
  }
), vc = (t, e) => [`/api/v5/firms/documents/${t}/account_options`, ...e ? [e] : []], Ic = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? vc(t, e), queryFn: ({ signal: a }) => Tc(t, e, a), enabled: !!t, ...s };
};
function LF(t, e, n) {
  const s = Ic(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const wc = (t, e) => r(
  {
    url: `/api/v5/firms/documents/${t}/account`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Oc = (t) => {
  const e = ["patchApiV5FirmsDocumentsDocumentUuidAccount"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { documentUuid: o, data: a } = i ?? {};
    return wc(o, a);
  }, ...n };
}, QF = (t) => {
  const e = Oc(t);
  return u(e);
}, kc = (t, e) => r(
  {
    url: "/api/v5/firms/employees",
    method: "GET",
    params: t,
    signal: e
  }
), Sc = (t) => ["/api/v5/firms/employees", ...t ? [t] : []], Dc = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Sc(t), queryFn: ({ signal: o }) => kc(t, o), ...n };
};
function BF(t, e) {
  const n = Dc(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Pc = (t, e, n) => r(
  {
    url: `/api/v5/firms/files/${t}/account_options`,
    method: "GET",
    params: e,
    signal: n
  }
), Cc = (t, e) => [`/api/v5/firms/files/${t}/account_options`, ...e ? [e] : []], Ec = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Cc(t, e), queryFn: ({ signal: a }) => Pc(t, e, a), enabled: !!t, ...s };
};
function jF(t, e, n) {
  const s = Ec(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Gc = (t, e) => r(
  {
    url: `/api/v5/firms/files/${t}/account`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), bc = (t) => {
  const e = ["patchApiV5FirmsFilesDocumentIdAccount"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { documentId: o, data: a } = i ?? {};
    return Gc(o, a);
  }, ...n };
}, zF = (t) => {
  const e = bc(t);
  return u(e);
}, xc = (t, e) => r(
  {
    url: "/api/v5/firms/files/search",
    method: "GET",
    params: t,
    signal: e
  }
), Uc = (t) => ["/api/v5/firms/files/search", ...t ? [t] : []], $c = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Uc(t), queryFn: ({ signal: o }) => xc(t, o), ...n };
};
function HF(t, e) {
  const n = $c(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Mc = (t, e) => r(
  {
    url: "/api/v5/firms/files",
    method: "GET",
    params: t,
    signal: e
  }
), Nc = (t) => ["/api/v5/firms/files", ...t ? [t] : []], Wc = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Nc(t), queryFn: ({ signal: o }) => Mc(t, o), ...n };
};
function JF(t, e) {
  const n = Wc(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Lc = (t, e) => r(
  {
    url: "/api/v5/firms/files/accounts",
    method: "GET",
    params: t,
    signal: e
  }
), Qc = (t) => ["/api/v5/firms/files/accounts", ...t ? [t] : []], Bc = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Qc(t), queryFn: ({ signal: o }) => Lc(t, o), ...n };
};
function YF(t, e) {
  const n = Bc(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const jc = (t, e) => r(
  {
    url: "/api/v5/firms/files/firm/tree",
    method: "GET",
    params: t,
    signal: e
  }
), zc = (t) => ["/api/v5/firms/files/firm/tree", ...t ? [t] : []], Hc = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? zc(t), queryFn: ({ signal: o }) => jc(t, o), ...n };
};
function ZF(t, e) {
  const n = Hc(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Jc = (t, e, n) => r(
  {
    url: `/api/v5/firms/files/accounts/${t}/tree`,
    method: "GET",
    params: e,
    signal: n
  }
), Yc = (t, e) => [`/api/v5/firms/files/accounts/${t}/tree`, ...e ? [e] : []], Zc = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Yc(t, e), queryFn: ({ signal: a }) => Jc(t, e, a), enabled: !!t, ...s };
};
function XF(t, e, n) {
  const s = Zc(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Xc = (t) => r(
  {
    url: "/api/v5/firms/files/sharepoint_imports/unreviewed_count",
    method: "GET",
    signal: t
  }
), tm = () => ["/api/v5/firms/files/sharepoint_imports/unreviewed_count"], em = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? tm(), queryFn: ({ signal: i }) => Xc(i), ...e };
};
function tq(t) {
  const e = em(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const nm = (t, e) => r(
  {
    url: "/api/v5/firms/files/uploaders",
    method: "GET",
    params: t,
    signal: e
  }
), sm = (t) => ["/api/v5/firms/files/uploaders", ...t ? [t] : []], im = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? sm(t), queryFn: ({ signal: o }) => nm(t, o), ...n };
};
function eq(t, e) {
  const n = im(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const om = (t, e) => r(
  {
    url: "/api/v5/firms/files/position",
    method: "GET",
    params: t,
    signal: e
  }
), rm = (t) => ["/api/v5/firms/files/position", ...t ? [t] : []], am = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? rm(t), queryFn: ({ signal: o }) => om(t, o), ...n };
};
function nq(t, e) {
  const n = am(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const um = (t, e, n) => r(
  {
    url: `/api/v5/firms/files/${t}`,
    method: "GET",
    params: e,
    signal: n
  }
), cm = (t, e) => [`/api/v5/firms/files/${t}`, ...e ? [e] : []], mm = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? cm(t, e), queryFn: ({ signal: a }) => um(t, e, a), enabled: !!t, ...s };
};
function sq(t, e, n) {
  const s = mm(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const pm = (t, e) => r(
  {
    url: `/api/v5/firms/files/${t}/share_recipients`,
    method: "GET",
    signal: e
  }
), dm = (t) => [`/api/v5/firms/files/${t}/share_recipients`], lm = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? dm(t), queryFn: ({ signal: o }) => pm(t, o), enabled: !!t, ...n };
};
function iq(t, e) {
  const n = lm(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const ym = (t, e) => r(
  {
    url: `/api/v5/firms/files/${t}/metadata`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), fm = (t) => {
  const e = ["patchApiV5FirmsFilesDocumentIdMetadata"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { documentId: o, data: a } = i ?? {};
    return ym(o, a);
  }, ...n };
}, oq = (t) => {
  const e = fm(t);
  return u(e);
}, Am = (t) => r(
  {
    url: "/api/v5/firms/files/document_types",
    method: "GET",
    signal: t
  }
), gm = () => ["/api/v5/firms/files/document_types"], hm = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? gm(), queryFn: ({ signal: i }) => Am(i), ...e };
};
function rq(t) {
  const e = hm(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Fm = (t, e) => r(
  {
    url: "/api/v5/firms/files/root/documents",
    method: "GET",
    params: t,
    signal: e
  }
), qm = (t) => ["/api/v5/firms/files/root/documents", ...t ? [t] : []], _m = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? qm(t), queryFn: ({ signal: o }) => Fm(t, o), ...n };
};
function aq(t, e) {
  const n = _m(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Vm = (t, e, n) => r(
  {
    url: `/api/v5/firms/files/${t}/location`,
    method: "GET",
    params: e,
    signal: n
  }
), Rm = (t, e) => [`/api/v5/firms/files/${t}/location`, ...e ? [e] : []], Km = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Rm(t, e), queryFn: ({ signal: a }) => Vm(t, e, a), enabled: !!t, ...s };
};
function uq(t, e, n) {
  const s = Km(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Tm = (t, e) => r(
  {
    url: `/api/v5/firms/files/${t}/placement`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), vm = (t) => {
  const e = ["patchApiV5FirmsFilesDocumentIdPlacement"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { documentId: o, data: a } = i ?? {};
    return Tm(o, a);
  }, ...n };
}, cq = (t) => {
  const e = vm(t);
  return u(e);
}, Im = (t, e) => r(
  {
    url: "/api/v5/firms/folders",
    method: "GET",
    params: t,
    signal: e
  }
), wm = (t) => ["/api/v5/firms/folders", ...t ? [t] : []], Om = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? wm(t), queryFn: ({ signal: o }) => Im(t, o), ...n };
};
function mq(t, e) {
  const n = Om(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const km = (t, e) => r(
  {
    url: "/api/v5/firms/folders",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Sm = (t) => {
  const e = ["postApiV5FirmsFolders"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return km(o);
  }, ...n };
}, pq = (t) => {
  const e = Sm(t);
  return u(e);
}, Dm = (t, e) => r(
  {
    url: `/api/v5/firms/folders/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Pm = (t) => {
  const e = ["patchApiV5FirmsFoldersFolderId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { folderId: o, data: a } = i ?? {};
    return Dm(o, a);
  }, ...n };
}, dq = (t) => {
  const e = Pm(t);
  return u(e);
}, Cm = (t) => r(
  {
    url: `/api/v5/firms/folders/${t}`,
    method: "DELETE"
  }
), Em = (t) => {
  const e = ["deleteApiV5FirmsFoldersFolderId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { folderId: o } = i ?? {};
    return Cm(o);
  }, ...n };
}, lq = (t) => {
  const e = Em(t);
  return u(e);
}, Gm = (t, e, n) => r(
  {
    url: `/api/v5/firms/folders/${t}/documents`,
    method: "GET",
    params: e,
    signal: n
  }
), bm = (t, e) => [`/api/v5/firms/folders/${t}/documents`, ...e ? [e] : []], xm = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? bm(t, e), queryFn: ({ signal: a }) => Gm(t, e, a), enabled: !!t, ...s };
};
function yq(t, e, n) {
  const s = xm(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Um = (t, e, n) => r(
  {
    url: `/api/v5/firms/folder_view/accounts/${t}/tree`,
    method: "GET",
    params: e,
    signal: n
  }
), $m = (t, e) => [`/api/v5/firms/folder_view/accounts/${t}/tree`, ...e ? [e] : []], Mm = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? $m(t, e), queryFn: ({ signal: a }) => Um(t, e, a), enabled: !!t, ...s };
};
function fq(t, e, n) {
  const s = Mm(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Nm = (t, e) => r(
  {
    url: `/api/v5/firms/folder_view/accounts/${t}/unresolved`,
    method: "GET",
    signal: e
  }
), Wm = (t) => [`/api/v5/firms/folder_view/accounts/${t}/unresolved`], Lm = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Wm(t), queryFn: ({ signal: o }) => Nm(t, o), enabled: !!t, ...n };
};
function Aq(t, e) {
  const n = Lm(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Qm = (t, e, n, s) => r(
  {
    url: `/api/v5/firms/requests/${t}/sections/${e}/items/${n}/response`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: s
  }
), Bm = (t) => {
  const e = ["patchApiV5FirmsRequestsRequestIdSectionsSectionIdItemsItemIdResponse"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestId: o, sectionId: a, itemId: d, data: y } = i ?? {};
    return Qm(o, a, d, y);
  }, ...n };
}, gq = (t) => {
  const e = Bm(t);
  return u(e);
}, jm = (t, e, n, s) => r(
  {
    url: `/api/v5/firms/requests/${t}/sections/${e}/items`,
    method: "GET",
    params: n,
    signal: s
  }
), zm = (t, e, n) => [`/api/v5/firms/requests/${t}/sections/${e}/items`, ...n ? [n] : []], Hm = (t, e, n, s) => {
  const { query: i } = s ?? {};
  return { queryKey: (i == null ? void 0 : i.queryKey) ?? zm(t, e, n), queryFn: ({ signal: d }) => jm(t, e, n, d), enabled: !!(t && e), ...i };
};
function hq(t, e, n, s) {
  const i = Hm(t, e, n, s), o = c(i);
  return o.queryKey = i.queryKey, o;
}
const Jm = (t, e, n) => r(
  {
    url: `/api/v5/firms/requests/${t}/sections`,
    method: "GET",
    params: e,
    signal: n
  }
), Ym = (t, e) => [`/api/v5/firms/requests/${t}/sections`, ...e ? [e] : []], Zm = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Ym(t, e), queryFn: ({ signal: a }) => Jm(t, e, a), enabled: !!t, ...s };
};
function Fq(t, e, n) {
  const s = Zm(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Xm = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/admin/documents",
    method: "GET",
    params: t,
    signal: e
  }
), tp = (t) => ["/api/v5/firms/rfi/admin/documents", ...t ? [t] : []], ep = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? tp(t), queryFn: ({ signal: o }) => Xm(t, o), ...n };
};
function qq(t, e) {
  const n = ep(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const np = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/admin/documents/${t}`,
    method: "GET",
    signal: e
  }
), sp = (t) => [`/api/v5/firms/rfi/admin/documents/${t}`], ip = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? sp(t), queryFn: ({ signal: o }) => np(t, o), enabled: !!t, ...n };
};
function _q(t, e) {
  const n = ip(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const op = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/admin/documents/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), rp = (t) => {
  const e = ["patchApiV5FirmsRfiAdminDocumentsUuid"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o, data: a } = i ?? {};
    return op(o, a);
  }, ...n };
}, Vq = (t) => {
  const e = rp(t);
  return u(e);
}, ap = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/admin/documents/${t}/regenerate_request`,
    method: "POST",
    signal: e
  }
), up = (t) => {
  const e = ["postApiV5FirmsRfiAdminDocumentsUuidRegenerateRequest"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return ap(o);
  }, ...n };
}, Rq = (t) => {
  const e = up(t);
  return u(e);
}, cp = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/admin/documents/next",
    method: "GET",
    params: t,
    signal: e
  }
), mp = (t) => ["/api/v5/firms/rfi/admin/documents/next", ...t ? [t] : []], pp = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? mp(t), queryFn: ({ signal: o }) => cp(t, o), ...n };
};
function Kq(t, e) {
  const n = pp(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const dp = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/admin/requests/${t}/approve`,
    method: "POST",
    signal: e
  }
), lp = (t) => {
  const e = ["postApiV5FirmsRfiAdminRequestsUuidApprove"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return dp(o);
  }, ...n };
}, Tq = (t) => {
  const e = lp(t);
  return u(e);
}, yp = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/attachments`,
    method: "GET",
    params: e,
    signal: n
  }
), fp = (t, e) => [`/api/v5/firms/rfi/requests/${t}/attachments`, ...e ? [e] : []], Ap = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? fp(t, e), queryFn: ({ signal: a }) => yp(t, e, a), enabled: !!t, ...s };
};
function vq(t, e, n) {
  const s = Ap(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const gp = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/attachments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), hp = (t) => {
  const e = ["postApiV5FirmsRfiRequestsRequestUuidAttachments"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, data: a } = i ?? {};
    return gp(o, a);
  }, ...n };
}, Iq = (t) => {
  const e = hp(t);
  return u(e);
}, Fp = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/attachments/${t}`,
    method: "GET",
    signal: e
  }
), qp = (t) => [`/api/v5/firms/rfi/attachments/${t}`], _p = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? qp(t), queryFn: ({ signal: o }) => Fp(t, o), enabled: !!t, ...n };
};
function wq(t, e) {
  const n = _p(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Vp = (t) => r(
  {
    url: `/api/v5/firms/rfi/attachments/${t}`,
    method: "DELETE"
  }
), Rp = (t) => {
  const e = ["deleteApiV5FirmsRfiAttachmentsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Vp(o);
  }, ...n };
}, Oq = (t) => {
  const e = Rp(t);
  return u(e);
}, Kp = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/gruntworx_export`,
    method: "POST",
    signal: e
  }
), Tp = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidGruntworxExport"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return Kp(o);
  }, ...n };
}, kq = (t) => {
  const e = Tp(t);
  return u(e);
}, vp = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/gruntworx_export/status`,
    method: "GET",
    params: e,
    signal: n
  }
), Ip = (t, e) => [`/api/v5/firms/rfi/requests/${t}/gruntworx_export/status`, ...e ? [e] : []], wp = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Ip(t, e), queryFn: ({ signal: a }) => vp(t, e, a), enabled: !!t, ...s };
};
function Sq(t, e, n) {
  const s = wp(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Op = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/to_pdf`,
    method: "GET",
    params: e,
    responseType: "blob",
    signal: n
  }
), kp = (t, e) => [`/api/v5/firms/rfi/requests/${t}/to_pdf`, ...e ? [e] : []], Sp = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? kp(t, e), queryFn: ({ signal: a }) => Op(t, e, a), enabled: !!t, ...s };
};
function Dq(t, e, n) {
  const s = Sp(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Dp = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/requests/bulk_archive",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Pp = (t) => {
  const e = ["postApiV5FirmsRfiRequestsBulkArchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Dp(o);
  }, ...n };
}, Pq = (t) => {
  const e = Pp(t);
  return u(e);
}, Cp = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/requests/bulk_delete",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Ep = (t) => {
  const e = ["postApiV5FirmsRfiRequestsBulkDelete"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Cp(o);
  }, ...n };
}, Cq = (t) => {
  const e = Ep(t);
  return u(e);
}, Gp = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/requests/bulk_recall",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), bp = (t) => {
  const e = ["postApiV5FirmsRfiRequestsBulkRecall"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Gp(o);
  }, ...n };
}, Eq = (t) => {
  const e = bp(t);
  return u(e);
}, xp = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/requests/bulk_send",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Up = (t) => {
  const e = ["postApiV5FirmsRfiRequestsBulkSend"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return xp(o);
  }, ...n };
}, Gq = (t) => {
  const e = Up(t);
  return u(e);
}, $p = (t) => r(
  {
    url: "/api/v5/firms/rfi/requests/bulk_update",
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: t
  }
), Mp = (t) => {
  const e = ["patchApiV5FirmsRfiRequestsBulkUpdate"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return $p(o);
  }, ...n };
}, bq = (t) => {
  const e = Mp(t);
  return u(e);
}, Np = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/requests",
    method: "GET",
    params: t,
    signal: e
  }
), Wp = (t) => ["/api/v5/firms/rfi/requests", ...t ? [t] : []], Lp = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Wp(t), queryFn: ({ signal: o }) => Np(t, o), ...n };
};
function xq(t, e) {
  const n = Lp(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Qp = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/requests",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Bp = (t) => {
  const e = ["postApiV5FirmsRfiRequests"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Qp(o);
  }, ...n };
}, Uq = (t) => {
  const e = Bp(t);
  return u(e);
}, jp = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}`,
    method: "GET",
    signal: e
  }
), zp = (t) => [`/api/v5/firms/rfi/requests/${t}`], Hp = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? zp(t), queryFn: ({ signal: o }) => jp(t, o), enabled: !!t, ...n };
};
function $q(t, e) {
  const n = Hp(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Jp = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Yp = (t) => {
  const e = ["patchApiV5FirmsRfiRequestsUuid"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o, data: a } = i ?? {};
    return Jp(o, a);
  }, ...n };
}, Mq = (t) => {
  const e = Yp(t);
  return u(e);
}, Zp = (t) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}`,
    method: "DELETE"
  }
), Xp = (t) => {
  const e = ["deleteApiV5FirmsRfiRequestsUuid"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return Zp(o);
  }, ...n };
}, Nq = (t) => {
  const e = Xp(t);
  return u(e);
}, td = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/send_to_client`,
    method: "POST",
    signal: e
  }
), ed = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidSendToClient"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return td(o);
  }, ...n };
}, Wq = (t) => {
  const e = ed(t);
  return u(e);
}, nd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/submit`,
    method: "POST",
    signal: e
  }
), sd = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidSubmit"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return nd(o);
  }, ...n };
}, Lq = (t) => {
  const e = sd(t);
  return u(e);
}, id = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/recall`,
    method: "POST",
    signal: e
  }
), od = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidRecall"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return id(o);
  }, ...n };
}, Qq = (t) => {
  const e = od(t);
  return u(e);
}, rd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/archive`,
    method: "POST",
    signal: e
  }
), ad = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidArchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return rd(o);
  }, ...n };
}, Bq = (t) => {
  const e = ad(t);
  return u(e);
}, ud = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/unarchive`,
    method: "POST",
    signal: e
  }
), cd = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidUnarchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return ud(o);
  }, ...n };
}, jq = (t) => {
  const e = cd(t);
  return u(e);
}, md = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/reopen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), pd = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidReopen"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o, data: a } = i ?? {};
    return md(o, a);
  }, ...n };
}, zq = (t) => {
  const e = pd(t);
  return u(e);
}, dd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/resend`,
    method: "POST",
    signal: e
  }
), ld = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidResend"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return dd(o);
  }, ...n };
}, Hq = (t) => {
  const e = ld(t);
  return u(e);
}, yd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/zip`,
    method: "POST",
    signal: e
  }
), fd = (t) => {
  const e = ["postApiV5FirmsRfiRequestsUuidZip"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return yd(o);
  }, ...n };
}, Jq = (t) => {
  const e = fd(t);
  return u(e);
}, Ad = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/items/bulk_status`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), gd = (t) => {
  const e = ["patchApiV5FirmsRfiRequestsRequestUuidItemsBulkStatus"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, data: a } = i ?? {};
    return Ad(o, a);
  }, ...n };
}, Yq = (t) => {
  const e = gd(t);
  return u(e);
}, hd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/items`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Fd = (t) => {
  const e = ["patchApiV5FirmsRfiRequestsRequestUuidItems"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, data: a } = i ?? {};
    return hd(o, a);
  }, ...n };
}, Zq = (t) => {
  const e = Fd(t);
  return u(e);
}, qd = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/direct_uploads",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), _d = (t) => {
  const e = ["postApiV5FirmsRfiDirectUploads"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return qd(o);
  }, ...n };
}, Xq = (t) => {
  const e = _d(t);
  return u(e);
}, Vd = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/documents",
    method: "GET",
    params: t,
    signal: e
  }
), Rd = (t) => ["/api/v5/firms/rfi/documents", ...t ? [t] : []], Kd = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Rd(t), queryFn: ({ signal: o }) => Vd(t, o), ...n };
};
function t5(t, e) {
  const n = Kd(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Td = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/documents",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), vd = (t) => {
  const e = ["postApiV5FirmsRfiDocuments"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Td(o);
  }, ...n };
}, e5 = (t) => {
  const e = vd(t);
  return u(e);
}, Id = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/documents/${t}`,
    method: "GET",
    signal: e
  }
), wd = (t) => [`/api/v5/firms/rfi/documents/${t}`], Od = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? wd(t), queryFn: ({ signal: o }) => Id(t, o), enabled: !!t, ...n };
};
function n5(t, e) {
  const n = Od(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const kd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/documents/${t}/retry`,
    method: "POST",
    signal: e
  }
), Sd = (t) => {
  const e = ["postApiV5FirmsRfiDocumentsUuidRetry"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return kd(o);
  }, ...n };
}, s5 = (t) => {
  const e = Sd(t);
  return u(e);
}, Dd = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/match_files/links`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), Pd = (t) => {
  const e = ["postApiV5FirmsRfiRequestsRequestUuidMatchFilesLinks"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, data: a } = i ?? {};
    return Dd(o, a);
  }, ...n };
}, i5 = (t) => {
  const e = Pd(t);
  return u(e);
}, Cd = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/match_files/placements`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), Ed = (t) => {
  const e = ["postApiV5FirmsRfiRequestsRequestUuidMatchFilesPlacements"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, data: a } = i ?? {};
    return Cd(o, a);
  }, ...n };
}, o5 = (t) => {
  const e = Ed(t);
  return u(e);
}, Gd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/match_files`,
    method: "GET",
    signal: e
  }
), bd = (t) => [`/api/v5/firms/rfi/requests/${t}/match_files`], xd = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? bd(t), queryFn: ({ signal: o }) => Gd(t, o), enabled: !!t, ...n };
};
function r5(t, e) {
  const n = xd(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ud = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/match_files/${e}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: n
  }
), $d = (t) => {
  const e = ["patchApiV5FirmsRfiRequestsRequestUuidMatchFilesDocumentId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o, documentId: a, data: d } = i ?? {};
    return Ud(o, a, d);
  }, ...n };
}, a5 = (t) => {
  const e = $d(t);
  return u(e);
}, Md = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/requests/${t}/reminders`,
    method: "POST",
    signal: e
  }
), Nd = (t) => {
  const e = ["postApiV5FirmsRfiRequestsRequestUuidReminders"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestUuid: o } = i ?? {};
    return Md(o);
  }, ...n };
}, u5 = (t) => {
  const e = Nd(t);
  return u(e);
}, Wd = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/templates",
    method: "GET",
    params: t,
    signal: e
  }
), Ld = (t) => ["/api/v5/firms/rfi/templates", ...t ? [t] : []], Qd = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ld(t), queryFn: ({ signal: o }) => Wd(t, o), ...n };
};
function c5(t, e) {
  const n = Qd(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Bd = (t, e) => r(
  {
    url: "/api/v5/firms/rfi/templates",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), jd = (t) => {
  const e = ["postApiV5FirmsRfiTemplates"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Bd(o);
  }, ...n };
}, m5 = (t) => {
  const e = jd(t);
  return u(e);
}, zd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/templates/${t}`,
    method: "GET",
    signal: e
  }
), Hd = (t) => [`/api/v5/firms/rfi/templates/${t}`], Jd = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Hd(t), queryFn: ({ signal: o }) => zd(t, o), enabled: !!t, ...n };
};
function p5(t, e) {
  const n = Jd(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Yd = (t, e) => r(
  {
    url: `/api/v5/firms/rfi/templates/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Zd = (t) => {
  const e = ["patchApiV5FirmsRfiTemplatesUuid"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o, data: a } = i ?? {};
    return Yd(o, a);
  }, ...n };
}, d5 = (t) => {
  const e = Zd(t);
  return u(e);
}, Xd = (t) => r(
  {
    url: `/api/v5/firms/rfi/templates/${t}`,
    method: "DELETE"
  }
), tl = (t) => {
  const e = ["deleteApiV5FirmsRfiTemplatesUuid"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return Xd(o);
  }, ...n };
}, l5 = (t) => {
  const e = tl(t);
  return u(e);
}, el = (t, e, n) => r(
  {
    url: `/api/v5/firms/rfi/templates/${t}/clone`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), nl = (t) => {
  const e = ["postApiV5FirmsRfiTemplatesUuidClone"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o, data: a } = i ?? {};
    return el(o, a);
  }, ...n };
}, y5 = (t) => {
  const e = nl(t);
  return u(e);
}, sl = (t) => r(
  {
    url: `/api/v5/firms/rfi/templates/${t}/activate`,
    method: "PATCH"
  }
), il = (t) => {
  const e = ["patchApiV5FirmsRfiTemplatesUuidActivate"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return sl(o);
  }, ...n };
}, f5 = (t) => {
  const e = il(t);
  return u(e);
}, ol = (t) => r(
  {
    url: `/api/v5/firms/rfi/templates/${t}/archive`,
    method: "PATCH"
  }
), rl = (t) => {
  const e = ["patchApiV5FirmsRfiTemplatesUuidArchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return ol(o);
  }, ...n };
}, A5 = (t) => {
  const e = rl(t);
  return u(e);
}, al = (t) => r(
  {
    url: `/api/v5/firms/rfi/templates/${t}/unarchive`,
    method: "PATCH"
  }
), ul = (t) => {
  const e = ["patchApiV5FirmsRfiTemplatesUuidUnarchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { uuid: o } = i ?? {};
    return al(o);
  }, ...n };
}, g5 = (t) => {
  const e = ul(t);
  return u(e);
}, cl = (t, e) => r(
  {
    url: "/api/v5/firms/rpa_documents",
    method: "GET",
    params: t,
    signal: e
  }
), ml = (t) => ["/api/v5/firms/rpa_documents", ...t ? [t] : []], pl = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? ml(t), queryFn: ({ signal: o }) => cl(t, o), ...n };
};
function h5(t, e) {
  const n = pl(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const dl = (t) => r(
  {
    url: "/api/v5/firms/rpa_documents/processing_count",
    method: "GET",
    signal: t
  }
), ll = () => ["/api/v5/firms/rpa_documents/processing_count"], yl = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? ll(), queryFn: ({ signal: i }) => dl(i), ...e };
};
function F5(t) {
  const e = yl(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const fl = (t, e, n) => r(
  {
    url: `/api/v5/firms/rpa_documents/${t}`,
    method: "GET",
    params: e,
    signal: n
  }
), Al = (t, e) => [`/api/v5/firms/rpa_documents/${t}`, ...e ? [e] : []], gl = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Al(t, e), queryFn: ({ signal: a }) => fl(t, e, a), enabled: !!t, ...s };
};
function q5(t, e, n) {
  const s = gl(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const hl = (t) => r(
  {
    url: "/api/v5/firms/sample_client",
    method: "POST",
    signal: t
  }
), Fl = (t) => {
  const e = ["postApiV5FirmsSampleClient"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => hl(), ...n };
}, _5 = (t) => {
  const e = Fl(t);
  return u(e);
}, ql = (t, e) => r(
  {
    url: "/api/v5/firms/service_aliases",
    method: "GET",
    params: t,
    signal: e
  }
), _l = (t) => ["/api/v5/firms/service_aliases", ...t ? [t] : []], Vl = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? _l(t), queryFn: ({ signal: o }) => ql(t, o), ...n };
};
function V5(t, e) {
  const n = Vl(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Rl = (t, e) => r(
  {
    url: "/api/v5/firms/service_aliases",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Kl = (t) => {
  const e = ["postApiV5FirmsServiceAliases"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Rl(o);
  }, ...n };
}, R5 = (t) => {
  const e = Kl(t);
  return u(e);
}, Tl = (t, e) => r(
  {
    url: `/api/v5/firms/service_aliases/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), vl = (t) => {
  const e = ["patchApiV5FirmsServiceAliasesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return Tl(o, a);
  }, ...n };
}, K5 = (t) => {
  const e = vl(t);
  return u(e);
}, Il = (t) => r(
  {
    url: `/api/v5/firms/service_aliases/${t}`,
    method: "DELETE"
  }
), wl = (t) => {
  const e = ["deleteApiV5FirmsServiceAliasesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Il(o);
  }, ...n };
}, T5 = (t) => {
  const e = wl(t);
  return u(e);
}, Ol = (t, e) => r(
  {
    url: `/api/v5/firms/service_aliases/${t}/confirm`,
    method: "POST",
    signal: e
  }
), kl = (t) => {
  const e = ["postApiV5FirmsServiceAliasesIdConfirm"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Ol(o);
  }, ...n };
}, v5 = (t) => {
  const e = kl(t);
  return u(e);
}, Sl = (t, e) => r(
  {
    url: `/api/v5/firms/service_aliases/${t}/reset`,
    method: "POST",
    signal: e
  }
), Dl = (t) => {
  const e = ["postApiV5FirmsServiceAliasesIdReset"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Sl(o);
  }, ...n };
}, I5 = (t) => {
  const e = Dl(t);
  return u(e);
}, Pl = (t, e) => r(
  {
    url: "/api/v5/firms/service_aliases/bulk_confirm",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), Cl = (t) => {
  const e = ["postApiV5FirmsServiceAliasesBulkConfirm"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Pl(o);
  }, ...n };
}, w5 = (t) => {
  const e = Cl(t);
  return u(e);
}, El = (t, e) => r(
  {
    url: "/api/v5/firms/service_aliases/suggestions",
    method: "GET",
    params: t,
    signal: e
  }
), Gl = (t) => ["/api/v5/firms/service_aliases/suggestions", ...t ? [t] : []], bl = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Gl(t), queryFn: ({ signal: o }) => El(t, o), ...n };
};
function O5(t, e) {
  const n = bl(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const xl = (t, e) => r(
  {
    url: "/api/v5/firms/smart_vault/availability",
    method: "GET",
    params: t,
    signal: e
  }
), Ul = (t) => ["/api/v5/firms/smart_vault/availability", ...t ? [t] : []], $l = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ul(t), queryFn: ({ signal: o }) => xl(t, o), ...n };
};
function k5(t, e) {
  const n = $l(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ml = (t, e, n) => r(
  {
    url: `/api/v5/firms/smart_vault/accounts/${t}/imported_folder_tree`,
    method: "GET",
    params: e,
    signal: n
  }
), Nl = (t, e) => [`/api/v5/firms/smart_vault/accounts/${t}/imported_folder_tree`, ...e ? [e] : []], Wl = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Nl(t, e), queryFn: ({ signal: a }) => Ml(t, e, a), enabled: !!t, ...s };
};
function S5(t, e, n) {
  const s = Wl(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Ll = (t, e) => r(
  {
    url: "/api/v5/firms/smart_vault/sync_runs",
    method: "GET",
    params: t,
    signal: e
  }
), Ql = (t) => ["/api/v5/firms/smart_vault/sync_runs", ...t ? [t] : []], Bl = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ql(t), queryFn: ({ signal: o }) => Ll(t, o), ...n };
};
function D5(t, e) {
  const n = Bl(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const jl = (t, e) => r(
  {
    url: "/api/v5/firms/smart_vault/sync_runs",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), zl = (t) => {
  const e = ["postApiV5FirmsSmartVaultSyncRuns"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return jl(o);
  }, ...n };
}, P5 = (t) => {
  const e = zl(t);
  return u(e);
}, Hl = (t) => r(
  {
    url: "/api/v5/firms/smart_vault/sync_runs/sync_all",
    method: "POST",
    signal: t
  }
), Jl = (t) => {
  const e = ["postApiV5FirmsSmartVaultSyncRunsSyncAll"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => Hl(), ...n };
}, C5 = (t) => {
  const e = Jl(t);
  return u(e);
}, Yl = (t, e) => r(
  {
    url: `/api/v5/firms/smart_vault/sync_runs/${t}`,
    method: "GET",
    signal: e
  }
), Zl = (t) => [`/api/v5/firms/smart_vault/sync_runs/${t}`], Xl = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Zl(t), queryFn: ({ signal: o }) => Yl(t, o), enabled: !!t, ...n };
};
function E5(t, e) {
  const n = Xl(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const ty = (t, e) => r(
  {
    url: "/api/v5/firms/tags",
    method: "GET",
    params: t,
    signal: e
  }
), ey = (t) => ["/api/v5/firms/tags", ...t ? [t] : []], ny = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? ey(t), queryFn: ({ signal: o }) => ty(t, o), ...n };
};
function G5(t, e) {
  const n = ny(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const sy = (t, e) => r(
  {
    url: "/api/v5/firms/tags",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), iy = (t) => {
  const e = ["postApiV5FirmsTags"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return sy(o);
  }, ...n };
}, b5 = (t) => {
  const e = iy(t);
  return u(e);
}, oy = (t) => r(
  {
    url: "/api/v5/firms/tags/update_sort_order",
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: t
  }
), ry = (t) => {
  const e = ["putApiV5FirmsTagsUpdateSortOrder"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return oy(o);
  }, ...n };
}, x5 = (t) => {
  const e = ry(t);
  return u(e);
}, ay = (t, e) => r(
  {
    url: `/api/v5/firms/tags/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), uy = (t) => {
  const e = ["patchApiV5FirmsTagsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return ay(o, a);
  }, ...n };
}, U5 = (t) => {
  const e = uy(t);
  return u(e);
}, cy = (t) => r(
  {
    url: `/api/v5/firms/tags/${t}`,
    method: "DELETE"
  }
), my = (t) => {
  const e = ["deleteApiV5FirmsTagsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return cy(o);
  }, ...n };
}, $5 = (t) => {
  const e = my(t);
  return u(e);
}, py = (t) => r(
  {
    url: "/api/v5/firms/workflow_templates/liscio_workflow_templates",
    method: "GET",
    signal: t
  }
), dy = () => ["/api/v5/firms/workflow_templates/liscio_workflow_templates"], ly = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? dy(), queryFn: ({ signal: i }) => py(i), ...e };
};
function M5(t) {
  const e = ly(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const yy = (t, e) => r(
  {
    url: `/api/v5/firms/workflow_templates/liscio_workflow_templates/${t}`,
    method: "GET",
    signal: e
  }
), fy = (t) => [`/api/v5/firms/workflow_templates/liscio_workflow_templates/${t}`], Ay = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? fy(t), queryFn: ({ signal: o }) => yy(t, o), enabled: !!t, ...n };
};
function N5(t, e) {
  const n = Ay(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const gy = (t) => r(
  {
    url: "/api/v5/firms/workflow_templates",
    method: "GET",
    signal: t
  }
), hy = () => ["/api/v5/firms/workflow_templates"], Fy = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? hy(), queryFn: ({ signal: i }) => gy(i), ...e };
};
function W5(t) {
  const e = Fy(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const qy = (t, e) => r(
  {
    url: `/api/v5/firms/workflow_templates/${t}`,
    method: "GET",
    signal: e
  }
), _y = (t) => [`/api/v5/firms/workflow_templates/${t}`], Vy = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? _y(t), queryFn: ({ signal: o }) => qy(t, o), enabled: !!t, ...n };
};
function L5(t, e) {
  const n = Vy(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Ry = (t, e) => r(
  {
    url: "/api/v5/intercom_settings",
    method: "GET",
    params: t,
    signal: e
  }
), Ky = (t) => ["/api/v5/intercom_settings", ...t ? [t] : []], Ty = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ky(t), queryFn: ({ signal: o }) => Ry(t, o), ...n };
};
function Q5(t, e) {
  const n = Ty(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const vy = (t, e) => r(
  {
    url: "/api/v5/messages",
    method: "GET",
    params: t,
    signal: e
  }
), Iy = (t) => ["/api/v5/messages", ...t ? [t] : []], wy = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Iy(t), queryFn: ({ signal: o }) => vy(t, o), ...n };
};
function B5(t, e) {
  const n = wy(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Oy = (t, e) => r(
  {
    url: "/api/v5/messages",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), ky = (t) => {
  const e = ["postApiV5Messages"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Oy(o);
  }, ...n };
}, j5 = (t) => {
  const e = ky(t);
  return u(e);
}, Sy = (t, e) => r(
  {
    url: "/api/v5/messages/counts",
    method: "GET",
    params: t,
    signal: e
  }
), Dy = (t) => ["/api/v5/messages/counts", ...t ? [t] : []], Py = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Dy(t), queryFn: ({ signal: o }) => Sy(t, o), ...n };
};
function z5(t, e) {
  const n = Py(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Cy = (t, e) => r(
  {
    url: `/api/v5/messages/threads/${t}`,
    method: "GET",
    signal: e
  }
), Ey = (t) => [`/api/v5/messages/threads/${t}`], Gy = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ey(t), queryFn: ({ signal: o }) => Cy(t, o), enabled: !!t, ...n };
};
function H5(t, e) {
  const n = Gy(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const by = (t, e) => r(
  {
    url: "/api/v5/messages/templates",
    method: "GET",
    params: t,
    signal: e
  }
), xy = (t) => ["/api/v5/messages/templates", ...t ? [t] : []], Uy = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? xy(t), queryFn: ({ signal: o }) => by(t, o), ...n };
};
function J5(t, e) {
  const n = Uy(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const $y = (t, e) => r(
  {
    url: `/api/v5/messages/${t}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), My = (t) => {
  const e = ["patchApiV5MessagesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return $y(o, a);
  }, ...n };
}, Y5 = (t) => {
  const e = My(t);
  return u(e);
}, Ny = (t, e) => r(
  {
    url: `/api/v5/messages/${t}`,
    method: "GET",
    signal: e
  }
), Wy = (t) => [`/api/v5/messages/${t}`], Ly = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Wy(t), queryFn: ({ signal: o }) => Ny(t, o), enabled: !!t, ...n };
};
function Z5(t, e) {
  const n = Ly(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Qy = (t) => r(
  {
    url: `/api/v5/messages/${t}`,
    method: "DELETE"
  }
), By = (t) => {
  const e = ["deleteApiV5MessagesId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Qy(o);
  }, ...n };
}, X5 = (t) => {
  const e = By(t);
  return u(e);
}, jy = (t, e, n) => r(
  {
    url: `/api/v5/messages/${t}/send`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), zy = (t) => {
  const e = ["postApiV5MessagesIdSend"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return jy(o, a);
  }, ...n };
}, t_ = (t) => {
  const e = zy(t);
  return u(e);
}, Hy = (t, e) => r(
  {
    url: `/api/v5/messages/${t}/participants`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: e
  }
), Jy = (t) => {
  const e = ["patchApiV5MessagesIdParticipants"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, data: a } = i ?? {};
    return Hy(o, a);
  }, ...n };
}, e_ = (t) => {
  const e = Jy(t);
  return u(e);
}, Yy = (t) => r(
  {
    url: `/api/v5/messages/${t}/discard`,
    method: "DELETE"
  }
), Zy = (t) => {
  const e = ["deleteApiV5MessagesIdDiscard"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Yy(o);
  }, ...n };
}, n_ = (t) => {
  const e = Zy(t);
  return u(e);
}, Xy = (t, e) => r(
  {
    url: `/api/v5/messages/threads/${t}/archive`,
    method: "POST",
    signal: e
  }
), tf = (t) => {
  const e = ["postApiV5MessagesThreadsIdArchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return Xy(o);
  }, ...n };
}, s_ = (t) => {
  const e = tf(t);
  return u(e);
}, ef = (t, e) => r(
  {
    url: "/api/v5/messages/bulk/archive",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), nf = (t) => {
  const e = ["postApiV5MessagesBulkArchive"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return ef(o);
  }, ...n };
}, i_ = (t) => {
  const e = nf(t);
  return u(e);
}, sf = (t) => r(
  {
    url: `/api/v5/messages/${t}/pin`,
    method: "PATCH"
  }
), of = (t) => {
  const e = ["patchApiV5MessagesIdPin"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return sf(o);
  }, ...n };
}, o_ = (t) => {
  const e = of(t);
  return u(e);
}, rf = (t) => r(
  {
    url: `/api/v5/messages/threads/${t}/pin`,
    method: "PATCH"
  }
), af = (t) => {
  const e = ["patchApiV5MessagesThreadsThreadIdPin"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { threadId: o } = i ?? {};
    return rf(o);
  }, ...n };
}, r_ = (t) => {
  const e = af(t);
  return u(e);
}, uf = (t) => r(
  {
    url: `/api/v5/messages/${t}/mark_unread`,
    method: "PATCH"
  }
), cf = (t) => {
  const e = ["patchApiV5MessagesIdMarkUnread"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o } = i ?? {};
    return uf(o);
  }, ...n };
}, a_ = (t) => {
  const e = cf(t);
  return u(e);
}, mf = (t, e) => r(
  {
    url: "/api/v5/messages/documents/from_templates",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), pf = (t) => {
  const e = ["postApiV5MessagesDocumentsFromTemplates"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return mf(o);
  }, ...n };
}, u_ = (t) => {
  const e = pf(t);
  return u(e);
}, df = (t, e) => r(
  {
    url: `/api/v5/messages/${t}/documents/${e}`,
    method: "DELETE"
  }
), lf = (t) => {
  const e = ["deleteApiV5MessagesMessageIdDocumentsDocumentId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { messageId: o, documentId: a } = i ?? {};
    return df(o, a);
  }, ...n };
}, c_ = (t) => {
  const e = lf(t);
  return u(e);
}, yf = (t) => r(
  {
    url: "/api/v5/onboarding/start",
    method: "POST",
    signal: t
  }
), ff = (t) => {
  const e = ["postApiV5OnboardingStart"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => yf(), ...n };
}, m_ = (t) => {
  const e = ff(t);
  return u(e);
}, Af = (t) => r(
  {
    url: "/api/v5/onboarding/complete",
    method: "POST",
    signal: t
  }
), gf = (t) => {
  const e = ["postApiV5OnboardingComplete"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => Af(), ...n };
}, p_ = (t) => {
  const e = gf(t);
  return u(e);
}, hf = (t) => r(
  {
    url: "/api/v5/onboarding/skip",
    method: "POST",
    signal: t
  }
), Ff = (t) => {
  const e = ["postApiV5OnboardingSkip"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: () => hf(), ...n };
}, d_ = (t) => {
  const e = Ff(t);
  return u(e);
}, qf = (t) => r(
  {
    url: "/api/v5/pain_points",
    method: "GET",
    signal: t
  }
), _f = () => ["/api/v5/pain_points"], Vf = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? _f(), queryFn: ({ signal: i }) => qf(i), ...e };
};
function l_(t) {
  const e = Vf(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Rf = (t) => r(
  {
    url: "/api/v5/profile",
    method: "GET",
    signal: t
  }
), Kf = () => ["/api/v5/profile"], Tf = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? Kf(), queryFn: ({ signal: i }) => Rf(i), ...e };
};
function y_(t) {
  const e = Tf(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const vf = (t, e) => r(
  {
    url: `/api/v5/requests/${t}/schedule_k1s`,
    method: "GET",
    signal: e
  }
), If = (t) => [`/api/v5/requests/${t}/schedule_k1s`], wf = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? If(t), queryFn: ({ signal: o }) => vf(t, o), enabled: !!t, ...n };
};
function f_(t, e) {
  const n = wf(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Of = (t, e, n) => r(
  {
    url: `/api/v5/requests/${t}/tax_return_form`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), kf = (t) => {
  const e = ["postApiV5RequestsRequestIdTaxReturnForm"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestId: o, data: a } = i ?? {};
    return Of(o, a);
  }, ...n };
}, A_ = (t) => {
  const e = kf(t);
  return u(e);
}, Sf = (t, e, n) => r(
  {
    url: `/api/v5/requests/${t}/tax_return_form/${e}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: n
  }
), Df = (t) => {
  const e = ["putApiV5RequestsRequestIdTaxReturnFormId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestId: o, id: a, data: d } = i ?? {};
    return Sf(o, a, d);
  }, ...n };
}, g_ = (t) => {
  const e = Df(t);
  return u(e);
}, Pf = (t, e) => r(
  {
    url: `/api/v5/requests/${t}/tax_return_form/${e}`,
    method: "DELETE"
  }
), Cf = (t) => {
  const e = ["deleteApiV5RequestsRequestIdTaxReturnFormId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { requestId: o, id: a } = i ?? {};
    return Pf(o, a);
  }, ...n };
}, h_ = (t) => {
  const e = Cf(t);
  return u(e);
}, Ef = (t, e) => r(
  {
    url: `/api/v5/requests/${t}/tax_return/todos`,
    method: "GET",
    signal: e
  }
), Gf = (t) => [`/api/v5/requests/${t}/tax_return/todos`], bf = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Gf(t), queryFn: ({ signal: o }) => Ef(t, o), enabled: !!t, ...n };
};
function F_(t, e) {
  const n = bf(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const xf = (t, e) => r(
  {
    url: `/api/v5/requests/${t}/tax_return`,
    method: "GET",
    signal: e
  }
), Uf = (t) => [`/api/v5/requests/${t}/tax_return`], $f = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Uf(t), queryFn: ({ signal: o }) => xf(t, o), enabled: !!t, ...n };
};
function q_(t, e) {
  const n = $f(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Mf = (t, e) => r(
  {
    url: `/api/v5/workflow/${t}/to_pdf`,
    method: "GET",
    responseType: "blob",
    signal: e
  }
), Nf = (t) => [`/api/v5/workflow/${t}/to_pdf`], Wf = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Nf(t), queryFn: ({ signal: o }) => Mf(t, o), enabled: !!t, ...n };
};
function __(t, e) {
  const n = Wf(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Lf = (t, e, n) => r(
  {
    url: `/api/v5/account/${t}/tax_returns/zip_package`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: e,
    signal: n
  }
), Qf = (t) => {
  const e = ["postApiV5AccountAccountIdTaxReturnsZipPackage"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { accountId: o, data: a } = i ?? {};
    return Lf(o, a);
  }, ...n };
}, V_ = (t) => {
  const e = Qf(t);
  return u(e);
}, Bf = (t, e) => r(
  {
    url: "/api/v5/terms_and_conditions/accept",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), jf = (t) => {
  const e = ["postApiV5TermsAndConditionsAccept"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return Bf(o);
  }, ...n };
}, R_ = (t) => {
  const e = jf(t);
  return u(e);
}, zf = (t, e) => r(
  {
    url: "/api/v5/terms_and_conditions",
    method: "GET",
    params: t,
    signal: e
  }
), Hf = (t) => ["/api/v5/terms_and_conditions", ...t ? [t] : []], Jf = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Hf(t), queryFn: ({ signal: o }) => zf(t, o), ...n };
};
function K_(t, e) {
  const n = Jf(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Yf = (t, e) => r(
  {
    url: "/api/v5/user_journey_steps",
    method: "GET",
    params: t,
    signal: e
  }
), Zf = (t) => ["/api/v5/user_journey_steps", ...t ? [t] : []], Xf = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Zf(t), queryFn: ({ signal: o }) => Yf(t, o), ...n };
};
function T_(t, e) {
  const n = Xf(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const tA = (t, e) => r(
  {
    url: "/api/v5/user_journey_steps",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), eA = (t) => {
  const e = ["postApiV5UserJourneySteps"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return tA(o);
  }, ...n };
}, v_ = (t) => {
  const e = eA(t);
  return u(e);
}, I_ = {
  proseries: "proseries",
  cch: "cch",
  lacerte: "lacerte",
  ultratax: "ultratax",
  ultratax_lite: "ultratax_lite",
  drake: "drake"
}, w_ = {
  pending_review: "pending_review",
  approved: "approved"
}, O_ = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, k_ = {
  proseries: "proseries",
  cch: "cch",
  lacerte: "lacerte",
  ultratax: "ultratax",
  ultratax_lite: "ultratax_lite",
  drake: "drake"
}, S_ = {
  pending_review: "pending_review",
  approved: "approved"
}, D_ = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, P_ = {
  same_firm_same_type: "same_firm_same_type",
  same_firm_any_type: "same_firm_any_type",
  none: "none"
}, C_ = {
  approved: "approved"
}, E_ = {
  feature_disabled: "feature_disabled",
  invalid_prompt: "invalid_prompt",
  invalid_thread_id: "invalid_thread_id",
  invalid_message: "invalid_message",
  thread_not_found: "thread_not_found",
  guardrail_triggered: "guardrail_triggered",
  generation_failed: "generation_failed",
  no_content_generated: "no_content_generated",
  internal_error: "internal_error"
}, G_ = {
  payable: "payable",
  document: "document",
  dynamic: "dynamic",
  signable_document: "signable_document"
}, b_ = {
  boolean: "boolean",
  text: "text",
  firm_authored_text: "firm_authored_text",
  reviewable_document: "reviewable_document",
  signable_document: "signable_document",
  upload_document: "upload_document",
  payable: "payable",
  dynamic: "dynamic"
}, x_ = {
  exact_email: "exact_email",
  partial_email: "partial_email",
  name: "name"
}, U_ = {
  existing_contact: "existing_contact",
  third_party_contact: "third_party_contact"
}, $_ = {
  google: "google",
  outlook: "outlook"
}, M_ = {
  not_requested: "not_requested",
  queued: "queued",
  failed: "failed"
}, N_ = {
  string: "string",
  boolean: "boolean",
  multivalue: "multivalue"
}, W_ = {
  folder_in_use: "folder_in_use"
}, L_ = {
  Folder_is_in_use_and_cannot_be_deleted: "Folder is in use and cannot be deleted"
}, Q_ = {
  smartvault: "smartvault",
  googledrive: "googledrive",
  sharepoint: "sharepoint",
  onedrive: "onedrive",
  box: "box",
  gruntworx: "gruntworx"
}, B_ = {
  Document: "Document",
  Request: "Request"
}, j_ = {
  pending: "pending",
  waiting: "waiting",
  completed: "completed",
  failed: "failed"
}, z_ = {
  pending: "pending",
  waiting: "waiting",
  viewed_agreement: "viewed_agreement",
  signed_name: "signed_name",
  signed_agreement: "signed_agreement",
  passed_kba: "passed_kba",
  failed_kba: "failed_kba",
  other_signatory_failed_kba: "other_signatory_failed_kba"
}, H_ = {
  pending: "pending",
  waiting: "waiting",
  viewed_agreement: "viewed_agreement",
  signed_name: "signed_name",
  signed_agreement: "signed_agreement",
  passed_kba: "passed_kba",
  failed_kba: "failed_kba",
  other_signatory_failed_kba: "other_signatory_failed_kba"
}, J_ = {
  disabled: "disabled",
  enabled: "enabled"
}, Y_ = {
  firm: "firm"
}, Z_ = {
  contact: "contact"
}, X_ = {
  contact: "contact"
}, tV = {
  not_found: "not_found",
  archive_failed: "archive_failed"
}, eV = {
  not_found: "not_found",
  delete_failed: "delete_failed"
}, nV = {
  not_found: "not_found",
  review_failed: "review_failed"
}, sV = {
  not_found: "not_found",
  forbidden: "forbidden",
  ineligible: "ineligible",
  state_conflict: "state_conflict",
  move_failed: "move_failed"
}, iV = {
  not_found: "not_found",
  no_stored_file: "no_stored_file",
  not_pdf: "not_pdf",
  workflow_failed: "workflow_failed",
  review_failed: "review_failed"
}, oV = {
  not_found: "not_found",
  share_unavailable: "share_unavailable",
  share_failed: "share_failed"
}, rV = {
  not_found: "not_found",
  unarchive_failed: "unarchive_failed"
}, aV = {
  not_found: "not_found",
  update_failed: "update_failed"
}, uV = {
  category: "category",
  year: "year",
  month: "month",
  quarter: "quarter"
}, cV = {
  organizer: "organizer",
  tax_delivery: "tax_delivery"
}, mV = {
  employee: "employee"
}, pV = {
  original: "original",
  ai: "ai",
  user: "user"
}, dV = {
  manual: "manual",
  message: "message",
  task: "task",
  note: "note",
  request: "request",
  bill: "bill",
  edoc: "edoc",
  imported: "imported",
  text_message: "text_message",
  multiple: "multiple",
  other: "other"
}, lV = {
  message: "message",
  task: "task",
  bill: "bill",
  note: "note"
}, yV = {
  original: "original",
  ai: "ai",
  user: "user"
}, fV = {
  organizer: "organizer",
  tax_delivery: "tax_delivery"
}, AV = {
  firm: "firm",
  account: "account"
}, gV = {
  firm: "firm",
  account: "account"
}, hV = {
  placed: "placed",
  unchanged: "unchanged"
}, FV = {
  contact: "contact",
  employee: "employee"
}, qV = {
  completed: "completed",
  not_applicable: "not_applicable"
}, _V = {
  pending_review: "pending_review",
  approved: "approved"
}, VV = {
  organizer: "organizer",
  tax_return: "tax_return"
}, RV = {
  draft: "draft",
  sent_to_client: "sent_to_client",
  opened: "opened",
  in_progress: "in_progress",
  submitted: "submitted",
  archived: "archived",
  recalled: "recalled",
  deleted: "deleted"
}, KV = {
  original: "original",
  ai: "ai",
  user: "user"
}, TV = {
  file: "file"
}, vV = {
  category: "category",
  year: "year",
  month: "month",
  quarter: "quarter"
}, IV = {
  unprocessed: "unprocessed",
  unclassified: "unclassified",
  unmapped_type: "unmapped_type",
  missing_year: "missing_year",
  missing_month: "missing_month",
  classification_error: "classification_error"
}, wV = {
  contact: "contact",
  employee: "employee"
}, OV = {
  tax_delivery: "tax_delivery",
  tax_organizer: "tax_organizer",
  standard: "standard"
}, kV = {
  request: "request",
  section_item: "section_item"
}, SV = {
  firm: "firm",
  client: "client"
}, DV = {
  deterministic: "deterministic"
}, PV = {
  gruntworx: "gruntworx"
}, CV = {
  what_to_do_today: "what_to_do_today"
}, EV = {
  created_at: "created_at",
  display_name: "display_name",
  tags: "tags",
  upload_file_month: "upload_file_month",
  upload_file_year: "upload_file_year"
}, GV = {
  asc: "asc",
  desc: "desc"
}, bV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, xV = {
  full: "full",
  shared_path: "shared_path"
}, UV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, $V = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, MV = {
  name: "name",
  "-name": "-name",
  year: "year",
  "-year": "-year",
  month: "month",
  "-month": "-month",
  uploaded_by: "uploaded_by",
  "-uploaded_by": "-uploaded_by",
  created_at: "created_at",
  "-created_at": "-created_at"
}, NV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, WV = {
  category: "category",
  year: "year",
  month: "month",
  quarter: "quarter"
}, LV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, QV = {
  client_upload: "client_upload",
  SharePoint_Import: "SharePoint Import"
}, BV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, jV = {
  name: "name",
  "-name": "-name",
  year: "year",
  "-year": "-year",
  month: "month",
  "-month": "-month",
  uploaded_by: "uploaded_by",
  "-uploaded_by": "-uploaded_by",
  created_at: "created_at",
  "-created_at": "-created_at"
}, zV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, HV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, JV = {
  name: "name",
  "-name": "-name",
  year: "year",
  "-year": "-year",
  month: "month",
  "-month": "-month",
  uploaded_by: "uploaded_by",
  "-uploaded_by": "-uploaded_by",
  created_at: "created_at",
  "-created_at": "-created_at"
}, YV = {
  client_upload: "client_upload",
  SharePoint_Import: "SharePoint Import"
}, ZV = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, XV = {
  name: "name",
  "-name": "-name",
  year: "year",
  "-year": "-year",
  month: "month",
  "-month": "-month",
  uploaded_by: "uploaded_by",
  "-uploaded_by": "-uploaded_by",
  created_at: "created_at",
  "-created_at": "-created_at"
}, tR = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, eR = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, nR = {
  open: "open",
  pending: "pending",
  archived: "archived",
  draft: "draft",
  recalled: "recalled"
}, sR = {
  tax_delivery: "tax_delivery",
  tax_organizer: "tax_organizer",
  standard: "standard"
}, iR = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, oR = {
  with_document: "with_document",
  without_document: "without_document"
}, rR = {
  request: "request",
  section_item: "section_item"
}, aR = {
  approved: "approved",
  pending_review: "pending_review"
}, uR = {
  draft: "draft",
  sent_to_client: "sent_to_client",
  opened: "opened",
  in_progress: "in_progress",
  submitted: "submitted",
  archived: "archived",
  recalled: "recalled"
}, cR = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, mR = {
  firm: "firm",
  client: "client"
}, pR = {
  draft: "draft",
  published: "published",
  archived: "archived"
}, dR = {
  liscio_defined: "liscio_defined",
  firm_defined: "firm_defined"
}, lR = {
  status: "status",
  created_at: "created_at",
  updated_at: "updated_at"
}, yR = {
  asc: "asc",
  desc: "desc"
}, fR = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, AR = {
  client: "client",
  firm: "firm"
}, gR = {
  inbox: "inbox",
  sent: "sent",
  draft: "draft",
  archive: "archive",
  pinned: "pinned",
  alert: "alert",
  all_messages: "all_messages",
  all: "all"
}, hR = {
  firm: "firm",
  client: "client"
}, FR = {
  pending: "pending"
}, qR = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, _R = {
  open: "open",
  pending: "pending",
  archived: "archived",
  draft: "draft",
  recalled: "recalled"
}, VR = {
  tax_delivery: "tax_delivery",
  tax_organizer: "tax_organizer",
  standard: "standard"
}, RR = {
  Internal_Server_Error: "Internal Server Error"
}, KR = {
  NUMBER_500: 500
}, TR = {
  not_applicable: "not_applicable",
  pending: "pending"
}, vR = {
  document: "document"
}, IR = {
  not_applicable: "not_applicable",
  pending: "pending"
}, wR = {
  draft: "draft",
  sent_to_client: "sent_to_client",
  opened: "opened",
  in_progress: "in_progress",
  submitted: "submitted",
  archived: "archived",
  recalled: "recalled"
}, OR = {
  invalid_attachment_origin: "invalid_attachment_origin"
}, kR = {
  direct_upload: "direct_upload",
  liscio_vault: "liscio_vault",
  template: "template"
}, SR = {
  user: "user",
  employee: "employee",
  contact: "contact"
}, DR = {
  active: "active"
}, PR = {
  google: "google",
  outlook: "outlook"
}, CR = {
  request: "request",
  section_item: "section_item"
}, ER = {
  inline: "inline",
  attachment: "attachment"
}, GR = {
  original: "original",
  ai: "ai",
  user: "user"
}, bR = {
  organizer: "organizer",
  tax_return: "tax_return"
}, xR = {
  request: "request",
  section_item: "section_item"
}, UR = {
  email: "email",
  mail: "mail",
  in_person: "in_person",
  message: "message",
  other: "other"
}, $R = {
  confirmed: "confirmed",
  not_found: "not_found",
  error: "error"
}, MR = {
  direct_upload: "direct_upload",
  liscio_vault: "liscio_vault",
  template: "template"
}, NR = {
  message_template: "message_template",
  edoc_template: "edoc_template",
  task_template: "task_template"
}, WR = {
  contact: "contact",
  employee: "employee"
}, LR = {
  inactive_recipients_omitted: "inactive_recipients_omitted"
}, QR = {
  account_unavailable: "account_unavailable",
  no_active_recipients: "no_active_recipients",
  private_documents_acknowledgement_required: "private_documents_acknowledgement_required",
  unprocessable_entity: "unprocessable_entity"
}, BR = {
  user: "user",
  employee: "employee",
  contact: "contact"
}, jR = {
  signup_onboarding: "signup_onboarding",
  dashboard_activation: "dashboard_activation",
  tax_delivery_adoption: "tax_delivery_adoption",
  smart_tax_organizer_adoption: "smart_tax_organizer_adoption",
  client_response_loop: "client_response_loop"
}, zR = {
  not_started: "not_started",
  in_progress: "in_progress",
  completed: "completed",
  skipped: "skipped",
  stalled: "stalled",
  dismissed: "dismissed",
  not_applicable: "not_applicable"
}, HR = {
  original: "original",
  ai: "ai",
  user: "user"
}, JR = {
  what_to_do_today: "what_to_do_today"
}, YR = {
  remind_to_pay: "remind_to_pay",
  notify_withdrawal: "notify_withdrawal",
  no_reminder: "no_reminder"
}, ZR = {
  contact: "contact",
  employee: "employee"
}, XR = {
  remind_to_pay: "remind_to_pay",
  notify_withdrawal: "notify_withdrawal",
  no_reminder: "no_reminder"
}, tK = {
  open: "open",
  pending: "pending",
  archived: "archived",
  draft: "draft",
  recalled: "recalled"
}, eK = {
  tax_delivery: "tax_delivery",
  tax_organizer: "tax_organizer",
  standard: "standard"
}, nK = {
  request: "request",
  section_item: "section_item"
}, sK = {
  email: "email",
  mail: "mail",
  in_person: "in_person",
  message: "message",
  other: "other"
}, iK = {
  client: "client",
  firm: "firm"
}, oK = {
  organizer: "organizer",
  tax_return: "tax_return"
}, rK = {
  organizer: "organizer",
  tax_return: "tax_return"
}, aK = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, uK = {
  not_applicable: "not_applicable",
  pending: "pending"
}, cK = {
  upload: "upload",
  vault: "vault",
  account: "account"
}, mK = {
  pending: "pending",
  reading: "reading",
  done: "done",
  failed: "failed"
}, pK = {
  email: "email",
  mail: "mail",
  in_person: "in_person",
  message: "message",
  other: "other"
}, dK = {
  same: "same",
  similar: "similar",
  check: "check"
}, lK = {
  ready: "ready",
  check: "check",
  none: "none",
  not_on_list: "not_on_list"
}, yK = {
  client: "client",
  firm: "firm"
}, fK = {
  rate_limited: "rate_limited"
}, AK = {
  equals: "equals"
}, gK = {
  completed: "completed",
  not_applicable: "not_applicable",
  pending: "pending"
}, hK = {
  text: "text",
  string: "string",
  boolean: "boolean",
  select: "select",
  date: "date",
  number: "number",
  file: "file"
}, FK = {
  sent_to_client: "sent_to_client",
  opened: "opened",
  in_progress: "in_progress",
  submitted: "submitted"
}, qK = {
  submitted: "submitted"
}, _K = {
  text: "text",
  boolean: "boolean",
  file: "file"
}, VK = {
  standard: "standard",
  state: "state",
  document_request_list: "document_request_list",
  firm_custom: "firm_custom"
}, RK = {
  draft: "draft",
  published: "published",
  archived: "archived"
}, KK = {
  untyped_state_section: "untyped_state_section",
  missing_document_request_list: "missing_document_request_list"
}, TK = {
  liscio_defined: "liscio_defined",
  firm_defined: "firm_defined"
}, vK = {
  validation: "validation",
  processing: "processing",
  system: "system"
}, IK = {
  organizer: "organizer",
  tax_delivery: "tax_delivery"
}, wK = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, OK = {
  validation: "validation",
  processing: "processing",
  system: "system"
}, kK = {
  organizer: "organizer",
  tax_delivery: "tax_delivery"
}, SK = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, DK = {
  connected: "connected",
  disconnected: "disconnected",
  inactive_employee: "inactive_employee",
  no_owner: "no_owner"
}, PK = {
  synced: "synced",
  partial: "partial",
  needs_reconnect: "needs_reconnect",
  no_readable_vault: "no_readable_vault",
  never_synced: "never_synced",
  no_owner_set: "no_owner_set",
  sync_error: "sync_error"
}, CK = {
  alabama: "alabama",
  alaska: "alaska",
  arizona: "arizona",
  arkansas: "arkansas",
  california: "california",
  colorado: "colorado",
  connecticut: "connecticut",
  delaware: "delaware",
  district_of_columbia: "district_of_columbia",
  florida: "florida",
  georgia: "georgia",
  hawaii: "hawaii",
  idaho: "idaho",
  illinois: "illinois",
  indiana: "indiana",
  iowa: "iowa",
  kansas: "kansas",
  kentucky: "kentucky",
  louisiana: "louisiana",
  maine: "maine",
  maryland: "maryland",
  massachusetts: "massachusetts",
  michigan: "michigan",
  minnesota: "minnesota",
  mississippi: "mississippi",
  missouri: "missouri",
  montana: "montana",
  nebraska: "nebraska",
  nevada: "nevada",
  new_hampshire: "new_hampshire",
  new_jersey: "new_jersey",
  new_mexico: "new_mexico",
  new_york: "new_york",
  north_carolina: "north_carolina",
  north_dakota: "north_dakota",
  ohio: "ohio",
  oklahoma: "oklahoma",
  oregon: "oregon",
  pennsylvania: "pennsylvania",
  rhode_island: "rhode_island",
  south_carolina: "south_carolina",
  south_dakota: "south_dakota",
  tennessee: "tennessee",
  texas: "texas",
  utah: "utah",
  vermont: "vermont",
  virginia: "virginia",
  washington: "washington",
  west_virginia: "west_virginia",
  wisconsin: "wisconsin",
  wyoming: "wyoming"
}, EK = {
  personal: "personal",
  business: "business"
}, GK = {
  Client: "Client",
  Firm_Admin: "Firm Admin",
  Firm_Employee: "Firm Employee",
  Firm_Frontdesk: "Firm Frontdesk",
  Specialist: "Specialist"
}, bK = {
  direct_upload: "direct_upload",
  liscio_vault: "liscio_vault",
  template: "template"
}, xK = {
  Draft: "Draft"
}, UK = {
  active: "active",
  archived: "archived",
  unavailable: "unavailable"
}, $K = {
  active: "active",
  archived: "archived",
  unavailable: "unavailable"
}, MK = {
  contact: "contact",
  employee: "employee",
  unavailable: "unavailable"
}, NK = {
  direct_upload: "direct_upload",
  liscio_vault: "liscio_vault",
  template: "template"
}, WK = {
  Sent: "Sent"
}, LK = {
  Draft: "Draft",
  Sent: "Sent"
}, QK = {
  user: "user",
  contact: "contact"
}, BK = {
  user: "user",
  contact: "contact"
}, jK = {
  direct_upload: "direct_upload",
  liscio_vault: "liscio_vault",
  template: "template"
}, zK = {
  Draft: "Draft"
}, HK = {
  employee: "employee",
  contact: "contact"
}, JK = {
  pending: "pending"
};
function YK(t, e) {
  return r({
    url: "/api/v5/auth/magic_links/handoff",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${e}`
    },
    data: t
  });
}
const wt = (t, e) => r(
  {
    url: "/api/v3/liscio_vault_files",
    method: "GET",
    params: t,
    signal: e
  }
), Ot = (t) => ["/api/v3/liscio_vault_files", ...t ? [t] : []], kt = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ot(t), queryFn: ({ signal: o }) => wt(t, o), ...n };
};
function nA(t, e) {
  const n = kt(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const St = (t, e, n) => r(
  {
    url: `/api/v3/get_document_details/${t}`,
    method: "GET",
    params: e,
    signal: n
  }
), Dt = (t, e) => [`/api/v3/get_document_details/${t}`, ...e ? [e] : []], Pt = (t, e, n) => {
  const { query: s } = n ?? {};
  return { queryKey: (s == null ? void 0 : s.queryKey) ?? Dt(t, e), queryFn: ({ signal: a }) => St(t, e, a), enabled: !!t, ...s };
};
function sA(t, e, n) {
  const s = Pt(t, e, n), i = c(s);
  return i.queryKey = s.queryKey, i;
}
const Ct = (t, e) => r(
  {
    url: "/api/v3/edoc_requests",
    method: "GET",
    params: t,
    signal: e
  }
), Et = (t) => ["/api/v3/edoc_requests", ...t ? [t] : []], Gt = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Et(t), queryFn: ({ signal: o }) => Ct(t, o), ...n };
};
function iA(t, e) {
  const n = Gt(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const bt = (t, e) => r(
  {
    url: `/api/v3/edoc_requests/${t}`,
    method: "DELETE",
    params: e
  }
), xt = (t) => {
  const e = ["deleteApiV3EdocRequestsId"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { id: o, params: a } = i ?? {};
    return bt(o, a);
  }, ...n };
}, oA = (t) => {
  const e = xt(t);
  return u(e);
}, Ut = (t) => r(
  {
    url: "/api/v3/adobe_web_access_url",
    method: "GET",
    signal: t
  }
), $t = () => ["/api/v3/adobe_web_access_url"], Mt = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? $t(), queryFn: ({ signal: i }) => Ut(i), ...e };
};
function rA(t) {
  const e = Mt(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const Nt = (t, e) => r(
  {
    url: `/api/v3/get_agreement_preview/${t}`,
    method: "GET",
    signal: e
  }
), Wt = (t) => [`/api/v3/get_agreement_preview/${t}`], Lt = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Wt(t), queryFn: ({ signal: o }) => Nt(t, o), enabled: !!t, ...n };
};
function aA(t, e) {
  const n = Lt(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Qt = (t, e) => r(
  {
    url: `/api/v3/get_audit_trail/${t}`,
    method: "GET",
    signal: e
  }
), Bt = (t) => [`/api/v3/get_audit_trail/${t}`], jt = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Bt(t), queryFn: ({ signal: o }) => Qt(t, o), enabled: !!t, ...n };
};
function uA(t, e) {
  const n = jt(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const zt = (t, e) => r(
  {
    url: `/api/v3/get_agreement_from_adobe/${t}`,
    method: "GET",
    signal: e
  }
), Ht = (t) => [`/api/v3/get_agreement_from_adobe/${t}`], Jt = (t, e) => {
  const { query: n } = e ?? {};
  return { queryKey: (n == null ? void 0 : n.queryKey) ?? Ht(t), queryFn: ({ signal: o }) => zt(t, o), enabled: !!t, ...n };
};
function cA(t, e) {
  const n = Jt(t, e), s = c(n);
  return s.queryKey = n.queryKey, s;
}
const Yt = (t) => r(
  {
    url: "/api/v3/get_default_recipient",
    method: "GET",
    signal: t
  }
), Zt = () => ["/api/v3/get_default_recipient"], Xt = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? Zt(), queryFn: ({ signal: i }) => Yt(i), ...e };
};
function mA(t) {
  const e = Xt(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const te = (t) => r(
  {
    url: "/api/v3/gruntworx_integration_status",
    method: "GET",
    signal: t
  }
), ee = () => ["/api/v3/gruntworx_integration_status"], ne = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? ee(), queryFn: ({ signal: i }) => te(i), ...e };
};
function pA(t) {
  const e = ne(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const se = (t, e) => r(
  {
    url: "/api/v3/get_emp_and_contact",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), ie = (t) => {
  const e = ["postApiV3GetEmpAndContact"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return se(o);
  }, ...n };
}, dA = (t) => {
  const e = ie(t);
  return u(e);
}, oe = (t, e) => r(
  {
    url: "/api/v3/messages",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: t,
    signal: e
  }
), re = (t) => {
  const e = ["postApiV3Messages"], { mutation: n } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : { ...t, mutation: { ...t.mutation, mutationKey: e } } : { mutation: { mutationKey: e } };
  return { mutationFn: (i) => {
    const { data: o } = i ?? {};
    return oe(o);
  }, ...n };
}, lA = (t) => {
  const e = re(t);
  return u(e);
}, ae = (t) => r(
  {
    url: "/api/v3/third_party_apps",
    method: "GET",
    signal: t
  }
), ue = () => ["/api/v3/third_party_apps"], ce = (t) => {
  const { query: e } = t ?? {};
  return { queryKey: (e == null ? void 0 : e.queryKey) ?? ue(), queryFn: ({ signal: i }) => ae(i), ...e };
};
function yA(t) {
  const e = ce(t), n = c(e);
  return n.queryKey = e.queryKey, n;
}
const fA = {
  user: "user",
  contact: "contact"
}, AA = {
  contact: "contact",
  emp: "emp"
}, gA = {
  agreement_name: "agreement_name",
  requester: "requester",
  updated_at: "updated_at"
}, hA = {
  asc: "asc",
  desc: "desc"
}, FA = {
  not_exported: "not_exported",
  exporting: "exporting",
  exported: "exported",
  export_failed: "export_failed"
}, qA = {
  not_exported: "not_exported",
  exporting: "exporting",
  exported: "exported",
  export_failed: "export_failed"
}, _A = {
  aws_url_file_name: "aws_url_file_name",
  tags: "tags",
  upload_file_month: "upload_file_month",
  upload_file_year: "upload_file_year"
}, VA = {
  firmuploads: "firmuploads",
  clientuploads: "clientuploads",
  privatefile: "privatefile"
}, RA = {
  asc: "asc",
  desc: "desc"
}, KA = {
  Active: "Active",
  Inactive: "Inactive",
  New: "New"
}, ZK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EmpAndContactOptionAssigneType: fA,
  EmpAndContactOptionType: AA,
  GetApiV3EdocRequestsField: gA,
  GetApiV3EdocRequestsSortBy: hA,
  GetApiV3GetDocumentDetailsId200OneOfDataExportStatusesGoogleDriveStatus: FA,
  GetApiV3GetDocumentDetailsId200OneOfDataExportStatusesSharepointStatus: qA,
  GetApiV3LiscioVaultFilesField: _A,
  GetApiV3LiscioVaultFilesFileUploadedBy: VA,
  GetApiV3LiscioVaultFilesSortBy: RA,
  GruntworxIntegrationStatusResponseDataStatus: KA,
  deleteApiV3EdocRequestsId: bt,
  getApiV3AdobeWebAccessUrl: Ut,
  getApiV3EdocRequests: Ct,
  getApiV3GetAgreementFromAdobeId: zt,
  getApiV3GetAgreementPreviewId: Nt,
  getApiV3GetAuditTrailId: Qt,
  getApiV3GetDefaultRecipient: Yt,
  getApiV3GetDocumentDetailsId: St,
  getApiV3GruntworxIntegrationStatus: te,
  getApiV3LiscioVaultFiles: wt,
  getApiV3ThirdPartyApps: ae,
  getDeleteApiV3EdocRequestsIdMutationOptions: xt,
  getGetApiV3AdobeWebAccessUrlQueryKey: $t,
  getGetApiV3AdobeWebAccessUrlQueryOptions: Mt,
  getGetApiV3EdocRequestsQueryKey: Et,
  getGetApiV3EdocRequestsQueryOptions: Gt,
  getGetApiV3GetAgreementFromAdobeIdQueryKey: Ht,
  getGetApiV3GetAgreementFromAdobeIdQueryOptions: Jt,
  getGetApiV3GetAgreementPreviewIdQueryKey: Wt,
  getGetApiV3GetAgreementPreviewIdQueryOptions: Lt,
  getGetApiV3GetAuditTrailIdQueryKey: Bt,
  getGetApiV3GetAuditTrailIdQueryOptions: jt,
  getGetApiV3GetDefaultRecipientQueryKey: Zt,
  getGetApiV3GetDefaultRecipientQueryOptions: Xt,
  getGetApiV3GetDocumentDetailsIdQueryKey: Dt,
  getGetApiV3GetDocumentDetailsIdQueryOptions: Pt,
  getGetApiV3GruntworxIntegrationStatusQueryKey: ee,
  getGetApiV3GruntworxIntegrationStatusQueryOptions: ne,
  getGetApiV3LiscioVaultFilesQueryKey: Ot,
  getGetApiV3LiscioVaultFilesQueryOptions: kt,
  getGetApiV3ThirdPartyAppsQueryKey: ue,
  getGetApiV3ThirdPartyAppsQueryOptions: ce,
  getPostApiV3GetEmpAndContactMutationOptions: ie,
  getPostApiV3MessagesMutationOptions: re,
  postApiV3GetEmpAndContact: se,
  postApiV3Messages: oe,
  useDeleteApiV3EdocRequestsId: oA,
  useGetApiV3AdobeWebAccessUrl: rA,
  useGetApiV3EdocRequests: iA,
  useGetApiV3GetAgreementFromAdobeId: cA,
  useGetApiV3GetAgreementPreviewId: aA,
  useGetApiV3GetAuditTrailId: uA,
  useGetApiV3GetDefaultRecipient: mA,
  useGetApiV3GetDocumentDetailsId: sA,
  useGetApiV3GruntworxIntegrationStatus: pA,
  useGetApiV3LiscioVaultFiles: nA,
  useGetApiV3ThirdPartyApps: yA,
  usePostApiV3GetEmpAndContact: dA,
  usePostApiV3Messages: lA
}, Symbol.toStringTag, { value: "Module" })), XK = (t) => {
  var n, s;
  const e = t;
  if (typeof ((s = (n = e == null ? void 0 : e.errors) == null ? void 0 : n[0]) == null ? void 0 : s.message) == "string")
    return e.errors[0].message;
  if (typeof (t == null ? void 0 : t.error) == "string")
    return t == null ? void 0 : t.error;
}, tT = (t) => {
  var n, s;
  const e = t;
  return (s = (n = e == null ? void 0 : e.errors) == null ? void 0 : n[0]) == null ? void 0 : s.type;
};
var TA = /* @__PURE__ */ ((t) => (t.expired_link = "expired_link", t.invalid_link = "invalid_link", t.inactive = "inactive", t.invalid_credentials = "invalid_credentials", t.invalid_sign_in_method = "invalid_sign_in_method", t.locked_out = "locked_out", t.magic_link_generated = "magic_link_generated", t.password_reset_generated = "password_reset_generated", t.password_reset_success = "password_reset_success", t.two_factor_invalid = "two_factor_invalid", t.unauthorized = "unauthorized", t.unprocessable = "unprocessable", t.password_mismatch = "password_mismatch", t.password_strength = "password_strength", t.password_reused = "password_reused", t.cpa_not_found = "cpa_not_found", t.firm_requires_mfa = "firm_requires_mfa", t))(TA || {});
const eT = "Unauthorized", nT = 629145600, sT = 600, iT = 1900, oT = 2100;
function rT(t) {
  const e = Be(t.baseURL);
  return e.interceptors.request.use(async (n) => {
    const s = Qe();
    return n.headers["X-Request-Id"] = s, n;
  }), Tn(e), {
    cpa: Ze(e),
    sms: An(e),
    documents: nn(e),
    contacts: He(e),
    contactsV5: Je(e),
    contactsV5Firms: Ye(e),
    accounts: je(e),
    firmAccounts: ze(e),
    tasks: gn(e),
    messages: sn(e),
    notes: on(e),
    templates: hn(e),
    users: Rn(e),
    devices: qn(e),
    auth: Fn(e),
    owners: an(e),
    security: Vn(e),
    registration: _n(e),
    workflows: Kn(e),
    notifications: rn(e),
    client: e
  };
}
export {
  vn as AccountStatus,
  I_ as AdminRfiDocumentInsightsOrganizerType,
  w_ as AdminRfiDocumentInsightsRequestReviewStatus,
  O_ as AdminRfiDocumentInsightsStatus,
  k_ as AdminRfiDocumentSummaryOrganizerType,
  S_ as AdminRfiDocumentSummaryRequestReviewStatus,
  D_ as AdminRfiDocumentSummaryStatus,
  P_ as AdminRfiNextDocumentResponseMetaMatchType,
  C_ as AdminRfiRequestApproveResponseDataReviewStatus,
  E_ as AiMessageErrorResponseError,
  TA as AuthErrorMessageTypes,
  G_ as BaseRequestItemsSchemaDependencyType,
  b_ as BaseRequestItemsSchemaItemType,
  tn as ClientOrFirm,
  x_ as ContactLookupByEmailMatchSchemaMatchType,
  U_ as ContactLookupByEmailMatchSchemaSource,
  $_ as ContactLookupByEmailMatchSchemaSourceProvider,
  M_ as ContactShowSchemaInvitationStatus,
  In as ContactStatus,
  N_ as CpaSettingUpdateRequestType,
  oT as DOCUMENT_METADATA_YEAR_MAX,
  iT as DOCUMENT_METADATA_YEAR_MIN,
  WA as DefaultWorkflowItemFragment2,
  W_ as DeleteApiV5FirmsFoldersFolderId409ErrorsItemCode,
  L_ as DeleteApiV5FirmsFoldersFolderId409ErrorsItemMessage,
  Q_ as DmsFileExportRequestAppKey,
  B_ as DmsFileExportRequestSource,
  j_ as EsignAgreementObjectStatus,
  z_ as EsignAgreementSignatoryNoUrlsObjectStatus,
  H_ as EsignAgreementSignatoryTypeObjectStatus,
  J_ as ExperienceStatusSchema,
  Y_ as FilesFirmTreeResponseDataRoot,
  Z_ as FirmAccountlessContactSchemaType,
  X_ as FirmContactForAccountSchemaType,
  tV as FirmDocumentBulkArchiveFailureCode,
  eV as FirmDocumentBulkDeleteFailureCode,
  nV as FirmDocumentBulkMarkReviewedFailureCode,
  sV as FirmDocumentBulkMoveFailureCode,
  iV as FirmDocumentBulkRouteToSmartTaxFailureCode,
  oV as FirmDocumentBulkShareFailureCode,
  rV as FirmDocumentBulkUnarchiveFailureCode,
  aV as FirmDocumentBulkUpdateMetadataFailureCode,
  uV as FirmDocumentTypeCatalogCategoriesItemFolderLevelsItem,
  cV as FirmDocumentsBulkRouteToSmartTaxInputWorkflow,
  mV as FirmEmployeeSchemaType,
  pV as FirmFileDetailNameSource,
  dV as FirmFileDetailSource,
  lV as FirmFileDetailSourceTargetType,
  yV as FirmFileIndexNameSource,
  fV as FirmFileLastRoutingEventDestination,
  AV as FirmFilesFolderOwnerType,
  gV as FirmFilesFolderTreeRootType,
  hV as FirmFilesPlacementStatus,
  FV as FirmFilesUploaderType,
  qV as FirmRfiRequestFirmValueUpdateResponseDataStatus,
  _V as FirmRfiRequestReviewStatus,
  VV as FirmRfiRequestSourceKind,
  RV as FirmRfiRequestStatus,
  KV as FolderViewFileLeafNameSource,
  TV as FolderViewFileLeafType,
  vV as FolderViewNodeLevel,
  IV as FolderViewUnresolvedRowReason,
  wV as GetApiV5ClientsContacts200DataItemType,
  OV as GetApiV5ClientsRequestsRequestId200RequestType,
  kV as GetApiV5ClientsRfiRequestsRequestUuidAttachmentsAttachedTo,
  SV as GetApiV5ClientsRfiRequestsUuidToPdfLayout,
  DV as GetApiV5FilesIdNamingSuggestions200Source,
  PV as GetApiV5FirmsAppConnectionsDmsFileExportsStatusAppKey,
  CV as GetApiV5FirmsDashboardWidgetPreferencesSection,
  EV as GetApiV5FirmsDocumentsLiscioVaultSortField,
  GV as GetApiV5FirmsDocumentsLiscioVaultSortOrder,
  bV as GetApiV5FirmsDocumentsLiscioVaultUploaderType,
  xV as GetApiV5FirmsFilesAccounts200DataItemVisibility,
  UV as GetApiV5FirmsFilesAccountsAccountIdTreeUploaderType,
  $V as GetApiV5FirmsFilesAccountsUploaderType,
  MV as GetApiV5FirmsFilesDocumentIdLocationSort,
  NV as GetApiV5FirmsFilesDocumentIdLocationUploaderType,
  WV as GetApiV5FirmsFilesDocumentTypes200DataCategoriesItemFolderLevelsItem,
  LV as GetApiV5FirmsFilesFirmTreeUploaderType,
  QV as GetApiV5FirmsFilesPositionTag,
  BV as GetApiV5FirmsFilesPositionUploaderType,
  jV as GetApiV5FirmsFilesRootDocumentsSort,
  zV as GetApiV5FirmsFilesRootDocumentsUploaderType,
  HV as GetApiV5FirmsFilesSearchUploaderType,
  JV as GetApiV5FirmsFilesSort,
  YV as GetApiV5FirmsFilesTag,
  ZV as GetApiV5FirmsFilesUploaderType,
  XV as GetApiV5FirmsFoldersFolderIdDocumentsSort,
  tR as GetApiV5FirmsFoldersFolderIdDocumentsUploaderType,
  eR as GetApiV5FirmsFoldersUploaderType,
  nR as GetApiV5FirmsRequestsStatus,
  sR as GetApiV5FirmsRequestsType,
  iR as GetApiV5FirmsRfiDocumentsStatus,
  oR as GetApiV5FirmsRfiRequestsDocumentFilter,
  rR as GetApiV5FirmsRfiRequestsRequestUuidAttachmentsAttachedTo,
  aR as GetApiV5FirmsRfiRequestsReviewStatus,
  uR as GetApiV5FirmsRfiRequestsStatus,
  cR as GetApiV5FirmsRfiRequestsUuidGruntworxExportStatus200Status,
  mR as GetApiV5FirmsRfiRequestsUuidToPdfLayout,
  pR as GetApiV5FirmsRfiTemplatesStatus,
  dR as GetApiV5FirmsRfiTemplatesType,
  lR as GetApiV5FirmsRpaDocumentsSort,
  yR as GetApiV5FirmsRpaDocumentsSortOrder,
  fR as GetApiV5FirmsRpaDocumentsStatus,
  AR as GetApiV5IntercomSettingsWorkspace,
  gR as GetApiV5MessagesTab,
  hR as GetApiV5TermsAndConditionsAudience,
  FR as GruntworxExportStartedStatus,
  qR as GruntworxExportStatusStatus,
  _R as IndexRequestSchemaDataItemStatus,
  VR as IndexRequestSchemaDataItemType,
  RR as InternalServerErrorResponseErrorsItemError,
  KR as InternalServerErrorResponseErrorsItemStatus,
  nT as MAX_FILE_SIZE_IN_BYTES,
  sT as MAX_FILE_SIZE_IN_MB,
  On as MESSAGE_ERROR_CODES,
  wn as MessageStatus,
  TR as PatchApiV5ClientsRfiRequestsRequestUuidItemsBodyStatus,
  vR as PatchApiV5FirmsRequestsRequestIdSectionsSectionIdItemsItemIdResponseBodyValueOneOfItemType,
  IR as PatchApiV5FirmsRfiRequestsRequestUuidItemsBodyStatus,
  wR as PatchApiV5FirmsRfiRequestsUuidBodyStatus,
  OR as PatchApiV5MessagesId422ErrorsItemType,
  kR as PatchApiV5MessagesIdBodyAttachmentOriginsItemOrigin,
  SR as PatchApiV5MessagesIdParticipantsBodyParticipantsItemType,
  DR as PostApiV5AuthSelfSignupInvitationsValidate200Status,
  PR as PostApiV5AuthSelfSignupSsoBodyLoginType,
  CR as PostApiV5ClientsRfiRequestsRequestUuidAttachmentsBodyAttachedTo,
  ER as PostApiV5DocumentsSignedUrlsBodyDisposition,
  GR as PostApiV5FilesIdAcceptNamingSuggestion200FileNameSource,
  bR as PostApiV5FirmsRfiDocumentsBodySourceKind,
  xR as PostApiV5FirmsRfiRequestsRequestUuidAttachmentsBodyAttachedTo,
  UR as PostApiV5FirmsRfiRequestsRequestUuidAttachmentsBodyReceivedVia,
  $R as PostApiV5FirmsServiceAliasesBulkConfirm200DataStatus,
  MR as PostApiV5MessagesBodyAttachmentOriginsItemOrigin,
  NR as PostApiV5MessagesDocumentsFromTemplatesBodyTemplateType,
  WR as PostApiV5MessagesIdSend200WarningsItemRecipientsItemType,
  LR as PostApiV5MessagesIdSend200WarningsItemType,
  QR as PostApiV5MessagesIdSend422ErrorsItemType,
  BR as PostApiV5MessagesIdSendBodyParticipantsItemType,
  jR as PostApiV5UserJourneyStepsBodyJourneyKey,
  zR as PostApiV5UserJourneyStepsBodyStatus,
  HR as PutApiV5FilesIdRename200FileNameSource,
  JR as PutApiV5FirmsDashboardWidgetPreferencesWidgetKeyBodySection,
  YR as PutApiV5FirmsRequestsIdBodyReminderType,
  ZR as RecipientWithAccountsSchemaType,
  XR as RequestSchemaReminderType,
  tK as RequestSchemaStatus,
  eK as RequestSchemaType,
  nK as RfiAttachmentAttachedTo,
  sK as RfiAttachmentReceivedVia,
  iK as RfiAttachmentUploadedByRole,
  oK as RfiDocumentEffectiveSourceKind,
  rK as RfiDocumentSourceKind,
  aK as RfiDocumentStatus,
  uK as RfiItemsBulkStatusRequestStatus,
  cK as RfiMatchFileOrigin,
  mK as RfiMatchFileReadingStatus,
  pK as RfiMatchFileReceivedVia,
  dK as RfiMatchFileSuggestionComparisonItemVerdict,
  lK as RfiMatchFileSuggestionKind,
  yK as RfiMatchFileUploadedByRole,
  fK as RfiReminderRateLimitedResponseErrorsItemType,
  AK as RfiRequestItemShowIfOperator,
  gK as RfiRequestItemStatus,
  hK as RfiRequestItemType,
  FK as RfiRequestStatus,
  qK as RfiRequestSubmitResponseDataStatus,
  _K as RfiTemplateItemType,
  VK as RfiTemplateSectionSectionType,
  RK as RfiTemplateStatus,
  KK as RfiTemplateStructureWarningCode,
  TK as RfiTemplateTemplateType,
  Sn as Role,
  CA as RpaDocumentFragment,
  vK as RpaDocumentSchemaErrorCategory,
  IK as RpaDocumentSchemaPipeline,
  wK as RpaDocumentSchemaStatus,
  OK as RpaDocumentsSchemaDataItemErrorCategory,
  kK as RpaDocumentsSchemaDataItemPipeline,
  SK as RpaDocumentsSchemaDataItemStatus,
  DK as ServiceAliasPrimaryOwnerConnectionStatus,
  PK as ServiceAliasSyncStatus,
  CK as StateCode,
  Dn as TaskStatus,
  Pn as TaskType,
  EK as TaxReturnSummaryTaxReturnType,
  eT as UNAUTHORIZED_ERROR_MESSAGE,
  Xe as UploadFormType,
  N as UploadType,
  en as UploaderType,
  GK as UserProfileRole,
  bK as V5DraftMessageDetailDocumentsItemAttachmentOrigin,
  xK as V5DraftMessageDetailStatus,
  UK as V5HistoricalRecipientAccountLifecycleStatus,
  $K as V5HistoricalRecipientLifecycleStatus,
  MK as V5HistoricalRecipientRecipientType,
  NK as V5MessageDetailDocumentsItemAttachmentOrigin,
  WK as V5MessageDetailStatus,
  LK as V5MessageListItemStatus,
  QK as V5ParticipantItemAssigneeType,
  BK as V5ParticipantItemType,
  jK as V5ThreadDraftMessageDetailDocumentsItemAttachmentOrigin,
  zK as V5ThreadDraftMessageDetailStatus,
  HK as V5UpdatedParticipantItemType,
  UA as WorkflowItemConditionFragment2,
  NA as WorkflowItemFragment2,
  $A as WorkflowItemInterfaceFragment2,
  GA as WorkflowRequestFragment,
  xA as WorkflowRequestItemFragment2,
  EA as WorkflowRequestSectionFragment,
  BA as WorkflowResponseItem,
  bA as WorkflowResponseItemFragment2,
  LA as WorkflowSectionFragment,
  QA as WorkflowSignableDocumentItemFragment2,
  JK as ZapierExportQueuedDataStatus,
  ag as createWorkflowItem2MutationDocument,
  eg as createWorkflowsFromWorkflowTemplateDocument,
  r as customApiClient,
  rT as default,
  gi as deleteApiV5AuthPasskeysId,
  Ls as deleteApiV5AuthSignOut,
  Po as deleteApiV5ClientsRfiAttachmentsId,
  Hu as deleteApiV5FirmsCpaWorkflowTemplatesId,
  Cm as deleteApiV5FirmsFoldersFolderId,
  qs as deleteApiV5FirmsPaymentEstimatesId,
  Ga as deleteApiV5FirmsRequestsId,
  Vp as deleteApiV5FirmsRfiAttachmentsId,
  Zp as deleteApiV5FirmsRfiRequestsUuid,
  Xd as deleteApiV5FirmsRfiTemplatesUuid,
  Il as deleteApiV5FirmsServiceAliasesId,
  cy as deleteApiV5FirmsTagsId,
  Qy as deleteApiV5MessagesId,
  Yy as deleteApiV5MessagesIdDiscard,
  df as deleteApiV5MessagesMessageIdDocumentsDocumentId,
  Pf as deleteApiV5RequestsRequestIdTaxReturnFormId,
  cg as deleteWorkflowItemMutationDocument,
  sg as deleteWorkflowTemplateDocument,
  pg as fetchFirmLicense,
  OA as getApiErrorHttpStatus,
  ls as getApiV5AccountsAccountIdPaymentEstimates,
  Ts as getApiV5AccountsAccountIdScheduleK1s,
  ws as getApiV5AccountsAccountIdTaxReturns,
  Ss as getApiV5AccountsAccountIdTaxReturnsTaxReturnId,
  ri as getApiV5AuthPasskeys,
  Si as getApiV5AuthSessions,
  Qi as getApiV5ClientsContacts,
  zi as getApiV5ClientsContactsGroupedByAccount,
  Yi as getApiV5ClientsContactsRecipientAccounts,
  to as getApiV5ClientsEsignAgreementSignatoriesEsignAgreementSignatoryIdSigningStatus,
  so as getApiV5ClientsEsignAgreementsIdSigningStatus,
  uo as getApiV5ClientsEsignAgreementsIdSigningUrls,
  Ao as getApiV5ClientsRequestsRequestId,
  ko as getApiV5ClientsRfiAttachmentsId,
  Uo as getApiV5ClientsRfiRequests,
  To as getApiV5ClientsRfiRequestsRequestUuidAttachments,
  No as getApiV5ClientsRfiRequestsUuid,
  jo as getApiV5ClientsRfiRequestsUuidToPdf,
  Vo as getApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturn,
  Fo as getApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturnTodos,
  er as getApiV5Experiences,
  ir as getApiV5ExperiencesExperienceId,
  gr as getApiV5FilesIdNamingSuggestions,
  Kr as getApiV5FilesIdTagSuggestions,
  yr as getApiV5FilesNamingConfig,
  Sr as getApiV5FilesPendingReview,
  pr as getApiV5FilesPreferredFormat,
  xr as getApiV5FirmPainPointSelections,
  Mr as getApiV5FirmsAccounts,
  Hr as getApiV5FirmsAccountsAccountIdUnusedJurisdictions,
  Br as getApiV5FirmsAccountsId,
  Zr as getApiV5FirmsAdminCpaSettingsKey,
  sa as getApiV5FirmsAdminZapierConfig,
  ma as getApiV5FirmsAppConnectionsDmsFileExportsStatus,
  la as getApiV5FirmsAppConnectionsOauthAccessTokensId,
  Aa as getApiV5FirmsAppConnectionsSharepointExportSettings,
  Fa as getApiV5FirmsAppConnectionsSmartVaultAccessToken,
  gu as getApiV5FirmsContactsAccounts,
  qu as getApiV5FirmsContactsForAccounts,
  vu as getApiV5FirmsContactsGroupedByAccount,
  du as getApiV5FirmsContactsId,
  Eu as getApiV5FirmsContactsIdAccounts,
  Ou as getApiV5FirmsContactsRecipientAccounts,
  Du as getApiV5FirmsContactsSearch,
  Ru as getApiV5FirmsContactsSuggestions,
  Nu as getApiV5FirmsCpaWorkflowTemplates,
  Yu as getApiV5FirmsDashboardWidgetPreferences,
  gc as getApiV5FirmsDocumentsDocumentTypes,
  qc as getApiV5FirmsDocumentsDocumentUuid,
  Tc as getApiV5FirmsDocumentsDocumentUuidAccountOptions,
  ac as getApiV5FirmsDocumentsDocumentUuidAnnotation,
  dc as getApiV5FirmsDocumentsDocumentUuidRotation,
  Zo as getApiV5FirmsDocumentsLiscioVault,
  kc as getApiV5FirmsEmployees,
  nc as getApiV5FirmsFileNamingTemplates,
  Mc as getApiV5FirmsFiles,
  Lc as getApiV5FirmsFilesAccounts,
  Jc as getApiV5FirmsFilesAccountsAccountIdTree,
  um as getApiV5FirmsFilesDocumentId,
  Pc as getApiV5FirmsFilesDocumentIdAccountOptions,
  Vm as getApiV5FirmsFilesDocumentIdLocation,
  pm as getApiV5FirmsFilesDocumentIdShareRecipients,
  Am as getApiV5FirmsFilesDocumentTypes,
  jc as getApiV5FirmsFilesFirmTree,
  om as getApiV5FirmsFilesPosition,
  Fm as getApiV5FirmsFilesRootDocuments,
  xc as getApiV5FirmsFilesSearch,
  Xc as getApiV5FirmsFilesSharepointImportsUnreviewedCount,
  nm as getApiV5FirmsFilesUploaders,
  Um as getApiV5FirmsFolderViewAccountsAccountIdTree,
  Nm as getApiV5FirmsFolderViewAccountsAccountIdUnresolved,
  Im as getApiV5FirmsFolders,
  Gm as getApiV5FirmsFoldersFolderIdDocuments,
  wa as getApiV5FirmsRequests,
  Pa as getApiV5FirmsRequestsId,
  Jm as getApiV5FirmsRequestsRequestIdSections,
  jm as getApiV5FirmsRequestsRequestIdSectionsSectionIdItems,
  Xm as getApiV5FirmsRfiAdminDocuments,
  cp as getApiV5FirmsRfiAdminDocumentsNext,
  np as getApiV5FirmsRfiAdminDocumentsUuid,
  Fp as getApiV5FirmsRfiAttachmentsId,
  Vd as getApiV5FirmsRfiDocuments,
  Id as getApiV5FirmsRfiDocumentsUuid,
  Np as getApiV5FirmsRfiRequests,
  yp as getApiV5FirmsRfiRequestsRequestUuidAttachments,
  Gd as getApiV5FirmsRfiRequestsRequestUuidMatchFiles,
  jp as getApiV5FirmsRfiRequestsUuid,
  vp as getApiV5FirmsRfiRequestsUuidGruntworxExportStatus,
  Op as getApiV5FirmsRfiRequestsUuidToPdf,
  Wd as getApiV5FirmsRfiTemplates,
  zd as getApiV5FirmsRfiTemplatesUuid,
  cl as getApiV5FirmsRpaDocuments,
  fl as getApiV5FirmsRpaDocumentsId,
  dl as getApiV5FirmsRpaDocumentsProcessingCount,
  ql as getApiV5FirmsServiceAliases,
  El as getApiV5FirmsServiceAliasesSuggestions,
  Ml as getApiV5FirmsSmartVaultAccountsAccountIdImportedFolderTree,
  xl as getApiV5FirmsSmartVaultAvailability,
  Ll as getApiV5FirmsSmartVaultSyncRuns,
  Yl as getApiV5FirmsSmartVaultSyncRunsId,
  ty as getApiV5FirmsTags,
  gy as getApiV5FirmsWorkflowTemplates,
  qy as getApiV5FirmsWorkflowTemplatesId,
  py as getApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplates,
  yy as getApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplatesId,
  Ry as getApiV5IntercomSettings,
  xi as getApiV5Me,
  vy as getApiV5Messages,
  Sy as getApiV5MessagesCounts,
  Ny as getApiV5MessagesId,
  by as getApiV5MessagesTemplates,
  Cy as getApiV5MessagesThreadsThreadId,
  qf as getApiV5PainPoints,
  Rf as getApiV5Profile,
  vf as getApiV5RequestsRequestIdScheduleK1s,
  xf as getApiV5RequestsRequestIdTaxReturn,
  Ef as getApiV5RequestsRequestIdTaxReturnTodos,
  zf as getApiV5TermsAndConditions,
  Yf as getApiV5UserJourneySteps,
  Vs as getApiV5WorkflowRequestsWorkflowRequestIdPaymentEstimates,
  Mf as getApiV5WorkflowWorkflowRequestUuidToPdf,
  hi as getDeleteApiV5AuthPasskeysIdMutationOptions,
  Qs as getDeleteApiV5AuthSignOutMutationOptions,
  Co as getDeleteApiV5ClientsRfiAttachmentsIdMutationOptions,
  Ju as getDeleteApiV5FirmsCpaWorkflowTemplatesIdMutationOptions,
  Em as getDeleteApiV5FirmsFoldersFolderIdMutationOptions,
  _s as getDeleteApiV5FirmsPaymentEstimatesIdMutationOptions,
  ba as getDeleteApiV5FirmsRequestsIdMutationOptions,
  Rp as getDeleteApiV5FirmsRfiAttachmentsIdMutationOptions,
  Xp as getDeleteApiV5FirmsRfiRequestsUuidMutationOptions,
  tl as getDeleteApiV5FirmsRfiTemplatesUuidMutationOptions,
  wl as getDeleteApiV5FirmsServiceAliasesIdMutationOptions,
  my as getDeleteApiV5FirmsTagsIdMutationOptions,
  Zy as getDeleteApiV5MessagesIdDiscardMutationOptions,
  By as getDeleteApiV5MessagesIdMutationOptions,
  lf as getDeleteApiV5MessagesMessageIdDocumentsDocumentIdMutationOptions,
  Cf as getDeleteApiV5RequestsRequestIdTaxReturnFormIdMutationOptions,
  ys as getGetApiV5AccountsAccountIdPaymentEstimatesQueryKey,
  fs as getGetApiV5AccountsAccountIdPaymentEstimatesQueryOptions,
  vs as getGetApiV5AccountsAccountIdScheduleK1sQueryKey,
  Is as getGetApiV5AccountsAccountIdScheduleK1sQueryOptions,
  Os as getGetApiV5AccountsAccountIdTaxReturnsQueryKey,
  ks as getGetApiV5AccountsAccountIdTaxReturnsQueryOptions,
  Ds as getGetApiV5AccountsAccountIdTaxReturnsTaxReturnIdQueryKey,
  Ps as getGetApiV5AccountsAccountIdTaxReturnsTaxReturnIdQueryOptions,
  ai as getGetApiV5AuthPasskeysQueryKey,
  ui as getGetApiV5AuthPasskeysQueryOptions,
  Di as getGetApiV5AuthSessionsQueryKey,
  Pi as getGetApiV5AuthSessionsQueryOptions,
  Hi as getGetApiV5ClientsContactsGroupedByAccountQueryKey,
  Ji as getGetApiV5ClientsContactsGroupedByAccountQueryOptions,
  Bi as getGetApiV5ClientsContactsQueryKey,
  ji as getGetApiV5ClientsContactsQueryOptions,
  Zi as getGetApiV5ClientsContactsRecipientAccountsQueryKey,
  Xi as getGetApiV5ClientsContactsRecipientAccountsQueryOptions,
  eo as getGetApiV5ClientsEsignAgreementSignatoriesEsignAgreementSignatoryIdSigningStatusQueryKey,
  no as getGetApiV5ClientsEsignAgreementSignatoriesEsignAgreementSignatoryIdSigningStatusQueryOptions,
  io as getGetApiV5ClientsEsignAgreementsIdSigningStatusQueryKey,
  oo as getGetApiV5ClientsEsignAgreementsIdSigningStatusQueryOptions,
  co as getGetApiV5ClientsEsignAgreementsIdSigningUrlsQueryKey,
  mo as getGetApiV5ClientsEsignAgreementsIdSigningUrlsQueryOptions,
  go as getGetApiV5ClientsRequestsRequestIdQueryKey,
  ho as getGetApiV5ClientsRequestsRequestIdQueryOptions,
  So as getGetApiV5ClientsRfiAttachmentsIdQueryKey,
  Do as getGetApiV5ClientsRfiAttachmentsIdQueryOptions,
  $o as getGetApiV5ClientsRfiRequestsQueryKey,
  Mo as getGetApiV5ClientsRfiRequestsQueryOptions,
  vo as getGetApiV5ClientsRfiRequestsRequestUuidAttachmentsQueryKey,
  Io as getGetApiV5ClientsRfiRequestsRequestUuidAttachmentsQueryOptions,
  Wo as getGetApiV5ClientsRfiRequestsUuidQueryKey,
  Lo as getGetApiV5ClientsRfiRequestsUuidQueryOptions,
  zo as getGetApiV5ClientsRfiRequestsUuidToPdfQueryKey,
  Ho as getGetApiV5ClientsRfiRequestsUuidToPdfQueryOptions,
  Ro as getGetApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturnQueryKey,
  Ko as getGetApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturnQueryOptions,
  qo as getGetApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturnTodosQueryKey,
  _o as getGetApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturnTodosQueryOptions,
  or as getGetApiV5ExperiencesExperienceIdQueryKey,
  rr as getGetApiV5ExperiencesExperienceIdQueryOptions,
  nr as getGetApiV5ExperiencesQueryKey,
  sr as getGetApiV5ExperiencesQueryOptions,
  hr as getGetApiV5FilesIdNamingSuggestionsQueryKey,
  Fr as getGetApiV5FilesIdNamingSuggestionsQueryOptions,
  Tr as getGetApiV5FilesIdTagSuggestionsQueryKey,
  vr as getGetApiV5FilesIdTagSuggestionsQueryOptions,
  fr as getGetApiV5FilesNamingConfigQueryKey,
  Ar as getGetApiV5FilesNamingConfigQueryOptions,
  Dr as getGetApiV5FilesPendingReviewQueryKey,
  Pr as getGetApiV5FilesPendingReviewQueryOptions,
  dr as getGetApiV5FilesPreferredFormatQueryKey,
  lr as getGetApiV5FilesPreferredFormatQueryOptions,
  Ur as getGetApiV5FirmPainPointSelectionsQueryKey,
  $r as getGetApiV5FirmPainPointSelectionsQueryOptions,
  Jr as getGetApiV5FirmsAccountsAccountIdUnusedJurisdictionsQueryKey,
  Yr as getGetApiV5FirmsAccountsAccountIdUnusedJurisdictionsQueryOptions,
  jr as getGetApiV5FirmsAccountsIdQueryKey,
  zr as getGetApiV5FirmsAccountsIdQueryOptions,
  Nr as getGetApiV5FirmsAccountsQueryKey,
  Wr as getGetApiV5FirmsAccountsQueryOptions,
  Xr as getGetApiV5FirmsAdminCpaSettingsKeyQueryKey,
  ta as getGetApiV5FirmsAdminCpaSettingsKeyQueryOptions,
  ia as getGetApiV5FirmsAdminZapierConfigQueryKey,
  oa as getGetApiV5FirmsAdminZapierConfigQueryOptions,
  pa as getGetApiV5FirmsAppConnectionsDmsFileExportsStatusQueryKey,
  da as getGetApiV5FirmsAppConnectionsDmsFileExportsStatusQueryOptions,
  ya as getGetApiV5FirmsAppConnectionsOauthAccessTokensIdQueryKey,
  fa as getGetApiV5FirmsAppConnectionsOauthAccessTokensIdQueryOptions,
  ga as getGetApiV5FirmsAppConnectionsSharepointExportSettingsQueryKey,
  ha as getGetApiV5FirmsAppConnectionsSharepointExportSettingsQueryOptions,
  qa as getGetApiV5FirmsAppConnectionsSmartVaultAccessTokenQueryKey,
  _a as getGetApiV5FirmsAppConnectionsSmartVaultAccessTokenQueryOptions,
  hu as getGetApiV5FirmsContactsAccountsQueryKey,
  Fu as getGetApiV5FirmsContactsAccountsQueryOptions,
  _u as getGetApiV5FirmsContactsForAccountsQueryKey,
  Vu as getGetApiV5FirmsContactsForAccountsQueryOptions,
  Iu as getGetApiV5FirmsContactsGroupedByAccountQueryKey,
  wu as getGetApiV5FirmsContactsGroupedByAccountQueryOptions,
  Gu as getGetApiV5FirmsContactsIdAccountsQueryKey,
  bu as getGetApiV5FirmsContactsIdAccountsQueryOptions,
  lu as getGetApiV5FirmsContactsIdQueryKey,
  yu as getGetApiV5FirmsContactsIdQueryOptions,
  ku as getGetApiV5FirmsContactsRecipientAccountsQueryKey,
  Su as getGetApiV5FirmsContactsRecipientAccountsQueryOptions,
  Pu as getGetApiV5FirmsContactsSearchQueryKey,
  Cu as getGetApiV5FirmsContactsSearchQueryOptions,
  Ku as getGetApiV5FirmsContactsSuggestionsQueryKey,
  Tu as getGetApiV5FirmsContactsSuggestionsQueryOptions,
  Wu as getGetApiV5FirmsCpaWorkflowTemplatesQueryKey,
  Lu as getGetApiV5FirmsCpaWorkflowTemplatesQueryOptions,
  Zu as getGetApiV5FirmsDashboardWidgetPreferencesQueryKey,
  Xu as getGetApiV5FirmsDashboardWidgetPreferencesQueryOptions,
  hc as getGetApiV5FirmsDocumentsDocumentTypesQueryKey,
  Fc as getGetApiV5FirmsDocumentsDocumentTypesQueryOptions,
  vc as getGetApiV5FirmsDocumentsDocumentUuidAccountOptionsQueryKey,
  Ic as getGetApiV5FirmsDocumentsDocumentUuidAccountOptionsQueryOptions,
  uc as getGetApiV5FirmsDocumentsDocumentUuidAnnotationQueryKey,
  cc as getGetApiV5FirmsDocumentsDocumentUuidAnnotationQueryOptions,
  _c as getGetApiV5FirmsDocumentsDocumentUuidQueryKey,
  Vc as getGetApiV5FirmsDocumentsDocumentUuidQueryOptions,
  lc as getGetApiV5FirmsDocumentsDocumentUuidRotationQueryKey,
  yc as getGetApiV5FirmsDocumentsDocumentUuidRotationQueryOptions,
  Xo as getGetApiV5FirmsDocumentsLiscioVaultQueryKey,
  tr as getGetApiV5FirmsDocumentsLiscioVaultQueryOptions,
  Sc as getGetApiV5FirmsEmployeesQueryKey,
  Dc as getGetApiV5FirmsEmployeesQueryOptions,
  sc as getGetApiV5FirmsFileNamingTemplatesQueryKey,
  ic as getGetApiV5FirmsFileNamingTemplatesQueryOptions,
  Yc as getGetApiV5FirmsFilesAccountsAccountIdTreeQueryKey,
  Zc as getGetApiV5FirmsFilesAccountsAccountIdTreeQueryOptions,
  Qc as getGetApiV5FirmsFilesAccountsQueryKey,
  Bc as getGetApiV5FirmsFilesAccountsQueryOptions,
  Cc as getGetApiV5FirmsFilesDocumentIdAccountOptionsQueryKey,
  Ec as getGetApiV5FirmsFilesDocumentIdAccountOptionsQueryOptions,
  Rm as getGetApiV5FirmsFilesDocumentIdLocationQueryKey,
  Km as getGetApiV5FirmsFilesDocumentIdLocationQueryOptions,
  cm as getGetApiV5FirmsFilesDocumentIdQueryKey,
  mm as getGetApiV5FirmsFilesDocumentIdQueryOptions,
  dm as getGetApiV5FirmsFilesDocumentIdShareRecipientsQueryKey,
  lm as getGetApiV5FirmsFilesDocumentIdShareRecipientsQueryOptions,
  gm as getGetApiV5FirmsFilesDocumentTypesQueryKey,
  hm as getGetApiV5FirmsFilesDocumentTypesQueryOptions,
  zc as getGetApiV5FirmsFilesFirmTreeQueryKey,
  Hc as getGetApiV5FirmsFilesFirmTreeQueryOptions,
  rm as getGetApiV5FirmsFilesPositionQueryKey,
  am as getGetApiV5FirmsFilesPositionQueryOptions,
  Nc as getGetApiV5FirmsFilesQueryKey,
  Wc as getGetApiV5FirmsFilesQueryOptions,
  qm as getGetApiV5FirmsFilesRootDocumentsQueryKey,
  _m as getGetApiV5FirmsFilesRootDocumentsQueryOptions,
  Uc as getGetApiV5FirmsFilesSearchQueryKey,
  $c as getGetApiV5FirmsFilesSearchQueryOptions,
  tm as getGetApiV5FirmsFilesSharepointImportsUnreviewedCountQueryKey,
  em as getGetApiV5FirmsFilesSharepointImportsUnreviewedCountQueryOptions,
  sm as getGetApiV5FirmsFilesUploadersQueryKey,
  im as getGetApiV5FirmsFilesUploadersQueryOptions,
  $m as getGetApiV5FirmsFolderViewAccountsAccountIdTreeQueryKey,
  Mm as getGetApiV5FirmsFolderViewAccountsAccountIdTreeQueryOptions,
  Wm as getGetApiV5FirmsFolderViewAccountsAccountIdUnresolvedQueryKey,
  Lm as getGetApiV5FirmsFolderViewAccountsAccountIdUnresolvedQueryOptions,
  bm as getGetApiV5FirmsFoldersFolderIdDocumentsQueryKey,
  xm as getGetApiV5FirmsFoldersFolderIdDocumentsQueryOptions,
  wm as getGetApiV5FirmsFoldersQueryKey,
  Om as getGetApiV5FirmsFoldersQueryOptions,
  Ca as getGetApiV5FirmsRequestsIdQueryKey,
  Ea as getGetApiV5FirmsRequestsIdQueryOptions,
  Oa as getGetApiV5FirmsRequestsQueryKey,
  ka as getGetApiV5FirmsRequestsQueryOptions,
  Ym as getGetApiV5FirmsRequestsRequestIdSectionsQueryKey,
  Zm as getGetApiV5FirmsRequestsRequestIdSectionsQueryOptions,
  zm as getGetApiV5FirmsRequestsRequestIdSectionsSectionIdItemsQueryKey,
  Hm as getGetApiV5FirmsRequestsRequestIdSectionsSectionIdItemsQueryOptions,
  mp as getGetApiV5FirmsRfiAdminDocumentsNextQueryKey,
  pp as getGetApiV5FirmsRfiAdminDocumentsNextQueryOptions,
  tp as getGetApiV5FirmsRfiAdminDocumentsQueryKey,
  ep as getGetApiV5FirmsRfiAdminDocumentsQueryOptions,
  sp as getGetApiV5FirmsRfiAdminDocumentsUuidQueryKey,
  ip as getGetApiV5FirmsRfiAdminDocumentsUuidQueryOptions,
  qp as getGetApiV5FirmsRfiAttachmentsIdQueryKey,
  _p as getGetApiV5FirmsRfiAttachmentsIdQueryOptions,
  Rd as getGetApiV5FirmsRfiDocumentsQueryKey,
  Kd as getGetApiV5FirmsRfiDocumentsQueryOptions,
  wd as getGetApiV5FirmsRfiDocumentsUuidQueryKey,
  Od as getGetApiV5FirmsRfiDocumentsUuidQueryOptions,
  Wp as getGetApiV5FirmsRfiRequestsQueryKey,
  Lp as getGetApiV5FirmsRfiRequestsQueryOptions,
  fp as getGetApiV5FirmsRfiRequestsRequestUuidAttachmentsQueryKey,
  Ap as getGetApiV5FirmsRfiRequestsRequestUuidAttachmentsQueryOptions,
  bd as getGetApiV5FirmsRfiRequestsRequestUuidMatchFilesQueryKey,
  xd as getGetApiV5FirmsRfiRequestsRequestUuidMatchFilesQueryOptions,
  Ip as getGetApiV5FirmsRfiRequestsUuidGruntworxExportStatusQueryKey,
  wp as getGetApiV5FirmsRfiRequestsUuidGruntworxExportStatusQueryOptions,
  zp as getGetApiV5FirmsRfiRequestsUuidQueryKey,
  Hp as getGetApiV5FirmsRfiRequestsUuidQueryOptions,
  kp as getGetApiV5FirmsRfiRequestsUuidToPdfQueryKey,
  Sp as getGetApiV5FirmsRfiRequestsUuidToPdfQueryOptions,
  Ld as getGetApiV5FirmsRfiTemplatesQueryKey,
  Qd as getGetApiV5FirmsRfiTemplatesQueryOptions,
  Hd as getGetApiV5FirmsRfiTemplatesUuidQueryKey,
  Jd as getGetApiV5FirmsRfiTemplatesUuidQueryOptions,
  Al as getGetApiV5FirmsRpaDocumentsIdQueryKey,
  gl as getGetApiV5FirmsRpaDocumentsIdQueryOptions,
  ll as getGetApiV5FirmsRpaDocumentsProcessingCountQueryKey,
  yl as getGetApiV5FirmsRpaDocumentsProcessingCountQueryOptions,
  ml as getGetApiV5FirmsRpaDocumentsQueryKey,
  pl as getGetApiV5FirmsRpaDocumentsQueryOptions,
  _l as getGetApiV5FirmsServiceAliasesQueryKey,
  Vl as getGetApiV5FirmsServiceAliasesQueryOptions,
  Gl as getGetApiV5FirmsServiceAliasesSuggestionsQueryKey,
  bl as getGetApiV5FirmsServiceAliasesSuggestionsQueryOptions,
  Nl as getGetApiV5FirmsSmartVaultAccountsAccountIdImportedFolderTreeQueryKey,
  Wl as getGetApiV5FirmsSmartVaultAccountsAccountIdImportedFolderTreeQueryOptions,
  Ul as getGetApiV5FirmsSmartVaultAvailabilityQueryKey,
  $l as getGetApiV5FirmsSmartVaultAvailabilityQueryOptions,
  Zl as getGetApiV5FirmsSmartVaultSyncRunsIdQueryKey,
  Xl as getGetApiV5FirmsSmartVaultSyncRunsIdQueryOptions,
  Ql as getGetApiV5FirmsSmartVaultSyncRunsQueryKey,
  Bl as getGetApiV5FirmsSmartVaultSyncRunsQueryOptions,
  ey as getGetApiV5FirmsTagsQueryKey,
  ny as getGetApiV5FirmsTagsQueryOptions,
  _y as getGetApiV5FirmsWorkflowTemplatesIdQueryKey,
  Vy as getGetApiV5FirmsWorkflowTemplatesIdQueryOptions,
  fy as getGetApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplatesIdQueryKey,
  Ay as getGetApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplatesIdQueryOptions,
  dy as getGetApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplatesQueryKey,
  ly as getGetApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplatesQueryOptions,
  hy as getGetApiV5FirmsWorkflowTemplatesQueryKey,
  Fy as getGetApiV5FirmsWorkflowTemplatesQueryOptions,
  Ky as getGetApiV5IntercomSettingsQueryKey,
  Ty as getGetApiV5IntercomSettingsQueryOptions,
  Ui as getGetApiV5MeQueryKey,
  $i as getGetApiV5MeQueryOptions,
  Dy as getGetApiV5MessagesCountsQueryKey,
  Py as getGetApiV5MessagesCountsQueryOptions,
  Wy as getGetApiV5MessagesIdQueryKey,
  Ly as getGetApiV5MessagesIdQueryOptions,
  Iy as getGetApiV5MessagesQueryKey,
  wy as getGetApiV5MessagesQueryOptions,
  xy as getGetApiV5MessagesTemplatesQueryKey,
  Uy as getGetApiV5MessagesTemplatesQueryOptions,
  Ey as getGetApiV5MessagesThreadsThreadIdQueryKey,
  Gy as getGetApiV5MessagesThreadsThreadIdQueryOptions,
  _f as getGetApiV5PainPointsQueryKey,
  Vf as getGetApiV5PainPointsQueryOptions,
  Kf as getGetApiV5ProfileQueryKey,
  Tf as getGetApiV5ProfileQueryOptions,
  If as getGetApiV5RequestsRequestIdScheduleK1sQueryKey,
  wf as getGetApiV5RequestsRequestIdScheduleK1sQueryOptions,
  Uf as getGetApiV5RequestsRequestIdTaxReturnQueryKey,
  $f as getGetApiV5RequestsRequestIdTaxReturnQueryOptions,
  Gf as getGetApiV5RequestsRequestIdTaxReturnTodosQueryKey,
  bf as getGetApiV5RequestsRequestIdTaxReturnTodosQueryOptions,
  Hf as getGetApiV5TermsAndConditionsQueryKey,
  Jf as getGetApiV5TermsAndConditionsQueryOptions,
  Zf as getGetApiV5UserJourneyStepsQueryKey,
  Xf as getGetApiV5UserJourneyStepsQueryOptions,
  Rs as getGetApiV5WorkflowRequestsWorkflowRequestIdPaymentEstimatesQueryKey,
  Ks as getGetApiV5WorkflowRequestsWorkflowRequestIdPaymentEstimatesQueryOptions,
  Nf as getGetApiV5WorkflowWorkflowRequestUuidToPdfQueryKey,
  Wf as getGetApiV5WorkflowWorkflowRequestUuidToPdfQueryOptions,
  kn as getMessageErrorCode,
  Hs as getPatchApiV5AuthMagicLinksIdMutationOptions,
  si as getPatchApiV5AuthMfaSetupsMutationOptions,
  Ai as getPatchApiV5AuthPasskeysIdMutationOptions,
  Ki as getPatchApiV5AuthPasswordResetsResetTokenMutationOptions,
  xo as getPatchApiV5ClientsRfiRequestsRequestUuidItemsMutationOptions,
  ur as getPatchApiV5ExperiencesExperienceIdMutationOptions,
  na as getPatchApiV5FirmsAdminCpaSettingsKeyMutationOptions,
  Au as getPatchApiV5FirmsContactsIdMutationOptions,
  Oc as getPatchApiV5FirmsDocumentsDocumentUuidAccountMutationOptions,
  Kc as getPatchApiV5FirmsDocumentsDocumentUuidMetadataMutationOptions,
  lo as getPatchApiV5FirmsEsignAgreementSignatoriesIdMutationOptions,
  bc as getPatchApiV5FirmsFilesDocumentIdAccountMutationOptions,
  fm as getPatchApiV5FirmsFilesDocumentIdMetadataMutationOptions,
  vm as getPatchApiV5FirmsFilesDocumentIdPlacementMutationOptions,
  Pm as getPatchApiV5FirmsFoldersFolderIdMutationOptions,
  Bm as getPatchApiV5FirmsRequestsRequestIdSectionsSectionIdItemsItemIdResponseMutationOptions,
  rp as getPatchApiV5FirmsRfiAdminDocumentsUuidMutationOptions,
  Mp as getPatchApiV5FirmsRfiRequestsBulkUpdateMutationOptions,
  gd as getPatchApiV5FirmsRfiRequestsRequestUuidItemsBulkStatusMutationOptions,
  Fd as getPatchApiV5FirmsRfiRequestsRequestUuidItemsMutationOptions,
  $d as getPatchApiV5FirmsRfiRequestsRequestUuidMatchFilesDocumentIdMutationOptions,
  Yp as getPatchApiV5FirmsRfiRequestsUuidMutationOptions,
  il as getPatchApiV5FirmsRfiTemplatesUuidActivateMutationOptions,
  rl as getPatchApiV5FirmsRfiTemplatesUuidArchiveMutationOptions,
  Zd as getPatchApiV5FirmsRfiTemplatesUuidMutationOptions,
  ul as getPatchApiV5FirmsRfiTemplatesUuidUnarchiveMutationOptions,
  vl as getPatchApiV5FirmsServiceAliasesIdMutationOptions,
  fo as getPatchApiV5FirmsSignersIdMutationOptions,
  uy as getPatchApiV5FirmsTagsIdMutationOptions,
  cf as getPatchApiV5MessagesIdMarkUnreadMutationOptions,
  My as getPatchApiV5MessagesIdMutationOptions,
  Jy as getPatchApiV5MessagesIdParticipantsMutationOptions,
  of as getPatchApiV5MessagesIdPinMutationOptions,
  af as getPatchApiV5MessagesThreadsThreadIdPinMutationOptions,
  Qf as getPostApiV5AccountAccountIdTaxReturnsZipPackageMutationOptions,
  Us as getPostApiV5AiMessagesDemoGenerateReplyMutationOptions,
  Es as getPostApiV5AiMessagesGenerateMutationOptions,
  bs as getPostApiV5AiMessagesGenerateReplyMutationOptions,
  Ms as getPostApiV5AuthCpaAuthorizationMutationOptions,
  Ni as getPostApiV5AuthCpaSwitcherMutationOptions,
  Ys as getPostApiV5AuthMagicLinksHandoffMutationOptions,
  js as getPostApiV5AuthMagicLinksMutationOptions,
  Xs as getPostApiV5AuthMfaMutationOptions,
  ei as getPostApiV5AuthMfaSetupsMutationOptions,
  di as getPostApiV5AuthPasskeysAuthenticationOptionsMutationOptions,
  mi as getPostApiV5AuthPasskeysMutationOptions,
  oi as getPostApiV5AuthPasskeysRegistrationOptionsMutationOptions,
  yi as getPostApiV5AuthPasskeysSignInMutationOptions,
  qi as getPostApiV5AuthPasswordResetTokensMutationOptions,
  Vi as getPostApiV5AuthPasswordResetsMutationOptions,
  wi as getPostApiV5AuthSelfSignupInvitationsValidateMutationOptions,
  ki as getPostApiV5AuthSelfSignupSsoMutationOptions,
  Ws as getPostApiV5AuthSignInMutationOptions,
  Ei as getPostApiV5AuthSignInSsoMutationOptions,
  bi as getPostApiV5AuthSignUpSsoMutationOptions,
  ao as getPostApiV5ClientsEsignAgreementsIdSigningUrlsMutationOptions,
  Go as getPostApiV5ClientsRfiDirectUploadsMutationOptions,
  Oo as getPostApiV5ClientsRfiRequestsRequestUuidAttachmentsMutationOptions,
  Bo as getPostApiV5ClientsRfiRequestsUuidSubmitMutationOptions,
  Yo as getPostApiV5DocumentsSignedUrlsMutationOptions,
  Rr as getPostApiV5FilesIdAcceptNamingSuggestionMutationOptions,
  _r as getPostApiV5FilesIdUndoAutoNameMutationOptions,
  mr as getPostApiV5FilesPreferredFormatMutationOptions,
  br as getPostApiV5FirmPainPointSelectionsMutationOptions,
  Qr as getPostApiV5FirmsAccountsMutationOptions,
  ca as getPostApiV5FirmsAppConnectionsDmsFileExportsMutationOptions,
  Ra as getPostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationMutationOptions,
  Ha as getPostApiV5FirmsBulkDocumentsArchiveMutationOptions,
  Xa as getPostApiV5FirmsBulkDocumentsDeleteMutationOptions,
  ou as getPostApiV5FirmsBulkDocumentsMarkAsReviewedMutationOptions,
  cu as getPostApiV5FirmsBulkDocumentsMoveMutationOptions,
  su as getPostApiV5FirmsBulkDocumentsRouteToSmartTaxMutationOptions,
  eu as getPostApiV5FirmsBulkDocumentsShareMutationOptions,
  Ya as getPostApiV5FirmsBulkDocumentsUnarchiveMutationOptions,
  au as getPostApiV5FirmsBulkDocumentsUpdateMetadataMutationOptions,
  pu as getPostApiV5FirmsContactsMutationOptions,
  Li as getPostApiV5FirmsCpaSwitcherMutationOptions,
  Uu as getPostApiV5FirmsCpaWorkflowTemplatesBulkMutationOptions,
  Bu as getPostApiV5FirmsCpaWorkflowTemplatesMutationOptions,
  Sm as getPostApiV5FirmsFoldersMutationOptions,
  gs as getPostApiV5FirmsPaymentEstimatesMutationOptions,
  Ia as getPostApiV5FirmsRequestsBulkUpdateMutationOptions,
  Wa as getPostApiV5FirmsRequestsIdArchiveMutationOptions,
  Ma as getPostApiV5FirmsRequestsIdCloseMutationOptions,
  Ua as getPostApiV5FirmsRequestsIdRecallMutationOptions,
  Qa as getPostApiV5FirmsRequestsIdReopenMutationOptions,
  ja as getPostApiV5FirmsRequestsIdZipMutationOptions,
  up as getPostApiV5FirmsRfiAdminDocumentsUuidRegenerateRequestMutationOptions,
  lp as getPostApiV5FirmsRfiAdminRequestsUuidApproveMutationOptions,
  _d as getPostApiV5FirmsRfiDirectUploadsMutationOptions,
  vd as getPostApiV5FirmsRfiDocumentsMutationOptions,
  Sd as getPostApiV5FirmsRfiDocumentsUuidRetryMutationOptions,
  Pp as getPostApiV5FirmsRfiRequestsBulkArchiveMutationOptions,
  Ep as getPostApiV5FirmsRfiRequestsBulkDeleteMutationOptions,
  bp as getPostApiV5FirmsRfiRequestsBulkRecallMutationOptions,
  Up as getPostApiV5FirmsRfiRequestsBulkSendMutationOptions,
  Bp as getPostApiV5FirmsRfiRequestsMutationOptions,
  hp as getPostApiV5FirmsRfiRequestsRequestUuidAttachmentsMutationOptions,
  Pd as getPostApiV5FirmsRfiRequestsRequestUuidMatchFilesLinksMutationOptions,
  Ed as getPostApiV5FirmsRfiRequestsRequestUuidMatchFilesPlacementsMutationOptions,
  Nd as getPostApiV5FirmsRfiRequestsRequestUuidRemindersMutationOptions,
  ad as getPostApiV5FirmsRfiRequestsUuidArchiveMutationOptions,
  Tp as getPostApiV5FirmsRfiRequestsUuidGruntworxExportMutationOptions,
  od as getPostApiV5FirmsRfiRequestsUuidRecallMutationOptions,
  pd as getPostApiV5FirmsRfiRequestsUuidReopenMutationOptions,
  ld as getPostApiV5FirmsRfiRequestsUuidResendMutationOptions,
  ed as getPostApiV5FirmsRfiRequestsUuidSendToClientMutationOptions,
  sd as getPostApiV5FirmsRfiRequestsUuidSubmitMutationOptions,
  cd as getPostApiV5FirmsRfiRequestsUuidUnarchiveMutationOptions,
  fd as getPostApiV5FirmsRfiRequestsUuidZipMutationOptions,
  jd as getPostApiV5FirmsRfiTemplatesMutationOptions,
  nl as getPostApiV5FirmsRfiTemplatesUuidCloneMutationOptions,
  Fl as getPostApiV5FirmsSampleClientMutationOptions,
  Cl as getPostApiV5FirmsServiceAliasesBulkConfirmMutationOptions,
  kl as getPostApiV5FirmsServiceAliasesIdConfirmMutationOptions,
  Dl as getPostApiV5FirmsServiceAliasesIdResetMutationOptions,
  Kl as getPostApiV5FirmsServiceAliasesMutationOptions,
  zl as getPostApiV5FirmsSmartVaultSyncRunsMutationOptions,
  Jl as getPostApiV5FirmsSmartVaultSyncRunsSyncAllMutationOptions,
  iy as getPostApiV5FirmsTagsMutationOptions,
  Ta as getPostApiV5FirmsWorkflowRequestsBulkDispatchMutationOptions,
  aa as getPostApiV5FirmsZapierExportsMutationOptions,
  nf as getPostApiV5MessagesBulkArchiveMutationOptions,
  pf as getPostApiV5MessagesDocumentsFromTemplatesMutationOptions,
  zy as getPostApiV5MessagesIdSendMutationOptions,
  ky as getPostApiV5MessagesMutationOptions,
  tf as getPostApiV5MessagesThreadsIdArchiveMutationOptions,
  gf as getPostApiV5OnboardingCompleteMutationOptions,
  Ff as getPostApiV5OnboardingSkipMutationOptions,
  ff as getPostApiV5OnboardingStartMutationOptions,
  kf as getPostApiV5RequestsRequestIdTaxReturnFormMutationOptions,
  jf as getPostApiV5TermsAndConditionsAcceptMutationOptions,
  eA as getPostApiV5UserJourneyStepsMutationOptions,
  vi as getPutApiV5AuthPasswordsMutationOptions,
  kr as getPutApiV5FilesIdMarkAsReviewedMutationOptions,
  wr as getPutApiV5FilesIdRenameMutationOptions,
  Er as getPutApiV5FilesIdUpdateTagsMutationOptions,
  Mu as getPutApiV5FirmsCpaWorkflowTemplatesBulkMutationOptions,
  zu as getPutApiV5FirmsCpaWorkflowTemplatesIdMutationOptions,
  ec as getPutApiV5FirmsDashboardWidgetPreferencesWidgetKeyMutationOptions,
  pc as getPutApiV5FirmsDocumentsDocumentUuidAnnotationMutationOptions,
  Ac as getPutApiV5FirmsDocumentsDocumentUuidRotationMutationOptions,
  rc as getPutApiV5FirmsFileNamingTemplatesIdMutationOptions,
  Fs as getPutApiV5FirmsPaymentEstimatesIdMutationOptions,
  Da as getPutApiV5FirmsRequestsIdMutationOptions,
  ry as getPutApiV5FirmsTagsUpdateSortOrderMutationOptions,
  Df as getPutApiV5RequestsRequestIdTaxReturnFormIdMutationOptions,
  DA as isLoginWithCodeMultiCpaResponse,
  SA as isLoginWithCodeSessionResponse,
  ct as makeDocumentsParams,
  pt as makeFileId,
  mt as makeFormDataForS3,
  XK as parseApiErrorMessage,
  tT as parseApiErrorType,
  zs as patchApiV5AuthMagicLinksId,
  ni as patchApiV5AuthMfaSetups,
  fi as patchApiV5AuthPasskeysId,
  Ri as patchApiV5AuthPasswordResetsResetToken,
  bo as patchApiV5ClientsRfiRequestsRequestUuidItems,
  ar as patchApiV5ExperiencesExperienceId,
  ea as patchApiV5FirmsAdminCpaSettingsKey,
  fu as patchApiV5FirmsContactsId,
  wc as patchApiV5FirmsDocumentsDocumentUuidAccount,
  Rc as patchApiV5FirmsDocumentsDocumentUuidMetadata,
  po as patchApiV5FirmsEsignAgreementSignatoriesId,
  Gc as patchApiV5FirmsFilesDocumentIdAccount,
  ym as patchApiV5FirmsFilesDocumentIdMetadata,
  Tm as patchApiV5FirmsFilesDocumentIdPlacement,
  Dm as patchApiV5FirmsFoldersFolderId,
  Qm as patchApiV5FirmsRequestsRequestIdSectionsSectionIdItemsItemIdResponse,
  op as patchApiV5FirmsRfiAdminDocumentsUuid,
  $p as patchApiV5FirmsRfiRequestsBulkUpdate,
  hd as patchApiV5FirmsRfiRequestsRequestUuidItems,
  Ad as patchApiV5FirmsRfiRequestsRequestUuidItemsBulkStatus,
  Ud as patchApiV5FirmsRfiRequestsRequestUuidMatchFilesDocumentId,
  Jp as patchApiV5FirmsRfiRequestsUuid,
  Yd as patchApiV5FirmsRfiTemplatesUuid,
  sl as patchApiV5FirmsRfiTemplatesUuidActivate,
  ol as patchApiV5FirmsRfiTemplatesUuidArchive,
  al as patchApiV5FirmsRfiTemplatesUuidUnarchive,
  Tl as patchApiV5FirmsServiceAliasesId,
  yo as patchApiV5FirmsSignersId,
  ay as patchApiV5FirmsTagsId,
  $y as patchApiV5MessagesId,
  uf as patchApiV5MessagesIdMarkUnread,
  Hy as patchApiV5MessagesIdParticipants,
  sf as patchApiV5MessagesIdPin,
  rf as patchApiV5MessagesThreadsThreadIdPin,
  Lf as postApiV5AccountAccountIdTaxReturnsZipPackage,
  xs as postApiV5AiMessagesDemoGenerateReply,
  Cs as postApiV5AiMessagesGenerate,
  Gs as postApiV5AiMessagesGenerateReply,
  $s as postApiV5AuthCpaAuthorization,
  Mi as postApiV5AuthCpaSwitcher,
  Bs as postApiV5AuthMagicLinks,
  Js as postApiV5AuthMagicLinksHandoff,
  YK as postApiV5AuthMagicLinksHandoffWithBearer,
  Zs as postApiV5AuthMfa,
  ti as postApiV5AuthMfaSetups,
  ci as postApiV5AuthPasskeys,
  pi as postApiV5AuthPasskeysAuthenticationOptions,
  ii as postApiV5AuthPasskeysRegistrationOptions,
  li as postApiV5AuthPasskeysSignIn,
  Fi as postApiV5AuthPasswordResetTokens,
  _i as postApiV5AuthPasswordResets,
  Ii as postApiV5AuthSelfSignupInvitationsValidate,
  Oi as postApiV5AuthSelfSignupSso,
  Ns as postApiV5AuthSignIn,
  Ci as postApiV5AuthSignInSso,
  Gi as postApiV5AuthSignUpSso,
  ro as postApiV5ClientsEsignAgreementsIdSigningUrls,
  Eo as postApiV5ClientsRfiDirectUploads,
  wo as postApiV5ClientsRfiRequestsRequestUuidAttachments,
  Qo as postApiV5ClientsRfiRequestsUuidSubmit,
  Jo as postApiV5DocumentsSignedUrls,
  Vr as postApiV5FilesIdAcceptNamingSuggestion,
  qr as postApiV5FilesIdUndoAutoName,
  cr as postApiV5FilesPreferredFormat,
  Gr as postApiV5FirmPainPointSelections,
  Lr as postApiV5FirmsAccounts,
  ua as postApiV5FirmsAppConnectionsDmsFileExports,
  Va as postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization,
  za as postApiV5FirmsBulkDocumentsArchive,
  Za as postApiV5FirmsBulkDocumentsDelete,
  iu as postApiV5FirmsBulkDocumentsMarkAsReviewed,
  uu as postApiV5FirmsBulkDocumentsMove,
  nu as postApiV5FirmsBulkDocumentsRouteToSmartTax,
  tu as postApiV5FirmsBulkDocumentsShare,
  Ja as postApiV5FirmsBulkDocumentsUnarchive,
  ru as postApiV5FirmsBulkDocumentsUpdateMetadata,
  mu as postApiV5FirmsContacts,
  Wi as postApiV5FirmsCpaSwitcher,
  Qu as postApiV5FirmsCpaWorkflowTemplates,
  xu as postApiV5FirmsCpaWorkflowTemplatesBulk,
  km as postApiV5FirmsFolders,
  As as postApiV5FirmsPaymentEstimates,
  va as postApiV5FirmsRequestsBulkUpdate,
  Na as postApiV5FirmsRequestsIdArchive,
  $a as postApiV5FirmsRequestsIdClose,
  xa as postApiV5FirmsRequestsIdRecall,
  La as postApiV5FirmsRequestsIdReopen,
  Ba as postApiV5FirmsRequestsIdZip,
  ap as postApiV5FirmsRfiAdminDocumentsUuidRegenerateRequest,
  dp as postApiV5FirmsRfiAdminRequestsUuidApprove,
  qd as postApiV5FirmsRfiDirectUploads,
  Td as postApiV5FirmsRfiDocuments,
  kd as postApiV5FirmsRfiDocumentsUuidRetry,
  Qp as postApiV5FirmsRfiRequests,
  Dp as postApiV5FirmsRfiRequestsBulkArchive,
  Cp as postApiV5FirmsRfiRequestsBulkDelete,
  Gp as postApiV5FirmsRfiRequestsBulkRecall,
  xp as postApiV5FirmsRfiRequestsBulkSend,
  gp as postApiV5FirmsRfiRequestsRequestUuidAttachments,
  Dd as postApiV5FirmsRfiRequestsRequestUuidMatchFilesLinks,
  Cd as postApiV5FirmsRfiRequestsRequestUuidMatchFilesPlacements,
  Md as postApiV5FirmsRfiRequestsRequestUuidReminders,
  rd as postApiV5FirmsRfiRequestsUuidArchive,
  Kp as postApiV5FirmsRfiRequestsUuidGruntworxExport,
  id as postApiV5FirmsRfiRequestsUuidRecall,
  md as postApiV5FirmsRfiRequestsUuidReopen,
  dd as postApiV5FirmsRfiRequestsUuidResend,
  td as postApiV5FirmsRfiRequestsUuidSendToClient,
  nd as postApiV5FirmsRfiRequestsUuidSubmit,
  ud as postApiV5FirmsRfiRequestsUuidUnarchive,
  yd as postApiV5FirmsRfiRequestsUuidZip,
  Bd as postApiV5FirmsRfiTemplates,
  el as postApiV5FirmsRfiTemplatesUuidClone,
  hl as postApiV5FirmsSampleClient,
  Rl as postApiV5FirmsServiceAliases,
  Pl as postApiV5FirmsServiceAliasesBulkConfirm,
  Ol as postApiV5FirmsServiceAliasesIdConfirm,
  Sl as postApiV5FirmsServiceAliasesIdReset,
  jl as postApiV5FirmsSmartVaultSyncRuns,
  Hl as postApiV5FirmsSmartVaultSyncRunsSyncAll,
  sy as postApiV5FirmsTags,
  Ka as postApiV5FirmsWorkflowRequestsBulkDispatch,
  ra as postApiV5FirmsZapierExports,
  Oy as postApiV5Messages,
  ef as postApiV5MessagesBulkArchive,
  mf as postApiV5MessagesDocumentsFromTemplates,
  jy as postApiV5MessagesIdSend,
  Xy as postApiV5MessagesThreadsIdArchive,
  Af as postApiV5OnboardingComplete,
  hf as postApiV5OnboardingSkip,
  yf as postApiV5OnboardingStart,
  Of as postApiV5RequestsRequestIdTaxReturnForm,
  Bf as postApiV5TermsAndConditionsAccept,
  tA as postApiV5UserJourneySteps,
  Ti as putApiV5AuthPasswords,
  Or as putApiV5FilesIdMarkAsReviewed,
  Ir as putApiV5FilesIdRename,
  Cr as putApiV5FilesIdUpdateTags,
  $u as putApiV5FirmsCpaWorkflowTemplatesBulk,
  ju as putApiV5FirmsCpaWorkflowTemplatesId,
  tc as putApiV5FirmsDashboardWidgetPreferencesWidgetKey,
  mc as putApiV5FirmsDocumentsDocumentUuidAnnotation,
  fc as putApiV5FirmsDocumentsDocumentUuidRotation,
  oc as putApiV5FirmsFileNamingTemplatesId,
  hs as putApiV5FirmsPaymentEstimatesId,
  Sa as putApiV5FirmsRequestsId,
  oy as putApiV5FirmsTagsUpdateSortOrder,
  Sf as putApiV5RequestsRequestIdTaxReturnFormId,
  tg as readyToSendMutationDocument,
  rg as reorderWorkflowItemsMutationDocument,
  kA as toMessageApiError,
  mg as todoFeedsQueryDocument,
  dg as updateFirmLicense,
  jA as updateResponseItemBoolDocument,
  HA as updateResponseItemDocUploadDocument,
  JA as updateResponseItemTextDocument,
  ug as updateWorkflowItem2MutationDocument,
  ig as updateWorkflowMutationDocument,
  zA as updateWorkflowRequestMutationDocument,
  Ug as useDeleteApiV5AuthPasskeysId,
  vg as useDeleteApiV5AuthSignOut,
  lh as useDeleteApiV5ClientsRfiAttachmentsId,
  DF as useDeleteApiV5FirmsCpaWorkflowTemplatesId,
  lq as useDeleteApiV5FirmsFoldersFolderId,
  Ag as useDeleteApiV5FirmsPaymentEstimatesId,
  sF as useDeleteApiV5FirmsRequestsId,
  Oq as useDeleteApiV5FirmsRfiAttachmentsId,
  Nq as useDeleteApiV5FirmsRfiRequestsUuid,
  l5 as useDeleteApiV5FirmsRfiTemplatesUuid,
  T5 as useDeleteApiV5FirmsServiceAliasesId,
  $5 as useDeleteApiV5FirmsTagsId,
  X5 as useDeleteApiV5MessagesId,
  n_ as useDeleteApiV5MessagesIdDiscard,
  c_ as useDeleteApiV5MessagesMessageIdDocumentsDocumentId,
  h_ as useDeleteApiV5RequestsRequestIdTaxReturnFormId,
  lg as useGetApiV5AccountsAccountIdPaymentEstimates,
  hg as useGetApiV5AccountsAccountIdScheduleK1s,
  Fg as useGetApiV5AccountsAccountIdTaxReturns,
  qg as useGetApiV5AccountsAccountIdTaxReturnsTaxReturnId,
  Cg as useGetApiV5AuthPasskeys,
  Bg as useGetApiV5AuthSessions,
  Zg as useGetApiV5ClientsContacts,
  Xg as useGetApiV5ClientsContactsGroupedByAccount,
  th as useGetApiV5ClientsContactsRecipientAccounts,
  eh as useGetApiV5ClientsEsignAgreementSignatoriesEsignAgreementSignatoryIdSigningStatus,
  nh as useGetApiV5ClientsEsignAgreementsIdSigningStatus,
  ih as useGetApiV5ClientsEsignAgreementsIdSigningUrls,
  ah as useGetApiV5ClientsRequestsRequestId,
  dh as useGetApiV5ClientsRfiAttachmentsId,
  Ah as useGetApiV5ClientsRfiRequests,
  mh as useGetApiV5ClientsRfiRequestsRequestUuidAttachments,
  gh as useGetApiV5ClientsRfiRequestsUuid,
  Fh as useGetApiV5ClientsRfiRequestsUuidToPdf,
  ch as useGetApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturn,
  uh as useGetApiV5ClientsWorkflowRequestsWorkflowRequestUuidTaxReturnTodos,
  Vh as useGetApiV5Experiences,
  Rh as useGetApiV5ExperiencesExperienceId,
  wh as useGetApiV5FilesIdNamingSuggestions,
  Sh as useGetApiV5FilesIdTagSuggestions,
  Ih as useGetApiV5FilesNamingConfig,
  Ch as useGetApiV5FilesPendingReview,
  vh as useGetApiV5FilesPreferredFormat,
  bh as useGetApiV5FirmPainPointSelections,
  xh as useGetApiV5FirmsAccounts,
  Mh as useGetApiV5FirmsAccountsAccountIdUnusedJurisdictions,
  $h as useGetApiV5FirmsAccountsId,
  Nh as useGetApiV5FirmsAdminCpaSettingsKey,
  Lh as useGetApiV5FirmsAdminZapierConfig,
  jh as useGetApiV5FirmsAppConnectionsDmsFileExportsStatus,
  zh as useGetApiV5FirmsAppConnectionsOauthAccessTokensId,
  Hh as useGetApiV5FirmsAppConnectionsSharepointExportSettings,
  Jh as useGetApiV5FirmsAppConnectionsSmartVaultAccessToken,
  qF as useGetApiV5FirmsContactsAccounts,
  _F as useGetApiV5FirmsContactsForAccounts,
  RF as useGetApiV5FirmsContactsGroupedByAccount,
  hF as useGetApiV5FirmsContactsId,
  vF as useGetApiV5FirmsContactsIdAccounts,
  KF as useGetApiV5FirmsContactsRecipientAccounts,
  TF as useGetApiV5FirmsContactsSearch,
  VF as useGetApiV5FirmsContactsSuggestions,
  OF as useGetApiV5FirmsCpaWorkflowTemplates,
  PF as useGetApiV5FirmsDashboardWidgetPreferences,
  MF as useGetApiV5FirmsDocumentsDocumentTypes,
  NF as useGetApiV5FirmsDocumentsDocumentUuid,
  LF as useGetApiV5FirmsDocumentsDocumentUuidAccountOptions,
  bF as useGetApiV5FirmsDocumentsDocumentUuidAnnotation,
  UF as useGetApiV5FirmsDocumentsDocumentUuidRotation,
  _h as useGetApiV5FirmsDocumentsLiscioVault,
  BF as useGetApiV5FirmsEmployees,
  EF as useGetApiV5FirmsFileNamingTemplates,
  JF as useGetApiV5FirmsFiles,
  YF as useGetApiV5FirmsFilesAccounts,
  XF as useGetApiV5FirmsFilesAccountsAccountIdTree,
  sq as useGetApiV5FirmsFilesDocumentId,
  jF as useGetApiV5FirmsFilesDocumentIdAccountOptions,
  uq as useGetApiV5FirmsFilesDocumentIdLocation,
  iq as useGetApiV5FirmsFilesDocumentIdShareRecipients,
  rq as useGetApiV5FirmsFilesDocumentTypes,
  ZF as useGetApiV5FirmsFilesFirmTree,
  nq as useGetApiV5FirmsFilesPosition,
  aq as useGetApiV5FirmsFilesRootDocuments,
  HF as useGetApiV5FirmsFilesSearch,
  tq as useGetApiV5FirmsFilesSharepointImportsUnreviewedCount,
  eq as useGetApiV5FirmsFilesUploaders,
  fq as useGetApiV5FirmsFolderViewAccountsAccountIdTree,
  Aq as useGetApiV5FirmsFolderViewAccountsAccountIdUnresolved,
  mq as useGetApiV5FirmsFolders,
  yq as useGetApiV5FirmsFoldersFolderIdDocuments,
  tF as useGetApiV5FirmsRequests,
  nF as useGetApiV5FirmsRequestsId,
  Fq as useGetApiV5FirmsRequestsRequestIdSections,
  hq as useGetApiV5FirmsRequestsRequestIdSectionsSectionIdItems,
  qq as useGetApiV5FirmsRfiAdminDocuments,
  Kq as useGetApiV5FirmsRfiAdminDocumentsNext,
  _q as useGetApiV5FirmsRfiAdminDocumentsUuid,
  wq as useGetApiV5FirmsRfiAttachmentsId,
  t5 as useGetApiV5FirmsRfiDocuments,
  n5 as useGetApiV5FirmsRfiDocumentsUuid,
  xq as useGetApiV5FirmsRfiRequests,
  vq as useGetApiV5FirmsRfiRequestsRequestUuidAttachments,
  r5 as useGetApiV5FirmsRfiRequestsRequestUuidMatchFiles,
  $q as useGetApiV5FirmsRfiRequestsUuid,
  Sq as useGetApiV5FirmsRfiRequestsUuidGruntworxExportStatus,
  Dq as useGetApiV5FirmsRfiRequestsUuidToPdf,
  c5 as useGetApiV5FirmsRfiTemplates,
  p5 as useGetApiV5FirmsRfiTemplatesUuid,
  h5 as useGetApiV5FirmsRpaDocuments,
  q5 as useGetApiV5FirmsRpaDocumentsId,
  F5 as useGetApiV5FirmsRpaDocumentsProcessingCount,
  V5 as useGetApiV5FirmsServiceAliases,
  O5 as useGetApiV5FirmsServiceAliasesSuggestions,
  S5 as useGetApiV5FirmsSmartVaultAccountsAccountIdImportedFolderTree,
  k5 as useGetApiV5FirmsSmartVaultAvailability,
  D5 as useGetApiV5FirmsSmartVaultSyncRuns,
  E5 as useGetApiV5FirmsSmartVaultSyncRunsId,
  G5 as useGetApiV5FirmsTags,
  W5 as useGetApiV5FirmsWorkflowTemplates,
  L5 as useGetApiV5FirmsWorkflowTemplatesId,
  M5 as useGetApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplates,
  N5 as useGetApiV5FirmsWorkflowTemplatesLiscioWorkflowTemplatesId,
  Q5 as useGetApiV5IntercomSettings,
  Hg as useGetApiV5Me,
  B5 as useGetApiV5Messages,
  z5 as useGetApiV5MessagesCounts,
  Z5 as useGetApiV5MessagesId,
  J5 as useGetApiV5MessagesTemplates,
  H5 as useGetApiV5MessagesThreadsThreadId,
  l_ as useGetApiV5PainPoints,
  y_ as useGetApiV5Profile,
  f_ as useGetApiV5RequestsRequestIdScheduleK1s,
  q_ as useGetApiV5RequestsRequestIdTaxReturn,
  F_ as useGetApiV5RequestsRequestIdTaxReturnTodos,
  K_ as useGetApiV5TermsAndConditions,
  T_ as useGetApiV5UserJourneySteps,
  gg as useGetApiV5WorkflowRequestsWorkflowRequestIdPaymentEstimates,
  __ as useGetApiV5WorkflowWorkflowRequestUuidToPdf,
  wg as usePatchApiV5AuthMagicLinksId,
  Dg as usePatchApiV5AuthMfaSetups,
  xg as usePatchApiV5AuthPasskeysId,
  Ng as usePatchApiV5AuthPasswordResetsResetToken,
  fh as usePatchApiV5ClientsRfiRequestsRequestUuidItems,
  Kh as usePatchApiV5ExperiencesExperienceId,
  Wh as usePatchApiV5FirmsAdminCpaSettingsKey,
  FF as usePatchApiV5FirmsContactsId,
  QF as usePatchApiV5FirmsDocumentsDocumentUuidAccount,
  WF as usePatchApiV5FirmsDocumentsDocumentUuidMetadata,
  oh as usePatchApiV5FirmsEsignAgreementSignatoriesId,
  zF as usePatchApiV5FirmsFilesDocumentIdAccount,
  oq as usePatchApiV5FirmsFilesDocumentIdMetadata,
  cq as usePatchApiV5FirmsFilesDocumentIdPlacement,
  dq as usePatchApiV5FirmsFoldersFolderId,
  gq as usePatchApiV5FirmsRequestsRequestIdSectionsSectionIdItemsItemIdResponse,
  Vq as usePatchApiV5FirmsRfiAdminDocumentsUuid,
  bq as usePatchApiV5FirmsRfiRequestsBulkUpdate,
  Zq as usePatchApiV5FirmsRfiRequestsRequestUuidItems,
  Yq as usePatchApiV5FirmsRfiRequestsRequestUuidItemsBulkStatus,
  a5 as usePatchApiV5FirmsRfiRequestsRequestUuidMatchFilesDocumentId,
  Mq as usePatchApiV5FirmsRfiRequestsUuid,
  d5 as usePatchApiV5FirmsRfiTemplatesUuid,
  f5 as usePatchApiV5FirmsRfiTemplatesUuidActivate,
  A5 as usePatchApiV5FirmsRfiTemplatesUuidArchive,
  g5 as usePatchApiV5FirmsRfiTemplatesUuidUnarchive,
  K5 as usePatchApiV5FirmsServiceAliasesId,
  rh as usePatchApiV5FirmsSignersId,
  U5 as usePatchApiV5FirmsTagsId,
  Y5 as usePatchApiV5MessagesId,
  a_ as usePatchApiV5MessagesIdMarkUnread,
  e_ as usePatchApiV5MessagesIdParticipants,
  o_ as usePatchApiV5MessagesIdPin,
  r_ as usePatchApiV5MessagesThreadsThreadIdPin,
  V_ as usePostApiV5AccountAccountIdTaxReturnsZipPackage,
  Rg as usePostApiV5AiMessagesDemoGenerateReply,
  _g as usePostApiV5AiMessagesGenerate,
  Vg as usePostApiV5AiMessagesGenerateReply,
  Kg as usePostApiV5AuthCpaAuthorization,
  Jg as usePostApiV5AuthCpaSwitcher,
  Ig as usePostApiV5AuthMagicLinks,
  Og as usePostApiV5AuthMagicLinksHandoff,
  kg as usePostApiV5AuthMfa,
  Sg as usePostApiV5AuthMfaSetups,
  Eg as usePostApiV5AuthPasskeys,
  Gg as usePostApiV5AuthPasskeysAuthenticationOptions,
  Pg as usePostApiV5AuthPasskeysRegistrationOptions,
  bg as usePostApiV5AuthPasskeysSignIn,
  $g as usePostApiV5AuthPasswordResetTokens,
  Mg as usePostApiV5AuthPasswordResets,
  Lg as usePostApiV5AuthSelfSignupInvitationsValidate,
  Qg as usePostApiV5AuthSelfSignupSso,
  Tg as usePostApiV5AuthSignIn,
  jg as usePostApiV5AuthSignInSso,
  zg as usePostApiV5AuthSignUpSso,
  sh as usePostApiV5ClientsEsignAgreementsIdSigningUrls,
  yh as usePostApiV5ClientsRfiDirectUploads,
  ph as usePostApiV5ClientsRfiRequestsRequestUuidAttachments,
  hh as usePostApiV5ClientsRfiRequestsUuidSubmit,
  qh as usePostApiV5DocumentsSignedUrls,
  kh as usePostApiV5FilesIdAcceptNamingSuggestion,
  Oh as usePostApiV5FilesIdUndoAutoName,
  Th as usePostApiV5FilesPreferredFormat,
  Gh as usePostApiV5FirmPainPointSelections,
  Uh as usePostApiV5FirmsAccounts,
  Bh as usePostApiV5FirmsAppConnectionsDmsFileExports,
  Yh as usePostApiV5FirmsAppConnectionsSmartVaultClientsSynchronization,
  cF as usePostApiV5FirmsBulkDocumentsArchive,
  pF as usePostApiV5FirmsBulkDocumentsDelete,
  yF as usePostApiV5FirmsBulkDocumentsMarkAsReviewed,
  AF as usePostApiV5FirmsBulkDocumentsMove,
  lF as usePostApiV5FirmsBulkDocumentsRouteToSmartTax,
  dF as usePostApiV5FirmsBulkDocumentsShare,
  mF as usePostApiV5FirmsBulkDocumentsUnarchive,
  fF as usePostApiV5FirmsBulkDocumentsUpdateMetadata,
  gF as usePostApiV5FirmsContacts,
  Yg as usePostApiV5FirmsCpaSwitcher,
  kF as usePostApiV5FirmsCpaWorkflowTemplates,
  IF as usePostApiV5FirmsCpaWorkflowTemplatesBulk,
  pq as usePostApiV5FirmsFolders,
  yg as usePostApiV5FirmsPaymentEstimates,
  Xh as usePostApiV5FirmsRequestsBulkUpdate,
  rF as usePostApiV5FirmsRequestsIdArchive,
  oF as usePostApiV5FirmsRequestsIdClose,
  iF as usePostApiV5FirmsRequestsIdRecall,
  aF as usePostApiV5FirmsRequestsIdReopen,
  uF as usePostApiV5FirmsRequestsIdZip,
  Rq as usePostApiV5FirmsRfiAdminDocumentsUuidRegenerateRequest,
  Tq as usePostApiV5FirmsRfiAdminRequestsUuidApprove,
  Xq as usePostApiV5FirmsRfiDirectUploads,
  e5 as usePostApiV5FirmsRfiDocuments,
  s5 as usePostApiV5FirmsRfiDocumentsUuidRetry,
  Uq as usePostApiV5FirmsRfiRequests,
  Pq as usePostApiV5FirmsRfiRequestsBulkArchive,
  Cq as usePostApiV5FirmsRfiRequestsBulkDelete,
  Eq as usePostApiV5FirmsRfiRequestsBulkRecall,
  Gq as usePostApiV5FirmsRfiRequestsBulkSend,
  Iq as usePostApiV5FirmsRfiRequestsRequestUuidAttachments,
  i5 as usePostApiV5FirmsRfiRequestsRequestUuidMatchFilesLinks,
  o5 as usePostApiV5FirmsRfiRequestsRequestUuidMatchFilesPlacements,
  u5 as usePostApiV5FirmsRfiRequestsRequestUuidReminders,
  Bq as usePostApiV5FirmsRfiRequestsUuidArchive,
  kq as usePostApiV5FirmsRfiRequestsUuidGruntworxExport,
  Qq as usePostApiV5FirmsRfiRequestsUuidRecall,
  zq as usePostApiV5FirmsRfiRequestsUuidReopen,
  Hq as usePostApiV5FirmsRfiRequestsUuidResend,
  Wq as usePostApiV5FirmsRfiRequestsUuidSendToClient,
  Lq as usePostApiV5FirmsRfiRequestsUuidSubmit,
  jq as usePostApiV5FirmsRfiRequestsUuidUnarchive,
  Jq as usePostApiV5FirmsRfiRequestsUuidZip,
  m5 as usePostApiV5FirmsRfiTemplates,
  y5 as usePostApiV5FirmsRfiTemplatesUuidClone,
  _5 as usePostApiV5FirmsSampleClient,
  R5 as usePostApiV5FirmsServiceAliases,
  w5 as usePostApiV5FirmsServiceAliasesBulkConfirm,
  v5 as usePostApiV5FirmsServiceAliasesIdConfirm,
  I5 as usePostApiV5FirmsServiceAliasesIdReset,
  P5 as usePostApiV5FirmsSmartVaultSyncRuns,
  C5 as usePostApiV5FirmsSmartVaultSyncRunsSyncAll,
  b5 as usePostApiV5FirmsTags,
  Zh as usePostApiV5FirmsWorkflowRequestsBulkDispatch,
  Qh as usePostApiV5FirmsZapierExports,
  j5 as usePostApiV5Messages,
  i_ as usePostApiV5MessagesBulkArchive,
  u_ as usePostApiV5MessagesDocumentsFromTemplates,
  t_ as usePostApiV5MessagesIdSend,
  s_ as usePostApiV5MessagesThreadsIdArchive,
  p_ as usePostApiV5OnboardingComplete,
  d_ as usePostApiV5OnboardingSkip,
  m_ as usePostApiV5OnboardingStart,
  A_ as usePostApiV5RequestsRequestIdTaxReturnForm,
  R_ as usePostApiV5TermsAndConditionsAccept,
  v_ as usePostApiV5UserJourneySteps,
  Wg as usePutApiV5AuthPasswords,
  Ph as usePutApiV5FilesIdMarkAsReviewed,
  Dh as usePutApiV5FilesIdRename,
  Eh as usePutApiV5FilesIdUpdateTags,
  wF as usePutApiV5FirmsCpaWorkflowTemplatesBulk,
  SF as usePutApiV5FirmsCpaWorkflowTemplatesId,
  CF as usePutApiV5FirmsDashboardWidgetPreferencesWidgetKey,
  xF as usePutApiV5FirmsDocumentsDocumentUuidAnnotation,
  $F as usePutApiV5FirmsDocumentsDocumentUuidRotation,
  GF as usePutApiV5FirmsFileNamingTemplatesId,
  fg as usePutApiV5FirmsPaymentEstimatesId,
  eF as usePutApiV5FirmsRequestsId,
  x5 as usePutApiV5FirmsTagsUpdateSortOrder,
  g_ as usePutApiV5RequestsRequestIdTaxReturnFormId,
  ZK as v3,
  YA as workflowRequestDocument,
  MA as workflowRequestItem,
  PA as workflowRequestsCountQueryDocument,
  ZA as workflowRequestsQueryDocument,
  XA as workflowTemplateFragment,
  ng as workflowTemplatesDocument,
  og as workflowsQueryDocument
};
